import { Component, OnInit, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, selectOperacionState, selectDetalleFacturaState, selectUtilsState } from 'app/store/app.states';
import { AsignarOperacion } from 'app/store/actions/operacion.actions';
import { BaseService } from 'app/services/base.service';
import { CoalService } from 'app/services/coal.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogComponent } from 'app/utilerias/confirm-dialog/confirm-dialog.component';
import { RelacionadosDialogComponent } from 'app/utilerias/relacionados-dialog/relacionados-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { Observable } from 'rxjs';
import { forkJoin } from 'rxjs';
import { ConfirmDialogOkComponent } from 'app/utilerias/confirm-dialog-ok/confirm-dialog-ok.component';
import { ConfirmDialogOpcionComponent } from 'app/utilerias/confirm-dialog-opcion/confirm-dialog-opcion.component';
import { filter } from 'rxjs/operators';
import { filters } from '../../../mock-api/apps/mailbox/data';
import { messages } from '../../../mock-api/apps/chat/data';
import { ComplementoPagoComponent } from '../utilsComprobantePago/complementoPago/complementoPago.component';
// import { Impuestos } from '../../../../../../backend/src/interfaces/interfaces';
import { map, startWith } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { ProductoAddComponent } from 'app/utilerias/producto-add/producto-add.component'

import { sparrowService } from 'app/services/sparrowService';
import { DialogNuevoClienteComponent } from 'app/utilerias/nuevo-cliente/dialog-nuevo-cliente.component';
import { CurrencyPipe } from '@angular/common';
import { ErrorFacturacionComponent } from '../error-facturacion/error-facturacion.component';
import { SuccessFacturacionComponent } from '../success-facturacion/success-facturacion.component';
import { SharedService } from 'app/shared.service';
import { VistaPreviaFacturaComponent } from '../vista-previa-factura/vista-previa-factura.component';
import { EstatusEmpresa, EstatusFolios, TipoDeComprobante } from 'app/shared/enum.shared';
import { FacturaService } from '../lista-facturas/factura.service';
import { environment } from 'environments/environment';
import Swal from 'sweetalert2';
import { DialogCfdiRelacionadosComponent } from '../dialog-cfdi-realcionados/dialog-cfdi-realcionados.component';
import { CustomAlertComponent } from 'app/utilerias/custom-alert/custom-alert.component';
import { ChangeDetectorRef } from '@angular/core';

interface Food {
    value: string;
    viewValue: string;
}
// interface ApiResponse {
//     data: {
//       attributes: {
//         data: {
//           id: number;
//         };
//       };
//     };
//   }
export interface State {
    flag: string;
    name: string;
    population: string;
}

const datosTabla1: any[] = [

];
@Component({
    selector: 'app-invoice',
    templateUrl: './invoice.component.html',
    styleUrls: ['./invoice.component.scss'],
    providers: [CurrencyPipe]
})

export class InvoiceComponent implements OnInit, OnDestroy {
    FacturaEdit = null;
    spinner = false;
    selectedProject: string = 'ACME Corp. Backend App';
    data: any;
    arregloClienteSeleccionado: any;
    idPadre: number = 0;
    curCatalogo: any;
    catalogoForm: FormGroup;
    agregarProductoForm: FormGroup;
    formModo: number = 1;
    tempEdit: any;
    lstCliente: any = [];
    lstProducto: any = [];
    mostrarComponenteCliente: boolean = false;
    facturaForm: FormGroup;
    facturaGlobalForm: FormGroup;
    productoSelecionados = [];
    productoSelecionadosEliminados = [];
    ltsMetodoPago: any[] = [];
    ltsMetodoPagoAux: any[] = [];
    ltsFormaPago: any = [];
    ltsMoneda: any = [];
    ltsFormaDescuento: any = [];
    /**
     * Id de MXN dentro del catálogo de monedas. El id NO es estable entre ambientes
     * (depende del orden en que se pobló c_Moneda), así que debe resolverse por clave.
     * Asumir un id fijo genera CFDIs con moneda equivocada y el PAC los rechaza con
     * "El campo TipoCambio se debe registrar cuando el campo Moneda tiene un valor
     * distinto de MXN y XXX".
     */
    private get idMonedaMXN(): any {
        return this.ltsMoneda?.find(option => option?.attributes?.clave === 'MXN')?.id ?? null;
    }
    ltsObjetoImpuesto: any[];
    sumatoriasTotales: any = [{ columna: 'Subtotal', sumatoria: 0 }, { columna: 'IVA', sumatoria: 0 }, { columna: 'IVARET', sumatoria: 0 }, { columna: 'IEPS', sumatoria: 0 }, { columna: 'ISR', sumatoria: 0 }, { columna: 'Total', sumatoria: 0 }];
    ltsLugarExpedicion: any = [];
    ltsSerie: any = [];
    lstTipoFactura: any = [];
    lstCfdiRelacionados: any = [];
    contenedorCfdiRelacionados: any[] = [];
    lstCuentaBancaria: any = [];
    lstObservaciones: any = [];
    contadorRelacionados = 0;
    desComplePago = false;
    desObservacion = false;
    seleccionaObservacion: any[];
    subscribeOperacion: any;
    getStateOperacion: Observable<any>;
    idOperacion: number;
    lstDataReport = [];
    dataReport = [];
    idTipoReporteSel: number = 1;
    objetoGridConfiguration: any = [];
    objetosSelected: any;
    verGrid = false;
    descuentoBloqueo: Number = 1;
    actulizarProducto = false;
    impuestos;
    precioUnitario;
    subtotal;
    total;
    valorProducto: number;
    verForm = false;
    procesandoFactura = false;
    getStateDetalleFactura: Observable<any>;
    subscribeDetalleFactura: any;
    banderaActualizarFactura = false;
    dataLlenarFormulario: any
    banderaEstatusFactura;
    listadoProductosEliminados = '';
    formComplementoporte = false;
    procesoPorte = false;
    @ViewChild('datosTabla1') datosTabla1: MatTable<any>;
    @ViewChild(ComplementoPagoComponent) complementoPago: ComplementoPagoComponent;
    foods: Food[] = [
        { value: 'steak-0', viewValue: 'Steak' },
        { value: 'pizza-1', viewValue: 'Pizza' },
        { value: 'tacos-2', viewValue: 'Tacos' },
    ];
    fechaEmisionValor: any;
    datosAdicionalesContador: number;
    datosAdicionales: boolean = false;
    displayedColumns: string[] = ['position', 'cantidad', 'claves', 'descripcion', 'precio', 'subtotal', 'descuento', 'impuestos', 'total'];
    facturaAdicionalesForm: FormGroup;
    dataActualizacion: any;
    curProducto: any;
    idFactura: any;
    selDetalle: any;
    getStateDetafactura: Observable<AppState>;
    ocultarBotonActualizar: boolean = false;
    Operacion: any;
    lugarExp: any;
    metodoPago: any;
    formaPago: any;
    cliente: any;
    codigoUnidadUpdate: string;
    ivaProdSelect: string;
    ivaRetProdSelect: string;
    isrProdSelect: string;
    valueIvaProdSelect: number;
    valueIvaRetProdSelect: number;
    valueIsrProdSelect: number;
    lastValueIvaProdSelect: number;
    lastValueIvaRetProdSelect: number;
    lastValueIsrProdSelect: number;
    totalImpuestos: number;
    seleccionTipoFactura: boolean = false;
    rulesByCrud: any = [0];
    disabledMetodoPago: boolean = false;
    timbrar: boolean = false;
    folios;
    /**
     * RULES VARIABLES
     */
    cantidadRule: any = {};
    claveProdServRule: any = {};
    claveUnidadRule: any = {};
    clienteRule: any = {};
    condicionesPagoRule: any;
    confirmacionRule: any = {};
    cuentaBancoRule: any = {};
    descripcionRule: any = {};
    descuentoRule: any = {};
    fechaEmisionRule: any = {};
    formaPagoRule: any = {};
    importeRule: any = {};
    lugarExpedicionRule: any = {};
    metodoPagoRule: any = {};
    monedaRule: any = {};
    noIdentificacionRule: any = {};
    nombreBancoRule: any = {};
    numeroCuentaRule: any = {};
    numeroPedidoRule: any = {};
    seleccionaObservacionRule: any = {};
    seleccioneCuentaBancoRule: any = {};
    subTotalRule: any = {};
    tipoCambioRule: any = {};
    tipoRelacionRule: any = {};
    totalRule: any = {};
    unidadRule: any = {};
    uuidRule: any = {};
    valorUnitarioRule: any = {};

    /**COMPLEMENTO PAGO */
    fechaPagoRule: any = {};
    horaPagoRule: any = {};
    montoPagoRule: any = {};
    numeroOperacionRule: any = {};
    rfcCuentaOrdenanteRule: any = {};
    cuentaOrdenanteRule: any = {};
    nombreBancoComplementoRule: any = {};
    rfcCuentaBeneficiarioRule: any = {};
    cuentabeneficiarioRule: any = {};

    /**DOCS RELACIONADOS */
    facturaOriginalRule: any = {};
    montoOriginalRule: any = {};
    noParcialidadRule: any = {};
    serieRule: any = {};
    folioRule: any = {};
    objetoImpuestoRule: any = {};
    metodoPagoDocsRelRule: any = {};
    importeSaldoAnterirorRule: any = {};
    importePagadoRule: any = {};
    saldoInsolutoRule: any = {};

    /**Impuestos */
    impuestoComplementoRule: any = {};
    baseComplementoRule: any = {};
    tasaComplementoRule: any = {};
    totalComplementoRule: any = {};

    /**
     * RULES VARIABLES
     */
    allCfdiEncontrados: any;
    complementoPagoTemplate: boolean = false;
    idFacturaForComplemento: number = 0;

    /**VARIABLES PARA OBTENER EL TOTAL DE PAGOS */
    allDataPago: any = [];
    lblTipoFactura: any;
    tipoFactura: any;
    SerieFolio: string;
    spinnerSerie: boolean = false;

    // Control de autocomplete productos
    stateCtrl = new FormControl('');
    filteredStates: Observable<State[]>;
    //Variables vista previa
    emisor;
    reseptor;
    pagosListprev;
    docsrelListprev
    //
    valueIEPSProdSelect: number = 0;
    lastValueIEPSProdSelect: number;
    IEPSProdSelect: string;
    descuento: number = 0;

    dataReports: any;
    impuestosLocales: { id?: number, nombre: string; tasa: number; monto: number; tipo: number; importeImpuesto: number; }[] = [];
    impuestosLocalesTotal: { id?: number, nombre: string; tasa: number; monto: number; tipo: number; importeImpuesto: number; }[] = [];
    ImpuestosTotalesProducto: number = 0;
    subtotalProducto: any;
    idTipoFactura: any;
    NuevoProducto: number;
    //PREVIAS
    subtotal_total;
    emisorRSocial: any;
    emisorCP: any;
    emisorCPRule: any = {};
    emisorRSocialRule: any = {};

    formeviando;
    dataproductos;
    serieFlag: boolean = false;

    curProductoCatalogo: any;
    valueIEPSProdSelectCuota: number;
    lastValueIEPSProdSelectCuota: number = 0;
    IEPSProdSelectCuota: string;
    sumatoriaDescuento: number = 0;
    sumatoriaSinDescuento: number = 0;
    lstCuentaPredial: any[] = [];
    adicionalesProducto: boolean;

    idEmpresa: number;
    logoEmpresa: string;
    folio: number;
    actualizarFact: any;
    numPagos: any;
    showCfdiManual: boolean = false;
    lstExportacion: any;
    datosevent: any;
    idCfdiRel: any[];
    periodicidadFactGlobal: any[];
    mesFactGlobal: any;
    tipo: any;
    statusCompany: number;
    respFacturaSave: any = {};

    filteredMonedas: Observable<any>;

    clienteControl = new FormControl();
    filteredClientes: any[] = [];
    configured: boolean = null;
    EditFac_Factura: any;

    constructor(
        private readonly store: Store<AppState>,
        private fb: FormBuilder,
        private baseService: BaseService,
        private coalService: CoalService,
        private router: Router,
        public dialog: MatDialog,
        private _snackBar: MatSnackBar,
        private srvcoal: CoalService,
        private sparroService: sparrowService,
        private cp: CurrencyPipe,
        private sharedService: SharedService,
        private facturaService: FacturaService,
        private route: ActivatedRoute,
        private cdr: ChangeDetectorRef,
        private _router: Router,
        
    ) {

        this.route.paramMap.subscribe(params => {
            this.tipo = params.get('tipo');
        });

        this.formProducto()
        this.formDatosAdicionales();
        this.getStateDetalleFactura = this.store.select(selectDetalleFacturaState);
        this.subscribeDetalleFactura = this.getStateDetalleFactura.subscribe((detalleFactura) => {
            this.banderaActualizarFactura = detalleFactura.params === null ? false : true;
            this.dataLlenarFormulario = detalleFactura.params === null ? null : detalleFactura?.params[0];
            this.banderaEstatusFactura = detalleFactura.params === null ? null : detalleFactura?.params[0].idEstatusFactura;
            if (this.banderaActualizarFactura && Object.keys(this.respFacturaSave).length !== 0) {
                this.CambioEmpresa()
            }


        });
        this.store.select(selectUtilsState).subscribe((state: any) => {
            if (state.empresaSeleccionada === undefined) {
				this.configured = false;
				throw new Error('Empresa no configurada. Proceso interrumpido.');
			}
			else {
				this.configured = true;
				if (this.idEmpresa !== state.empresaSeleccionada.id) {
                    console.log("empresaCambio", state.empresaSeleccionada)
                    this.idEmpresa = state.empresaSeleccionada.id;
                    this.logoEmpresa = environment.hostBack + state.empresaSeleccionada?.attributes.logo?.data?.attributes.url;
                    this.statusCompany = state?.empresaSeleccionada?.attributes?.ope_empresa_estatus_hs?.data[0]?.attributes?.ope_empresa_estatus?.data?.id;
                    this.CambioEmpresa()
                }
			}
        });



    }
    ngOnDestroy(): void {
        this.baseService.postDetalleFactura(null);
        localStorage.removeItem("duplicar")
    }

    ngOnInit(): void {
        this.getCompanyStatuses();
        this.getFolios();
        //autocomplete moneda
        //let moneda= this.ltsMoneda.find(option => option.id== 1);
        //console.log("🚀 ~ ngOnInit ~ moneda:", moneda)
        this.facturaAdicionalesForm.controls.moneda.setValue(null);
        this.filteredMonedas = this.facturaAdicionalesForm.controls.moneda.valueChanges.pipe(
            startWith(''),
            map(value => {
                const name = typeof value === 'string' ? value : value?.name;
                return name ? this._filterMoneda(name as string) : this.ltsMoneda.slice();
            }),
        );

        // Inicialización del filtrado, mostrando todos los clientes por defecto
        this.filteredClientes = this.lstCliente;

        // Opcional: Puedes inicializar un valor por defecto si ya está establecido en el formulario
        if (this.facturaForm.controls.cliente.value) {
            this.clienteControl.setValue(this.facturaForm.controls.cliente.value);
        }
    };

    getFolios() {
        this.store.dispatch(MostrarSpinner());
        this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_empresa_paquetes.ope_empresa_paquete_hs.cat_paquete_estatus`)
            .subscribe((res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.folios = res.data[0]?.attributes?.ope_empresa_paquetes?.data;
                this.validateFolios();
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                error?.error?.error?.status === 400 ?
                    this._snackBar.open(
                        error?.error?.error?.message,
                        'OK',
                        { duration: 5000 }
                    ) :
                    this._snackBar.open(
                        'Algo salió mal. Por favor, vuelva a intentarlo.',
                        'OK',
                        { duration: 5000 }
                    );
            });
    }

    validateFolios() {
        let folios = this.folios;
        let activeFolios = folios.filter(function (paquete) {
            return this.indexOf(paquete?.attributes?.ope_empresa_paquete_hs?.data[0]?.attributes?.cat_paquete_estatus?.data?.id) < 0;
        }, [EstatusFolios.Cancelado, EstatusFolios.SolicitudEnviada]);
        let total = activeFolios.map(item => item.attributes?.folios).reduce((a, b) => a + b, 0);
        let usados = activeFolios.map(item => item.attributes?.usado).reduce((a, b) => a + b, 0);
        if (usados >= total) {
            this.router.navigate(['/cuenta/paquetes']);
        }
    }

    getCompanyStatuses() {
        this.store.dispatch(MostrarSpinner());
        this.coalService.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_direccion_empresas`)
            .subscribe((res: any) => {
                let place = res.data[0]?.attributes?.ope_direccion_empresas?.data;
                // if( this.statusCompany == EstatusEmpresa.Prerregistro || this.statusCompany == EstatusEmpresa.RegistroCompleto || place == undefined || place?.length == 0 ) {
                //     Swal.fire({
                //         title: '¡Casi Listo Para Facturar!',
                //         text: 'Estás a solo un paso de comenzar a facturar. Finaliza la configuración de tu cuenta para desbloquear todas las herramientas de facturación y comenzar a gestionar tus transacciones con facilidad.',
                //         confirmButtonText: 'Aceptar'
                //     }).then((result) => {
                //         if (result.isConfirmed) {
                //             if (this.statusCompany == EstatusEmpresa.Prerregistro)
                //                 this.router.navigate(['/cuenta/perfil'], {queryParams: {key: 'account'}});
                //             else if (this.statusCompany == EstatusEmpresa.RegistroCompleto)
                //                 this.router.navigate(['/cuenta/perfil'], {queryParams: {key: 'stamp'}});
                //             else if (place == undefined || place?.length == 0)
                //                 this.router.navigate(['/cuenta/perfil'], {queryParams: {key: 'place'}});
                //         }
                //     })
                // }
                this.store.dispatch(OcultarSpinner());
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
            })
    }

    CambioEmpresa() {
        // console.log("dentro de metofo",this.dataLlenarFormulario.tipoFactura)
        if (this.banderaActualizarFactura) {
            this.seleccionTipoFactura = true;
            if (this.dataLlenarFormulario.tipoFactura === 3) {
                this.getDataMetodoPago();
            };
        };
        this.setOperacion();
        this.getData();
        this.datosAdicionalesContador = 0;
        this.datosAdicionales = false;
        this.data = [
            {
                id: '2bfa2be5-7688-48d5-b5ac-dc0d9ac97f14',
                avatar: 'assets/images/custom/company.jpg',
                name: 'COAL Solutions SA de CV',
                about: 'CARF800723PF1'
            },
            {
                id: '77a4383b-b5a5-4943-bc46-04c3431d1566',
                avatar: 'assets/images/custom/company.jpg',
                name: 'Auto-mas SA de CV',
                about: 'AALL6907225D6'
            }
        ];
        this.formAgregarProducto();
        this.formFacturaGlobal()
        this.GetCatalogoFacturacion();
        if (this.banderaActualizarFactura) {
            this.banderaEstatusFactura = this.dataLlenarFormulario.idEstatusFactura;
            var valueDuplicar = localStorage.getItem('duplicar') ? localStorage.getItem('duplicar') : 0;
            if (this.banderaEstatusFactura === 2 && Number(valueDuplicar) === 1) {
                console.log("solo entro duplicar")
                this.ocultarBotonActualizar = true;
                this.SerieFolio = this.dataLlenarFormulario.serie + '-' + this.dataLlenarFormulario.folio;
            }
            if (this.dataLlenarFormulario.aplicaProductos) {
                this.GetSelProductoFacturacion();
            }
        } else {
            this.ObjectGrid();
        };

        this.facturaForm.valueChanges.subscribe(changes => {
            // Realiza las acciones necesarias con los cambios en los campos del formulario
            this.sharedService.enviarValoresFormulariofacturaForm(changes);
        });
        this.facturaAdicionalesForm.valueChanges.subscribe(changes => {
            // Realiza las acciones necesarias con los cambios en los campos del formulario
            this.sharedService.enviarValoresFormulariofacturaAdicionalesForm(changes);
        });

        this.sharedService.trasladoPor$.subscribe((valores: any) => {
            try {
                if (valores == 1) {
                    this.formaPagoRule.disabled = true;
                    this.metodoPagoRule.disabled = true;
                }
                else {
                    this.formaPagoRule.disabled = false;
                    this.metodoPagoRule.disabled = false;
                }

            } catch (error) {

            }

        });

        // Init
        this.initCuentaPredial();
    }

    private isString = value => typeof value === 'string' || value instanceof String;

    private _filterStates(value: any): State[] {
        console.log("value darien test: ", value);
        const filterValue = this.isString(value) ? value.toLowerCase() : value.toString();
        return this.lstProducto.filter(state => state.attributes.descripcion.toLowerCase().includes(filterValue));
    }

    displayFn(Producto: any): string {
        return Producto && Producto.nombreInterno ? Producto.nombreInterno : '';
    };

    formatPesos(floatValue: any) {
        //const formato = new Intl.NumberFormat('es-MX', { maximumFractionDigits: 2 });
        //return formato.format( valor );

        // let decimals = 2;
        // let multiplier = 1;
        // let floatMultiplied = floatValue * multiplier;
        // let stringFloat = floatMultiplied + "";
        // let arraySplitFloat = stringFloat.split(".");
        // let decimalsValue = "0";
        // if (arraySplitFloat.length > 1) {
        //     decimalsValue = arraySplitFloat[1].slice(0, decimals);
        // }
        // let integerValue = arraySplitFloat[0];
        // let arrayFullStringValue = [integerValue, decimalsValue];
        // let FullStringValue = arrayFullStringValue.join(".")
        // let floatFullValue = parseFloat(FullStringValue) + "";
        // let formatFloatFullValue = new Intl.NumberFormat('es-ES', { minimumFractionDigits: decimals }).format(floatFullValue);
        // return formatFloatFullValue;
    }

    changeSerie(value: any) {
        var aux = this.ltsSerie.filter(x => x.id === value);
        // console.log(aux);
        this.SerieFolio = aux[0].attributes.nombre + '-00000';
        const idSerie = aux[0].id
        this.folio = aux[0].attributes.folio
        this.srvcoal.getService(`fac-facturas?populate[ope_direccion_serie][populate]= *
        &filters[ope_empresa][id][$eq]=${this.idEmpresa}
        &filters[ope_direccion_serie][id][$eq]=${idSerie}`,)
            .subscribe((res: any) => {
                if (res.err) {
                    console.log("erro *************** 1")
                } else if (res.excepcion) {
                    console.log("erro *************** 2")
                } else {
                    console.log('data report', res.data)
                    if (res.data.length > 0) {
                        this.folio = res.data.reduce((max, obj) => obj.attributes.folio > max ? obj.attributes.folio : max, 0);
                        this.folio = this.folio + 1
                    }
                }
            }, (error: any) => {
                console.log("erro *************** 3", error)
            });


    }

    delComplementos() {
        const data = {
            idFactura: this.dataLlenarFormulario.idFactura
        };
        this.coalService.postService(`catalogo/DELComplemento`, data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                this.InsertarDatosComplemento();
            };
        }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            this.store.dispatch(OcultarSpinner());
            this.spinner = false;
        });
    }

    llenarFormularioForm() {
        console.log("luis aqui te qeudaste", this.dataLlenarFormulario)
        // this.changeTipoFactura(3);
        this.sharedService.enviarValoresFormulariofacturaForm(this.dataLlenarFormulario);
        this.changeTipoFactura(this.dataLlenarFormulario.tipoFactura);
        console.log("this.dataLlenarFormulario", this.dataLlenarFormulario)
        // this.facturaForm.controls.cliente.setValue(this.dataLlenarFormulario.cliente);
        if (this.dataLlenarFormulario.cliente ?? false) {
            // this.clienteControl.setValue(this.dataLlenarFormulario.cliente);

            this.curCliente(this.dataLlenarFormulario.cliente);
        }else{
                // if(this.EditFac_Factura.attributes.cli_cliente.data.id ?? false){
                //     this.clienteControl.setValue(this.EditFac_Factura.attributes.cli_cliente.data);
                // }
        }

        this.facturaForm.controls.tipoFactura.setValue(this.dataLlenarFormulario.tipoFactura);
        this.facturaForm.controls.lugarExpedicion.setValue(this.dataLlenarFormulario.lugarExpedicion);
        this.facturaForm.controls.emisorRSocial.setValue(this.dataLlenarFormulario.idEmpresa)
        this.facturaForm.controls.emisorCP.setValue(this.dataLlenarFormulario.lugarExpedicionCP)
        // this.serieFlag = this.dataLlenarFormulario.idSerie ? true:false;
        this.facturaForm.controls.serie.setValue(this.dataLlenarFormulario.idSerie);

        this.facturaForm.controls.formaPago.setValue(this.dataLlenarFormulario.idFormaPago);
        if (Number(this.dataLlenarFormulario.formaPago) === 99) {
            this.disabledMetodoPago = true;
        };
        this.facturaForm.controls.metodoPago.setValue(this.dataLlenarFormulario.metodoPago);


        //datos adicionales encabezado
        if (this.dataLlenarFormulario.moneda === this.idMonedaMXN) {
            this.facturaAdicionalesForm.controls.tipoCambio.setValue(1);
            this.facturaAdicionalesForm.controls.tipoCambio.disable();
        } else {
            this.facturaAdicionalesForm.controls.tipoCambio.setValue(this.dataLlenarFormulario.tipoCambio);
        }
        this.facturaAdicionalesForm.controls.numeroPedido.setValue(this.dataLlenarFormulario.numeroPedido);
        let moneda = this.ltsMoneda.find(option => option.id == this.dataLlenarFormulario.moneda);
        this.facturaAdicionalesForm.controls.moneda.setValue(moneda);

        this.facturaAdicionalesForm.controls.fechaEmision.setValue(this.dataLlenarFormulario.idFechaEmision);
        this.facturaAdicionalesForm.controls.numerodeCuenta.setValue(this.dataLlenarFormulario.numeroCuenta);
        this.facturaAdicionalesForm.controls.nombreBanco.setValue(this.dataLlenarFormulario.nombreBanco);
        // this.facturaAdicionalesForm.controls.seleccionaObservacion.setValue(this.dataLlenarFormulario.observacion );
        this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(this.dataLlenarFormulario.CFDIRelacionados ? this.dataLlenarFormulario.CFDIRelacionados.id : null);
        this.facturaAdicionalesForm.controls.seleccioneCuentaBanco.setValue(this.dataLlenarFormulario.cuentaBanco);
        this.facturaAdicionalesForm.controls.seleccioneExportacion.setValue(this.dataLlenarFormulario.cat_exportacion.id),// ? this.dataLlenarFormulario.seleccioneExportacion.id:1);
            this.facturaAdicionalesForm.controls.confirmacion.setValue(this.dataLlenarFormulario.confirmacion ? this.dataLlenarFormulario.confirmacion : '');
        //

        this.facturaAdicionalesForm.controls.condicionesPago.setValue(this.dataLlenarFormulario.condicionesPago);

        if (this.dataLlenarFormulario.observacion !== null) {
            this.desObservacion = true;
            this.facturaAdicionalesForm.controls.observaciones.setValue(this.dataLlenarFormulario.observacion);
            this.facturaAdicionalesForm.controls.seleccionaObservacion.setValue(this.dataLlenarFormulario.observaciones === null ? 1 : this.dataLlenarFormulario.observaciones);
        } else {
            this.desObservacion = false;
            this.facturaAdicionalesForm.controls.seleccionaObservacion.setValue(0);
            this.facturaAdicionalesForm.controls.observaciones.reset();
        };


        // this.emisorCP = this.Operacion.CP

        //
        // this.facturaForm.controls.emisorCP.setValue( this.Operacion.CP )

        // setTimeout(() => {
        //     this.curCliente(this.dataLlenarFormulario.cliente);
        // }, 5000);

        this.DatosAdicionales();
        this.dataLlenarFormulario.fac_factura_doc_relacionados.length !== 0 ? this.GetCFDIRelacionados() : null;


        // this.curMetodoPago(this.dataLlenarFormulario.metodoPago);
        //this.curFormaPagoPV(this.dataLlenarFormulario.formaPago);
        if (this.dataLlenarFormulario.tipoFactura === 5) {
            this.facturaGlobalForm.controls.periodicidad.setValue(this.dataLlenarFormulario.cat_global_periodicidad.data.id);
            this.seleccionarPeriodicidad(this.dataLlenarFormulario.cat_global_periodicidad.data.id);
            this.facturaGlobalForm.controls.anioFactGlobal.setValue(this.dataLlenarFormulario.catGlobalAnio);

        }

        // console.log("Llenar formulario Listo!", this.dataLlenarFormulario.tipo_factura);
        this.lblTipoFactura = this.dataLlenarFormulario.tipo_factura;

        // this.store.dispatch(OcultarSpinner());
        // // this.store.dispatch(MostrarSpinner());
        // setTimeout(() => {
        //     this.store.dispatch(OcultarSpinner());
        // }, 2000);
    };

    getDataMetodoPago = () => {
        const data = {
            idFactura: this.dataLlenarFormulario.idFactura
        };
        this.coalService.getService(`fac-facturas/${this.dataLlenarFormulario.idFactura}?fields[0]=folio&populate[cli_cliente]=*&populate[fac_complemento_pagos][populate]=cat_moneda,cat_forma_pago,fac_factura_doc_relacionados&populate[fac_complemento_pagos][populate]=fac_com_pago_documentos.cat_moneda,fac_com_pago_documentos.cat_objeto_impuesto,fac_com_pago_documentos.cat_metodo_pago&populate[fac_complemento_pagos][populate]=fac_com_pago_documentos.cat_moneda,fac_com_pago_documentos.cat_objeto_impuesto,fac_com_pago_documentos.cat_metodo_pago,fac_com_pago_documentos.fac_com_pago_doc_imps,fac_com_pago_documentos.fac_com_pago_doc_imps.cat_impuesto,cli-cliente`).subscribe((res: any) => {
            // this.coalService.postService(`catalogo/selDataComplementoPago`, data).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else {
                this.allDataPago = res.data.attributes.fac_complemento_pagos.data

                this.EditFac_Factura = res.data;
                // this.facturaForm.controls.cliente.setValue(res.data.attributes.cli_cliente.data.id);

                // this.facturaForm.controls.cliente.patchValue(res.data.attributes.cli_cliente.data.id);

                // this.curCliente(res.data.attributes.cli_cliente.data.id);
                
                //;
                
                // let uiids = res.data.attributes.fac_complemento_pagos.data[0].attributes.fac_com_pago_documentos.data
                // this.GetCFDIRelacionados_(uiids)
                // console.log("allPagos", this.allDataPago)
            };
        }, (error: any) => {
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
            //this.store.dispatch(OcultarSpinner());
        });
    };

    GetCFDIRelacionados() {
        this.showCfdiManual = true
        this.dataLlenarFormulario.fac_factura_doc_relacionados.forEach(relacion => {
            this.agregarRelacionadoData(relacion.attributes.uuid);
        });
        //         this.GetSelProductoFacturacion();
    };
   
    GetCFDIRelacionados_(fac_factura_doc_relacionados) {
        this.showCfdiManual = true
        //;
        fac_factura_doc_relacionados.forEach(relacion => {
            this.agregarRelacionadoData(relacion.attributes.uuid);
        });
        //         this.GetSelProductoFacturacion();
    };

    agregarRelacionadoData = data => {
        //;
        const body = {
            cfdiRelacionados: data
        };
        this.contenedorCfdiRelacionados.push(body);
        console.log('this.contenedorCfdiRelacionados ', this.contenedorCfdiRelacionados);
    };

    GetSelProductoFacturacion() {
        console.log("get productos")
        this.store.dispatch(MostrarSpinner());
        // this.coalService.getService(`catalogo/GetSelProductoFacturacion?idFactura=${this.dataLlenarFormulario.idFactura}`,).subscribe((res: any) => {
        this.srvcoal.getService(`fac-facturas?filters[id][$eq]=${this.dataLlenarFormulario.idFactura}&fields[0]=folio&populate[fac_factura_productos][populate][pro_producto][populate]=*&populate[fac_factura_productos][populate][cat_forma_descuento][populate]=*&populate[fac_factura_productos][populate][fac_factura_prod_imps][populate]=*&populate[fac_factura_productos][populate][fac_factura_imp_locales][populate][pro_impuesto_local][populate]=*`,).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(OcultarSpinner());
            } else {
                console.log("productosFacturaa", res.data)
                this.agregarProductosToGridUPD(res.data[0].attributes.fac_factura_productos.data != null ? res.data[0].attributes.fac_factura_productos.data : [])



                this.store.dispatch(OcultarSpinner());
            }
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
        });
    }
    getPeriodicidad() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`cat-global-periodicidads`,).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(OcultarSpinner());
            } else {
                this.periodicidadFactGlobal = res.data
                this.store.dispatch(OcultarSpinner());
            }
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
        });
    }
    seleccionarPeriodicidad(e) {
        console.log("periodicidad", e)
        if (e !== 0) {
            console.log("Si hay seleccion")
            // this.periodicidadFactGlobal.find(x => x.id === e).attributes.clave == "05"
            const esBimestre = e === 5 ? true : false;
            this.store.dispatch(MostrarSpinner());
            this.srvcoal.getService(`cat-global-meses?filters[esBimestre]=${esBimestre}`,).subscribe((res: any) => {
                if (res.err) {
                    this.store.dispatch(OcultarSpinner());
                } else {
                    console.log("productosFacturaa", res.data)
                    this.mesFactGlobal = res.data
                    if (this.banderaActualizarFactura) {
                        this.facturaGlobalForm.controls.mesFactGlobal.setValue(this.dataLlenarFormulario.cat_global_me.data ? this.dataLlenarFormulario.cat_global_me.data.id : null);
                    }
                    this.store.dispatch(OcultarSpinner());
                }
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
            });
        }
    }

    agregarProductosToGridUPD(dataProductos) {
        dataProductos.forEach(producto => {
            const productoServicioValue = producto.attributes.pro_producto.data.id;
            const cantidadValue = producto.attributes.cantidad;
            const formaDescuentaValue = producto.attributes.cat_forma_descuento.data ? producto.attributes.cat_forma_descuento.data.id : 0//producto.attributes.formaDescuento;
            let descuentoValue: any = producto.attributes.descuento;

            const precioUnitarioValue = producto.attributes.precioUnitario;
            const descripcionPorductoValue = producto.attributes.nombre;

            const descuento = formaDescuentaValue === 1 ? 0 : descuentoValue;
            const subTotal = (cantidadValue * precioUnitarioValue);
            // const totalSinDescuento = subTotal + producto.attributes.montoImpuestosTotal;
            // const total = formaDescuentaValue === 1 ? totalSinDescuento : totalSinDescuento - (totalSinDescuento * (descuento / 100));
            // const total = (cantidadValue * precioUnitarioValue) - descuento;//producto.attributes.total;
            console.log("tot", this.total)
            // const nombreFormaDescuento = producto.attributes.nombreFormaDescuento;
            const clave = [producto.attributes.pro_producto.data.attributes.cat_unidad.data.attributes.clave + ' - ' + producto.attributes.pro_producto.data.attributes.cat_unidad.data.attributes.nombre]

            const impuestosLocales = [];

            let impLoc = producto.attributes.fac_factura_imp_locales?.data ?? [];
            let totalImpuestosLocales = 0;
            impLoc.forEach(fac_imp => {
                let local = fac_imp.attributes;
                let imp = local.pro_impuesto_local.data;
                let element = imp.attributes;
                let tipo_impuesto = element.cat_tipo_impuesto.data;
                let importeImpuesto = 0;

                if (element.monto == 0 || element.monto === undefined || element.monto === null || element.monto == "") {
                    if (element.tasa > 0) { importeImpuesto = subTotal * element.tasa; }
                    else { importeImpuesto = 0; }
                }
                else { importeImpuesto = element.monto; }

                totalImpuestosLocales += importeImpuesto;
                impuestosLocales.push({
                    id: imp.id,
                    nombre: element.nombre,
                    tasa: element.tasa,
                    monto: element.monto,
                    tipo: tipo_impuesto.id,
                    importeImpuesto: importeImpuesto
                });
            });

            const total = (cantidadValue * precioUnitarioValue) - descuento + (totalImpuestosLocales);//producto.attributes.total;

            const body = {
                id: producto.id,
                idProductoFac: this.productoSelecionados.length + 1,
                idProducto: productoServicioValue,
                cantidad: cantidadValue === 0 ? 1 : cantidadValue,
                descripcion: descripcionPorductoValue,
                precio: precioUnitarioValue,
                subTotal: subTotal,
                total: total,
                descuento: descuento,
                claves: clave,

                // impuestos: [producto.attributes.valorIEPS, producto.attributes.valorISR, producto.attributes.valorIva, producto.attributes.valorIvaRet].filter(impuesto => impuesto != null),
                // nombreFormaDescuento: nombreFormaDescuento,
                formaDescuento: formaDescuentaValue,
                // montoImpuestosTotal: producto.attributes.montoImpuestosTotal,


                valIva: producto.attributes.pro_producto.data.attributes.cat_iva.data ? producto.attributes.pro_producto.data.attributes.cat_iva.data.attributes.valor : 0,
                valIvaRet: producto.attributes.pro_producto.data.attributes.cat_iva_ret.data ? producto.attributes.pro_producto.data.attributes.cat_iva_ret.data.attributes.valor : 0,
                valIEPS: producto.attributes.pro_producto.data.attributes.cat_iep.data ? producto.attributes.pro_producto.data.attributes.cat_iep.data.attributes.valor : 0,
                valISR: producto.attributes.pro_producto.data.attributes.cat_isr.data ? producto.attributes.pro_producto.data.attributes.cat_isr.data.attributes.valor : 0,

                // valIva: producto.attributes.pro_producto.data.attributes.cat_iva.data ? producto.attributes.pro_producto.data.attributes.cat_iva.data.attributes : null,
                // valIvaRet: producto.attributes.pro_producto.data.attributes.cat_iva_ret.data ? producto.attributes.pro_producto.data.attributes.cat_iva_ret.data.attributes : null,
                // valIEPS: producto.attributes.pro_producto.data.attributes.cat_iep.data ? producto.attributes.pro_producto.data.attributes.cat_iep.data.attributes : null,
                // valISR: producto.attributes.pro_producto.data.attributes.cat_isr.data ? producto.attributes.pro_producto.data.attributes.cat_isr.data.attributes : null,

                // iva: producto.attributes.iva,
                // ivaRet: producto.attributes.ivaRet,
                // ISR: producto.attributes.ISR,

                IEPSTasaCat: producto.attributes.pro_producto.data.attributes.cat_iep.data ? producto.attributes.pro_producto.data.attributes.cat_iep.data.attributes.valor : 0,
                IEPSTasa: producto.attributes.pro_producto.data.attributes.esTasa,
                IEPSCuota: producto.attributes.pro_producto.data.attributes.esTasa ? false : true,
                IEPSCuotaCuot: producto.attributes.pro_producto.data ? producto.attributes.pro_producto.data.attributes.cuotaIeps : 0,

                // IEPSTasaCat: (this.lstProducto[index].attributes.cat_iep.data) ? this.lstProducto[index].attributes.cat_iep.data.attributes.valor : 0,
                // IEPSTasa: this.lstProducto[index].attributes.esTasa,
                // IEPSCuota: this.lstProducto[index].attributes.esTasa ? false : true,
                // IEPSCuotaCuot: this.lstProducto[index].attributes.cuotaIeps,

                existeRegistrado: 0,
                //ImpuestosLocalesProducto: producto.attributes.ImpuestosLocales,
                //ObjetoImpuesto: producto.attributes.ObjetoImpuesto,
                //lblObjetoImpuesto: producto.attributes.lblObjetoImpuesto,
                //claveSat: producto.attributes.claveSat,
                //codigoUnidad: producto.attributes.codigoUnidad,
                //Unidad: producto.attributes.Unidad,
                //cuentaPredial: producto.attributes.cuentaPredial,

                ImpuestosLocales: impuestosLocales
            };

            // Calulamos Impuestos Federales
            let traslados = (body.subTotal * body.valIva) + (body.subTotal * body.valIEPS)
            let retenciones = (body.subTotal * body.valIvaRet) + (body.subTotal * body.valISR)
            body.total = body.total + traslados - retenciones;

            this.productoSelecionados.push(body);
        });

        this.sumarTotales();
        this.ObjectGrid();
        this.agregarProductoForm.reset();
        this.stateCtrl.setValue('');
        this.verForm = false;
    };

    ObjectGrid() {
        let that = this;
        this.objetoGridConfiguration = {
            GridOptions: {
                paginacion: 20,
                pageSize: [
                    '40',
                    '60',
                    '80',
                    '100'
                ]
            },
            ExportExcel: { enabled: false, fileName: 'Historico' },
            ColumnHiding: { hide: true },
            Checkbox: { checkboxmode: 'none' },
            Editing: { allowupdate: true, mode: 'cell' },
            Columnchooser: { columnchooser: true },
            SearchPanel: { visible: true, width: 200, placeholder: 'Buscar...', filterRow: true },
            Scroll: { mode: 'infinite' },
            Color: null,
            Detail: { detail: true },
            ToolbarDetail: null,
            ToolBox: [
            ],
            Columns: [],
            Data: [],
            Columns1: [1],
            Data1: [],
            datosMessage(evento) {
                that.objetosSelected = evento.data;
            }
        };
        this.DataColumnsGrid();
    };
    datosMessage($event) {
        try {
            console.log("soy", $event.data[0])
            this.datosevent = $event.data[0];
        } catch (error) {
            // this.Excepciones(error, 1);
        }
    }
    DataColumnsGrid() {
        if (!this.lstDataReport.find(x => x.idTipoReporte === this.idTipoReporteSel)) {
            let columnsMulti = [];
            columnsMulti.push({
                caption: 'Acciones',
                dataField: 'accion',
                allowEditing: false,
                cellTemplate: 'templateBotones'
            });
            columnsMulti.push({
                caption: 'Cantidad',
                dataField: 'cantidad',
                allowEditing: false,
                fixed: true,
            });
            columnsMulti.push({
                caption: 'Unidad',
                dataField: 'claves',
                allowEditing: false,
                fixed: true,
            });
            // columnsMulti.push({
            //     caption: 'Claves',
            //     dataField: 'claves',
            //     allowEditing: false
            // });
            columnsMulti.push({
                caption: 'Concepto',
                dataField: 'descripcion',
                allowEditing: false
            });
            columnsMulti.push({
                caption: 'Precio Unitario',
                dataField: 'precio',
                allowEditing: false,
                format: '$#,##0.00'
            });
            columnsMulti.push({
                caption: 'SubTotal',
                dataField: 'subTotal',
                allowEditing: false,
                format: '$#,##0.00'
            });
            columnsMulti.push({
                caption: 'Descuento',
                dataField: 'descuento',
                allowEditing: false,
                format: '$#,##0.00'
            });
            // columnsMulti.push({
            //     caption: 'Forma de descuento',
            //     dataField: 'nombreFormaDescuento',
            //     allowEditing: false,
            // });
            // columnsMulti.push({
            //     caption: 'Impuestos',
            //     dataField: 'impuestos',
            //     allowEditing: false,
            // });
            columnsMulti.push({
                caption: 'Total',
                dataField: 'total',
                allowEditing: false,
                format: '$#,##0.00'
            });

            setTimeout(() => this.lstDataReport.push({
                idTipoReporte: this.idTipoReporteSel,
                columnas: columnsMulti,
                dataReport: this.productoSelecionados,
                identificadorGrid: 0
            }), 500);
            setTimeout(() => this.FillGrid(), 800);
        } else {
            this.FillGrid();
        }
    }

    FillGrid() {
        this.objetoGridConfiguration.Columns = this.lstDataReport.find(x => x.idTipoReporte === this.idTipoReporteSel && x.identificadorGrid === 0).columnas;
        this.objetoGridConfiguration.Data = this.lstDataReport.find(x => x.idTipoReporte === this.idTipoReporteSel && x.identificadorGrid === 0).dataReport;
        this.dataproductos = this.objetoGridConfiguration.Data;
        this.verGrid = true;
        this.spinner = false;
        // this.store.dispatch(OcultarSpinner())
    }

    formDatosAdicionales() {
        this.facturaAdicionalesForm = this.fb.group({
            numeroPedido: new FormControl(),
            moneda: new FormControl(1),
            tipoCambio: new FormControl(1),
            fechaEmision: new FormControl(),
            numerodeCuenta: new FormControl(),
            nombreBanco: new FormControl(),
            condicionesPago: new FormControl(),
            seleccionaObservacion: new FormControl(0),
            cFDIRelacionado: new FormControl(),
            seleccioneCuentaBanco: new FormControl(),
            observaciones: new FormControl(),
            folioManual: new FormControl(),
            confirmacion: new FormControl(''),
            seleccioneExportacion: new FormControl(Validators.required),
        })
        //// console.log(this.fechaEmisionValor[0].value)
    }

    formAgregarProducto() {
        this.agregarProductoForm = this.fb.group({
            productoServicio: new FormControl('', Validators.required),
            formaDescuento: new FormControl(0, Validators.required),
            descuento: new FormControl(0, [Validators.required, Validators.min(0)]),
            cantidad: new FormControl(1, [Validators.required, Validators.min(1)]),
            precioUnitario: new FormControl(),
            subTotal: new FormControl(),
            total: new FormControl(),
            descripcionProducto: new FormControl('', Validators.required)
        })
        this.agregarProductoForm.controls.subTotal.disable();
        this.agregarProductoForm.controls.total.disable();
    }

    formFacturaGlobal() {
        this.facturaGlobalForm = this.fb.group({
            periodicidad: new FormControl(0, Validators.required),
            mesFactGlobal: new FormControl(0, Validators.required),
            anioFactGlobal: new FormControl(0, Validators.required),
        })
        // this.agregarProductoForm.controls.subTotal.disable();
        // this.agregarProductoForm.controls.total.disable();
    }

    InsertarDatos() {
        if (this.procesoPorte) {
            //Insertar carta porte
            this.sharedService.acciones(0);
        } else {
            const validacion = this.validaDatos();
            if (!validacion.success) {
                this._snackBar.open(validacion.msg, 'ok', { duration: 3000, });
            } else {
                this.procesandoFactura = true;
                let contadorErrores = 0;
                let validador;
                this.contenedorCfdiRelacionados.forEach(x => {
                    validador = this.isUUID(x.cfdiRelacionados);
                    if (!validador) {
                        contadorErrores++;
                    }
                });
                if (contadorErrores > 0) {
                    this.procesandoFactura = false;
                    return this._snackBar.open('Favor de introducir UUID válido', 'OK', { duration: 3000 });
                };

                const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Está seguro de crear esta factura?' });
                dialogRef.afterClosed().subscribe(result => {
                    if (result) {
                        this.spinner = true;
                        let xmlRelacionados = '<propiedades>';
                        this.contenedorCfdiRelacionados.forEach(x => {
                            xmlRelacionados += `<propiedad><relacionado>${x.cfdiRelacionados}</relacionado></propiedad>`;
                        });
                        xmlRelacionados += '</propiedades>';
                        let xmlProducto = '<propiedades>';
                        this.productoSelecionados.forEach(x => {
                            xmlProducto += `<propiedad><idProducto>${x.idProducto}</idProducto><cantidad>${x.cantidad}</cantidad><subTotal>${x.subTotal}</subTotal><total>${parseFloat(x.total)}</total><descuento>${x.descuento}</descuento><formaDescuento>${x.formaDescuento}</formaDescuento><precioUnitario>${x.precio}</precioUnitario><descripcion>${x.descripcion}</descripcion><cuentaPredial>${x.cuentaPredial}</cuentaPredial></propiedad>`;
                        });
                        xmlProducto += '</propiedades>';

                        // impuestosLocalesTotal: { nombre: string; tasa: number; monto: number; tipo: number; importeImpuesto: number; }[] = [];
                        let xmlImpuestosLocales = '<propiedades>';
                        this.impuestosLocalesTotal.forEach(x => {
                            xmlImpuestosLocales += `<propiedad><nombre>${x.nombre}</nombre><tasa>${x.tasa}</tasa><monto>${x.monto}</monto><tipo>${x.tipo}</tipo><importeImpuesto>${x.importeImpuesto}</importeImpuesto></propiedad>`;
                        });
                        xmlImpuestosLocales += '</propiedades>';

                        var datosCliente = this.facturaForm.value;
                        var datosClienteAdicionales = this.facturaAdicionalesForm.value;
                        this.idFacturaForComplemento = 0;

                        const body = {
                            cliente: datosCliente.cliente,
                            tipoFactura: datosCliente.tipoFactura,
                            lugarExpedicion: datosCliente.lugarExpedicion,
                            formaPago: datosCliente.formaPago,
                            serie: datosCliente.serie,
                            metodoPago: datosCliente.metodoPago,
                            numeroPedido: datosClienteAdicionales.numeroPedido,
                            moneda: datosClienteAdicionales.moneda,
                            tipoCambio: datosClienteAdicionales.tipoCambio,
                            fechaEmision: datosClienteAdicionales.fechaEmision,
                            numeroCuenta: datosClienteAdicionales.numerodeCuenta,
                            nombreBanco: datosClienteAdicionales.nombreBanco,
                            condicionesPago: datosClienteAdicionales.condicionesPago,
                            observacion: datosClienteAdicionales.seleccionaObservacion === 0 ? null : datosClienteAdicionales.seleccionaObservacion,
                            CFDIRelacionados: datosClienteAdicionales.cFDIRelacionado === 0 ? null : datosClienteAdicionales.cFDIRelacionado,
                            cuentaBanco: datosClienteAdicionales.seleccioneCuentaBanco,
                            observaciones: datosClienteAdicionales.observaciones,
                            idRol: 2,
                            idOperacion: this.idOperacion,
                            xmlRelacionados: xmlRelacionados,
                            xmlProducto: xmlProducto,

                            // Totales
                            importeSubtotal: this.sumatoriasTotales[0]?.sumatoria,
                            importeDescuento: 0,
                            importeIVA: this.sumatoriasTotales[1]?.sumatoria,
                            importeIVARet: this.sumatoriasTotales[2]?.sumatoria,
                            importeIEPS: this.sumatoriasTotales[3]?.sumatoria,
                            importeISR: this.sumatoriasTotales[4]?.sumatoria,
                            importeTotal: this.sumatoriasTotales[5]?.sumatoria,
                            importeLocales: 0,
                            impuestosLocales: xmlImpuestosLocales
                        };

                        this._snackBar.open('No se salga de la página o interrumpa el proceso, se está generando la factura y él timbrando de la misma ante el SAT.', 'ok', { duration: 6000 });
                        this.store.dispatch(MostrarSpinner());
                        this.srvcoal.postService(`catalogo/PostINSFactura`, body).subscribe((res: any) => {
                            if (res.error) {
                                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                            } else if (res.excepcion) {
                                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
                            } else {
                                if (res.recordsets[0][0].success === 1 || res.recordsets[0][0].success === 2) {
                                    this.facturaAdicionalesForm.reset();
                                    this.facturaForm.reset();
                                    this.contenedorCfdiRelacionados.length = 0;
                                    this.productoSelecionados.length = 0;
                                };
                                this.procesandoFactura = false;
                                var datafact = {
                                    tipofactura: datosCliente.tipoFactura,
                                    clave: res.recordsets[0][0].idFactura
                                }
                                if (res.recordsets[0][0].success === 1) {
                                    this.store.dispatch(OcultarSpinner());

                                    var datafact = {
                                        tipofactura: datosCliente.tipoFactura,
                                        clave: res.recordsets[0][0].idFactura
                                    }
                                    console.log('datafact ', datafact);
                                    this.openSuccess(res.recordsets[0][0], datafact);
                                    localStorage.setItem('enviarCorreoFactura', JSON.stringify(res.recordsets[0][0]));

                                    console.log('PostINSFactura - Success 1')
                                } else {
                                    console.log('PostINSFactura - Error 1')
                                    if (datosCliente.tipoFactura === 3) {
                                        console.log('PostINSFactura - Error 1.1')
                                        this.idFacturaForComplemento = res.recordsets[0][0].idFactura;
                                        this.InsertarDatosComplemento();
                                    } else {
                                        console.log('PostINSFactura - Error 1.2')
                                        this.store.dispatch(OcultarSpinner());
                                        this.openError(res.recordsets[0][0]);

                                    };
                                };
                            };

                        }, (error: any) => {
                            this.store.dispatch(OcultarSpinner());
                            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                        });
                    } else {
                        this._snackBar.open('Registro cancelado', 'OK', { duration: 3000 });
                        this.procesandoFactura = false;
                        this.spinner = false;
                    };
                });
            };
        }

    };

    cancelarFactura() {
        if (this.facturaForm.controls['tipoFactura'].value == 0) {
            this.router.navigateByUrl('/factura/facturas/0/0/0/0/0/0/0/0');
        }
        else {
            const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea cerrar sin guardar este registro?' });
            dialogRef.afterClosed().subscribe(result => {
                // console.log(result)
                if (result) {
                    localStorage.removeItem("duplicar")
                    this.router.navigateByUrl('/factura/facturas/0/0/0/0/0/0/0/0');
                }
                // if (result) {

                // }
            });
        }

    }

    openError(error) {
        this.banderaActualizarFactura = true;
        this.dataLlenarFormulario = {
            idFactura: error.idFactura
        }

        this.banderaEstatusFactura = 1;
        localStorage.removeItem("duplicar")
        this.ocultarBotonActualizar = false;


        const dialogRef = this.dialog.open(ErrorFacturacionComponent, {
            width: '60%',
            data: { error: error }
        });

        dialogRef.afterClosed().subscribe(result => {

        });
    }

    openSuccess(respuesta, data) {
        const dialogRef = this.dialog.open(SuccessFacturacionComponent, {
            width: '60%',
            data: { error: respuesta, data: data }
        });

        dialogRef.afterClosed().subscribe(result => {
            this.router.navigateByUrl('/factura/facturas/0/0/0/0/0/0/0/0');
        });
    }

    // # región Acualiar
    actualizarFactura(val) {
        // console.clear();

        console.log("Entered actulizarFactura() method");
        console.log("tipo fact", this.facturaForm.value.tipoFactura);

        this.actualizarFact = val
        console.log(this.procesoPorte);
        if (this.procesoPorte) {
            this.sharedService.acciones(4);
        } else {
            const validacion = this.validaDatos();
            console.log("Validación resultado:", validacion);
            if (!validacion.success) {
                this._snackBar.open(validacion.msg, 'ok', { duration: 3000, });
            } else {
                this.procesandoFactura = true;
                let contadorErrores = 0;
                let validador;
                this.contenedorCfdiRelacionados.forEach(x => {
                    validador = this.isUUID(x.cfdiRelacionados);
                    if (!validador) {
                        contadorErrores++;
                    }
                });

                //;
                console.log("this.contenedorCfdiRelacionados antes de contadorErrores:", this.contenedorCfdiRelacionados);
                console.log("contadorErrores inicial:", contadorErrores);
                if (contadorErrores > 0) {
                    this.procesandoFactura = false;
                    return this._snackBar.open('Favor de introducir UUID válido', 'OK', { duration: 3000 });
                };

                console.log("Preparando forkJoin con contenedorCfdiRelacionados");
                const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea actualizar este registro?' });
                dialogRef.afterClosed().subscribe(async result => {
                    if (result) {
                        let idCfdiRel = []
                        const observables = this.contenedorCfdiRelacionados.map(x => this.cfdiSave(x.cfdiRelacionados));
                        forkJoin(observables).subscribe(
                            (ids: any[]) => {
                                // Aquí ids es un array con los resultados de todas las observables
                                console.log("IDs obtenidos de CfdiSave:", ids);
                                idCfdiRel = ids
    
                            },
                            (error: any) => {
                                // Manejar errores en las solicitudes individuales
                                console.error('Error en una o más solicitudes individuales:', error);
                                this.store.dispatch(OcultarSpinner());
                            },
                            () => {
                                var datosCliente = this.facturaForm.value;
                                var datosClienteAdicionales = this.facturaAdicionalesForm.value;
                                let idFacturaUpdate = this.dataLlenarFormulario.idFactura ?? this.idFacturaForComplemento  ;
                                let tipoFacturaUpdate = datosCliente.tipoFactura;
                                var idFactura = this.dataLlenarFormulario?.idFactura ?? this.idFacturaForComplemento ;

                                // let tipoFacturaUpdate = datosCliente.tipoFactura;
                                ///************** */
                                const body = {
                                    folio: this.folio,
                                    fechaEmision: new Date(),
                                    ope_direccion_empresa: datosCliente.lugarExpedicion,
                                    cat_tipo_comprobante: datosCliente.tipoFactura,
                                    ope_direccion_serie: datosCliente.serie,
                                    cli_cliente: datosCliente.cliente,
                                    fac_estatus: 1,
                                    cat_metodo_pago: datosCliente.metodoPago,
                                    cat_forma_pago: datosCliente.formaPago,
                                    numeroPedido: datosClienteAdicionales.numeroPedido,
                                    tipoCambio: datosClienteAdicionales.tipoCambio,
                                    cat_moneda: datosClienteAdicionales.moneda ? datosClienteAdicionales.moneda : this.idMonedaMXN,
                                    nombreBanco: datosClienteAdicionales.nombreBanco,
                                    condicionesPago: datosClienteAdicionales.condicionesPago,
                                    observacion: datosClienteAdicionales.seleccionaObservacion == 0 ? null : datosClienteAdicionales.observaciones,
                                    cat_cfdi_relaciondo: datosClienteAdicionales.cFDIRelacionado === 0 ? null : datosClienteAdicionales.cFDIRelacionado,
                                    //ope_cuenta: 12,
                                    ope_empresa_observacion: (datosClienteAdicionales.seleccionaObservacion == 0 || datosClienteAdicionales.seleccionaObservacion == 1) ? null : datosClienteAdicionales.seleccionaObservacion,
                                    fac_factura_estatus_hs: [1],
                                    ope_empresa: this.idEmpresa,
                                    ope_empresa_banco: datosCliente.seleccioneCuentaBanco,
                                    cat_fecha_emision: datosClienteAdicionales.fechaEmision,
                                    numeroCuentaPago: datosClienteAdicionales.numerodeCuenta,
                                    fac_factura_doc_relacionados: idCfdiRel.length !== 0 ? idCfdiRel : null,
                                    cat_exportacion: datosClienteAdicionales.seleccioneExportacion,
                                    confirmacion: datosClienteAdicionales.confirmacion,
                                    subtotal: Number(this.sumatoriaSinDescuento ? this.sumatoriaSinDescuento : 0),
                                    descuento: Number(this.sumatoriaDescuento != 0 ? this.sumatoriaDescuento : 0),
                                    total: Number(this.sumatoriasTotales[5]?.sumatoria ? this.sumatoriasTotales[5]?.sumatoria : 0),
                                    cat_global_periodicidad: datosCliente.tipoFactura === 5 ? this.facturaGlobalForm.value.periodicidad : null,
                                    cat_global_me: datosCliente.tipoFactura === 5 ? this.facturaGlobalForm.value.mesFactGlobal : null,
                                    catGlobalAnio: datosCliente.tipoFactura === 5 ? Number(this.facturaGlobalForm.value.anioFactGlobal) : null
                                };
                                // console.log("p seleccionados : " , xmlRelacionados);
                                this.store.dispatch(MostrarSpinner());
                                this.srvcoal.putService(`fac-facturas/${idFactura}`, { data: body }).subscribe(async (res: any) => {
                                    if (res.err) {
                                        this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                                    } else {
                                        console.log("res", res)


                                        this.contenedorCfdiRelacionados.length = 0;

                                        var datafact = {
                                            tipofactura: datosCliente.tipoFactura,
                                            clave: idFactura //res.recordsets[0][0].idFactura
                                        }
                                        //****************** FACTURA Y NOTA DE CREDITO ****************

                                        //Soy complemento de pago
                                        this.idFacturaForComplemento = idFactura;
                                        if (datosCliente.tipoFactura === 3) {
                                            console.log("complemento de pago")

                                            const response = await this.deleteFacComPagoDocumento(this.EditFac_Factura.attributes.fac_complemento_pagos.data ?? []);
                                            console.log('Eliminación exitosa:', response);

                                            this.InsertarDatosComplemento();
                                        } else if (datosCliente.tipoFactura === 4) {
                                            console.log("CARTA PORTE")
                                            //AQUI VA FUNCIÒN PARA INSERTAR DATA CARTA PORTE
                                            this.actualizarProductos_(datafact);
                                            this.sharedService.acciones(1);
                                        }
                                        else {
                                            console.log("Otro")
                                            this.actualizarProductos_(datafact);
                                        }
                                    };

                                }, (error: any) => {
                                    this.store.dispatch(OcultarSpinner());
                                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                                },
                                    () => {
                                        // Código que se ejecuta después de que todas las solicitudes se completen
                                        console.log('Todas las solicitudes completadas');
                                    }
                                )
                            })
                    } else {
                        this.procesandoFactura = false;
                        this._snackBar.open('Registro cancelado', 'OK', { duration: 3000 });
                        this.spinner = false;
                    };
                });
            };
        }
    };

    actualizarFacturaTimbrar() {
        console.log(this.procesoPorte);
        if (this.procesoPorte) {
            this.sharedService.acciones(4);
        } else {
            const validacion = this.validaDatos();
            if (!validacion.success) {
                this._snackBar.open(validacion.msg, 'ok', { duration: 3000, });
            } else {
                this.procesandoFactura = true;
                let contadorErrores = 0;
                let validador;
                this.contenedorCfdiRelacionados.forEach(x => {
                    validador = this.isUUID(x.cfdiRelacionados);
                    if (!validador) {
                        contadorErrores++;
                    }
                });
                if (contadorErrores > 0) {
                    this.procesandoFactura = false;
                    return this._snackBar.open('Favor de introducir UUID válido', 'OK', { duration: 3000 });
                };

                const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea actualizar este registro?' });
                dialogRef.afterClosed().subscribe(async result => {
                    if (result) {
                        this.spinner = true;
                        let xmlRelacionados = '<propiedades>';
                        this.contenedorCfdiRelacionados.forEach(x => {
                            xmlRelacionados += `<propiedad><relacionado>${x.cfdiRelacionados}</relacionado></propiedad>`;
                        });
                        xmlRelacionados += '</propiedades>';
                        let xmlProducto = '<propiedades>';
                        this.productoSelecionados.forEach(x => {
                            xmlProducto += `<propiedad><idProducto>${x.idProducto}</idProducto><cantidad>${x.cantidad}</cantidad><subTotal>${x.subTotal}</subTotal><total>${parseFloat(x.total)}</total><descuento>${x.descuento}</descuento><formaDescuento>${x.formaDescuento}</formaDescuento><precioUnitario>${x.precio}</precioUnitario><descripcion>${x.descripcion}</descripcion><cuentaPredial>${x.cuentaPredial}</cuentaPredial></propiedad>`;
                        });
                        xmlProducto += '</propiedades>';

                        // impuestosLocalesTotal: { nombre: string; tasa: number; monto: number; tipo: number; importeImpuesto: number; }[] = [];
                        let xmlImpuestosLocales = '<propiedades>';
                        this.impuestosLocalesTotal.forEach(x => {
                            xmlImpuestosLocales += `<propiedad><nombre>${x.nombre}</nombre><tasa>${x.tasa}</tasa><monto>${x.monto}</monto><tipo>${x.tipo}</tipo><importeImpuesto>${x.importeImpuesto}</importeImpuesto></propiedad>`;
                        });
                        xmlImpuestosLocales += '</propiedades>';

                        //// console.log('xml Relacionados', xmlRelacionados);
                        //// console.log('xmlProducto', xmlProducto);
                        var datosCliente = this.facturaForm.value;
                        var datosClienteAdicionales = this.facturaAdicionalesForm.value;
                        let idFacturaUpdate = this.dataLlenarFormulario.idFactura;
                        let tipoFacturaUpdate = datosCliente.tipoFactura;

                        const body = {
                            idFactura: this.dataLlenarFormulario.idFactura,
                            idDatoGeneralFactura: this.dataLlenarFormulario.idDatoGeneralFactura,
                            cliente: datosCliente.cliente,
                            tipoFactura: datosCliente.tipoFactura,
                            lugarExpedicion: datosCliente.lugarExpedicion,
                            formaPago: datosCliente.formaPago,
                            serie: datosCliente.serie,
                            metodoPago: datosCliente.metodoPago,
                            numeroPedido: datosClienteAdicionales.numeroPedido,
                            moneda: datosClienteAdicionales.moneda,
                            tipoCambio: datosClienteAdicionales.tipoCambio,
                            fechaEmision: datosClienteAdicionales.fechaEmision,
                            numeroCuenta: datosClienteAdicionales.numerodeCuenta,
                            nombreBanco: datosClienteAdicionales.nombreBanco,
                            condicionesPago: datosClienteAdicionales.condicionesPago,
                            observacion: datosClienteAdicionales.seleccionaObservacion === 0 ? null : datosClienteAdicionales.seleccionaObservacion,
                            CFDIRelacionados: datosClienteAdicionales.cFDIRelacionado === 0 ? null : datosClienteAdicionales.cFDIRelacionado,
                            cuentaBanco: datosClienteAdicionales.seleccioneCuentaBanco,
                            observaciones: datosClienteAdicionales.observaciones === undefined ? null : datosClienteAdicionales.observaciones,
                            idRol: 2,
                            idOperacion: this.idOperacion,
                            xmlRelacionados: xmlRelacionados,
                            xmlProducto: xmlProducto,

                            // Totales
                            importeSubtotal: this.sumatoriasTotales[0]?.sumatoria,
                            importeDescuento: 0,
                            importeIVA: this.sumatoriasTotales[1]?.sumatoria,
                            importeIVARet: this.sumatoriasTotales[2]?.sumatoria,
                            importeIEPS: this.sumatoriasTotales[3]?.sumatoria,
                            importeISR: this.sumatoriasTotales[4]?.sumatoria,
                            importeTotal: this.sumatoriasTotales[5]?.sumatoria,
                            importeLocales: 0,
                            impuestosLocales: xmlImpuestosLocales
                        };

                        // console.log("p seleccionados : " , xmlRelacionados);
                        this.store.dispatch(MostrarSpinner());
                        this._snackBar.open('No se salga de la página o interrumpa el proceso, se está generando la factura y él timbrando de la misma ante el SAT.', 'ok', { duration: 6000 });
                        this.srvcoal.postService(`catalogo/PostUPDFacturaTimbra`, body).subscribe(async (res: any) => {
                            if (res.err) {
                                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                            } else if (res.excepcion) {
                                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
                            } else {
                                this._snackBar.open(res.recordsets[0][0].mensaje, 'ok', { duration: 3000 });
                                this.store.dispatch(OcultarSpinner());
                                if (this.dataLlenarFormulario.tipoFactura == 3) {
                                    // console.log("test : " , this.dataLlenarFormulario.tipoFactura);
                                    this.idFacturaForComplemento = this.dataLlenarFormulario.idFactura;
                                    await this.delComplementos();
                                }
                                this.spinner = false;
                                if (this.dataLlenarFormulario.tipoFactura == 3) {
                                    // console.log("test : " , this.dataLlenarFormulario.tipoFactura);
                                    this.idFacturaForComplemento = this.dataLlenarFormulario.idFactura;
                                    await this.delComplementos();
                                }

                                if (res.recordsets[0][0].success === 1) {

                                    var datafact = {
                                        tipofactura: tipoFacturaUpdate,
                                        clave: idFacturaUpdate
                                    }

                                    this.openSuccess(res.recordsets[0][0], datafact);

                                }
                                else {
                                    this.openError(res.recordsets[0][0]);
                                }
                            };
                            this.store.dispatch(OcultarSpinner());

                        }, (error: any) => {
                            this.store.dispatch(OcultarSpinner());
                            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                        });
                    } else {
                        this.procesandoFactura = false;
                        this._snackBar.open('Registro cancelado', 'OK', { duration: 3000 });
                        this.spinner = false;
                    };
                });
            };
        }
    };


    actualizarProductos_(datafact: any): void {
        console.log("actualizando", datafact, "   ", this.productoSelecionados)
        const productoPromesasBorrar = this.productoSelecionadosEliminados.map(element => {
            return new Promise((resolve, reject) => {
                this.srvcoal.deleteService(`fac-factura-productos/${element.id}`).subscribe({
                    next: res => resolve(res),
                    error: err => reject(err)
                });
            });
        });
        const productoPromesasBorrar_ = this.productoSelecionados.map(element => {
            return new Promise((resolve, reject) => {
                if (element.id){
                    this.srvcoal.deleteService(`fac-factura-productos/${element.id}`).subscribe({
                        next: res => resolve(res),
                        error: err => reject(err)
                    });
                } else {
                    resolve(null);
                }
            });
        });

        const productoPromesas = this.productoSelecionados.map(element => {
            let bodyProducto = {
                data: {
                    noIdentificacion: element.codigoUnidad,
                    nombre: element.descripcion,
                    precioUnitario: element.precio,
                    pro_producto: element.idProducto,
                    cantidad: element.cantidad,
                    cat_forma_descuento: Number(element.formaDescuento) === 0 ? 1 : element.formaDescuento,
                    descuento: element.descuento,
                    fact_factura: this.idFacturaForComplemento,
                    cuentaPredial: element.cuentaPredial  + ''
                }
            };
            console.log("BodyProductos", element.id, bodyProducto);
            //return new Promise(resolve => resolve(bodyProductos));
            // if (element.id != null) {
                // return new Promise((resolve, reject) => {
                //     this.srvcoal.putService(`fac-factura-productos/${element.id}`, bodyProducto).subscribe({
                //         next: res => resolve(res),
                //         error: err => reject(err)
                //     });
                // });
            // } else {
                return new Promise((resolve, reject) => {
                    this.srvcoal.postService(`fac-factura-productos`, bodyProducto).subscribe({
                        next: res => resolve(res),
                        error: err => reject(err)
                    });
                });
            // }
        });

        Promise.all([...productoPromesas, ...productoPromesasBorrar,...productoPromesasBorrar_]).then(responses => {
            this.productoSelecionados.length = 0;
            this.store.dispatch(OcultarSpinner());

            if (this.timbrar) {
                this.facturar(datafact);
            } else {
                this.mostrarFactura(datafact);
            }
            // const dialogRef = this.dialog.open(ConfirmDialogOpcionComponent,
            //     {
            //         width: '450px', data: {
            //             data: datafact,
            //             msj: 'Se ha actualizado la factura.' // res.recordsets[0][0].mensaje
            //         }
            //     });
            // dialogRef.afterClosed().subscribe(result => {
            //     this.router.navigateByUrl('/factura/facturas/0/0/0/0/0/0/0/0');
            // });
        }).catch(error => {
            console.error(error);
        });
    }

    actualizarProductos(datafact: any): void {
        console.log("actualizando", datafact, "   ", this.productoSelecionados)
        const productoPromesasBorrar = this.productoSelecionadosEliminados.map(element => {
            return new Promise((resolve, reject) => {
                this.srvcoal.deleteService(`fac-factura-productos/`, element.id).subscribe({
                    next: res => resolve(res),
                    error: err => reject(err)
                });
            });
        });

        const productoPromesas = this.productoSelecionados.map(element => {
            let bodyProducto = {
                data: {
                    noIdentificacion: element.codigoUnidad,
                    nombre: element.descripcion,
                    precioUnitario: element.precio,
                    pro_producto: element.idProducto,
                    cantidad: element.cantidad,
                    cat_forma_descuento: Number(element.formaDescuento) === 0 ? 1 : element.formaDescuento,
                    descuento: element.descuento,
                    fact_factura: this.idFacturaForComplemento,
                    cuentaPredial: element.cuentaPredial  + ''
                }
            };
            console.log("BodyProductos", element.id, bodyProducto);
            //return new Promise(resolve => resolve(bodyProductos));
            if (element.id != null) {
                return new Promise((resolve, reject) => {
                    this.srvcoal.putService(`fac-factura-productos/${element.id}`, bodyProducto).subscribe({
                        next: res => resolve(res),
                        error: err => reject(err)
                    });
                });
            } else {
                return new Promise((resolve, reject) => {
                    this.srvcoal.postService(`fac-factura-productos`, bodyProducto).subscribe({
                        next: res => resolve(res),
                        error: err => reject(err)
                    });
                });
            }
        });

        Promise.all([...productoPromesas, ...productoPromesasBorrar]).then(responses => {
            this.productoSelecionados.length = 0;
            this.store.dispatch(OcultarSpinner());
            const dialogRef = this.dialog.open(ConfirmDialogOpcionComponent,
                {
                    width: '450px', data: {
                        data: datafact,
                        msj: 'Se ha actualizado la factura.' // res.recordsets[0][0].mensaje
                    }
                });
            dialogRef.afterClosed().subscribe(result => {
                this.router.navigateByUrl('/factura/facturas/0/0/0/0/0/0/0/0');
            });
        }).catch(error => {
            console.error(error);
        });
    }


    // 

    //#region Crear en base de datos
    Borrador() {
        console.clear();

        console.log("Entered Borrador() method");
        console.log("tipo fact", this.facturaForm.value.tipoFactura);
        //Guardar demas facturas
        const validacion = this.validaDatos();
        console.log("Validación resultado:", validacion);
        if (!validacion.success) {
            this._snackBar.open(validacion.msg, 'ok', { duration: 18000, });
        } else {
            this.procesandoFactura = true;
            let contadorErrores = 0;
            let validador;
            this.contenedorCfdiRelacionados.forEach(x => {
                validador = this.isUUID(x.cfdiRelacionados);
                if (!validador) {
                    contadorErrores++;
                }
            });
            //;
            console.log("this.contenedorCfdiRelacionados antes de contadorErrores:", this.contenedorCfdiRelacionados);
            console.log("contadorErrores inicial:", contadorErrores);
            if (contadorErrores > 0) {
                this.procesandoFactura = false;
                return this._snackBar.open('Favor de introducir UUID válido', 'OK', { duration: 3000 });
            };

            console.log("Preparando forkJoin con contenedorCfdiRelacionados");
            const dialogRef = this.dialog.open(ConfirmDialogComponent, { width: '350px', data: '¿Desea guardar este registro?' });
            dialogRef.afterClosed().subscribe(result => {
                //;
                console.log("Dialog result:", result);
                if (result) {
                    // this.spinner = true;
                    let idCfdiRel = []
                    this.store.dispatch(MostrarSpinner());
                    const observables = this.contenedorCfdiRelacionados.map(x => this.cfdiSave(x.cfdiRelacionados));
                    forkJoin(observables).subscribe(
                        (ids: any[]) => {
                            // Aquí ids es un array con los resultados de todas las observables
                            console.log("IDs obtenidos de CfdiSave:", ids);
                            idCfdiRel = ids

                        },
                        (error: any) => {
                            // Manejar errores en las solicitudes individuales
                            console.error('Error en una o más solicitudes individuales:', error);
                            this.store.dispatch(OcultarSpinner());
                        },
                        () => {
                            // Código que se ejecuta después de que todas las solicitudes se completen
                            console.log('Todas las solicitudes completadas');
                            var datosCliente = this.facturaForm.value;
                            var datosClienteAdicionales = this.facturaAdicionalesForm.value;
                            this.idFacturaForComplemento = 0;
                            let productosFactura = []
                            ///************** */
                            const body = {
                                data: {
                                    folio: this.folio,
                                    fechaEmision: new Date(),
                                    ope_direccion_empresa: datosCliente.lugarExpedicion,
                                    cat_tipo_comprobante: datosCliente.tipoFactura,
                                    ope_direccion_serie: datosCliente.serie,
                                    cli_cliente: datosCliente.cliente,
                                    fac_estatus: 1,
                                    cat_metodo_pago: datosCliente.metodoPago,
                                    cat_forma_pago: datosCliente.formaPago,
                                    numeroPedido: datosClienteAdicionales.numeroPedido,
                                    tipoCambio: datosClienteAdicionales.tipoCambio,
                                    cat_moneda: datosClienteAdicionales.moneda ? datosClienteAdicionales.moneda : this.idMonedaMXN,
                                    nombreBanco: datosClienteAdicionales.nombreBanco,
                                    condicionesPago: datosClienteAdicionales.condicionesPago,
                                    observacion: datosClienteAdicionales.seleccionaObservacion == 0 ? null : datosClienteAdicionales.observaciones,
                                    cat_cfdi_relaciondo: datosClienteAdicionales.cFDIRelacionado === 0 ? null : datosClienteAdicionales.cFDIRelacionado,
                                    // ope_cuenta: 12,
                                    ope_empresa_observacion: (datosClienteAdicionales.seleccionaObservacion == 0 || datosClienteAdicionales.seleccionaObservacion == 1) ? null : datosClienteAdicionales.seleccionaObservacion,
                                    fac_factura_estatus_hs: [1],
                                    ope_empresa: this.idEmpresa,
                                    numeroCuentaPago: datosClienteAdicionales.numerodeCuenta,
                                    ope_empresa_banco: datosClienteAdicionales.seleccioneCuentaBanco,
                                    cat_fecha_emision: datosClienteAdicionales.fechaEmision,
                                    fac_factura_doc_relacionados: idCfdiRel.length !== 0 ? idCfdiRel : null,
                                    cat_exportacion: datosClienteAdicionales.seleccioneExportacion,
                                    confirmacion: datosClienteAdicionales.confirmacion,
                                    subtotal: Number(this.sumatoriaSinDescuento ? this.sumatoriaSinDescuento : 0),
                                    descuento: Number(this.sumatoriaDescuento != 0 ? this.sumatoriaDescuento : 0),
                                    total: Number(this.sumatoriasTotales[5]?.sumatoria ? this.sumatoriasTotales[5]?.sumatoria : 0),
                                    cat_global_periodicidad: datosCliente.tipoFactura === 5 ? this.facturaGlobalForm.value.periodicidad : null,
                                    cat_global_me: datosCliente.tipoFactura === 5 ? this.facturaGlobalForm.value.mesFactGlobal : null,
                                    catGlobalAnio: datosCliente.tipoFactura === 5 ? Number(this.facturaGlobalForm.value.anioFactGlobal) : null

                                }
                            }

                            console.log("ForkJoin completado satisfactoriamente");
                            this.srvcoal.postService(`fac-facturas`, body).subscribe((res: any) => {
                                //;
                                console.log("Respuesta de postService fac-facturas:", res);
                                if (res.err) {
                                    this.store.dispatch(OcultarSpinner());
                                    this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
                                } else {
                                    var resp = res.data
                                    this.respFacturaSave =
                                    {
                                        serie: res.data.ope_direccion_serie ? res.data.ope_direccion_serie : '',
                                        folio: res.data.folio ? res.data.folio : '',
                                        rfc: res.data.cli_cliente ? res.data.cli_cliente.rfc : '',
                                        nombre: res.data.cli_cliente ? res.data.cli_cliente.nombre : '',
                                        email: res.data.cli_cliente ? res.data.cli_cliente.email : '',
                                        fecha: res.data.fechaEmision ? res.data.fechaEmision : '',
                                        descripcion: res.data.fac_estatus ? res.data.fac_estatus.nombre : '',
                                        accion: res.data.fac_estatus ? res.data.fac_estatus.id : 0,
                                        tipoFactura: res.data.cat_tipo_comprobante ? res.data.cat_tipo_comprobante.id : 0,
                                        tipoFactura_nombre: res.data.cat_tipo_comprobante ? res.data.cat_tipo_comprobante.nombre : '',
                                        CFDIRelacionados: res.data.cat_cfdi_relaciondo,
                                        EstatusFactura: res.data.fac_estatus ? res.data.fac_estatus.nombre : null,

                                        UUID: null, // no se
                                        UUIDCancelado: null, // no se
                                        UUIDRelacionado: null,// no se
                                        clave: 16812,// no se
                                        cliente: res.data.cli_cliente ? res.data.cli_cliente.id : null,
                                        condicionesPago: res.data.condicionesPago,
                                        cuentaBanco: res.data.ope_empresa_banco ? res.data.ope_empresa_banco.id : null, // no se falta back
                                        fechaEmision: null, // no se
                                        fechaHoraRegistro: "04/12/2023 01:52:35",// no se
                                        fechaRegistro: "2023/12/04",// no se
                                        formaPago: res.data.cat_forma_pago ? res.data.cat_forma_pago.id : null,
                                        fultext: null,// no se
                                        idDatoGeneralFactura: 16715, // no se
                                        idEstatusFactura: res.data.fac_estatus ? res.data.fac_estatus.id : null,
                                        idFactura: res.data.id,
                                        idEmpresa: res.data.ope_empresa ? res.data.ope_empresa.id : null,
                                        idFormaPago: res.data.cat_forma_pago ? res.data.cat_forma_pago.id : null,
                                        idSerie: res.data.ope_direccion_serie ? res.data.ope_direccion_serie.id : null,
                                        lugarExpedicion: res.data.ope_direccion_empresa ? res.data.ope_direccion_empresa.id : null,
                                        lugarExpedicionCP: "06280", // no se
                                        metodoPago: res.data.cat_metodo_pago ? res.data.cat_metodo_pago.id : null,
                                        moneda: res.data.cat_moneda ? res.data.cat_moneda.id : null,
                                        motivoCancelacion: null, // no se
                                        nombreBanco: res.data.nombreBanco,
                                        numeroCuenta: res.data.numeroCuentaPago,// no se
                                        numeroPedido: res.data.numeroPedido,
                                        observacion: res.data.observacion,

                                        observaciones: res.data.ope_empresa_observacion ? res.data.ope_empresa_observacion.id : null,// no se falta back
                                        periodoAnio: 2023,// no se
                                        periodoMes: 12,// no se
                                        tipoCambio: res.data.tipoCambio,
                                        tipo_factura: res.data.cat_tipo_comprobante ? res.data.cat_tipo_comprobante.nombre : '',
                                        xml_format: null,// no se,
                                        ope_empresa_banco: res.data.ope_empresa_banco ? res.data.ope_empresa_banco.id : null,
                                        idFechaEmision: res.data.cat_fecha_emision ? res.data.cat_fecha_emision.id : null,
                                        fac_comp_pago: res.data.fac_complemento_pagos ? res.data.fac_complemento_pagos : [],
                                        fac_factura_doc_relacionados: res.data.fac_factura_doc_relacionados ? res.data.fac_factura_doc_relacionados : [],
                                        confirmacion: res.data.confirmacion,
                                        cat_exportacion: res.data.cat_exportacion ? res.data.cat_exportacion : [],
                                        aplicaProductos: res.data.cat_tipo_comprobante.aplicaProductos !== null ? res.data.cat_tipo_comprobante.aplicaProductos : false,
                                        importe: res.data.total !== null ? res.data.total : 0,
                                        cat_global_periodicidad: res.data.cat_global_periodicidad ? { data: { id: res.data.cat_global_periodicidad.id } } : null,
                                        cat_global_me: res.data.cat_global_me ? { data: { id: res.data.cat_global_me.id } } : null,
                                        catGlobalAnio: res.data.catGlobalAnio
                                    }
                                    //this.facturaAdicionalesForm.reset();
                                    //this.facturaForm.reset();
                                    this.contenedorCfdiRelacionados.length = 0;

                                    this.spinner = false

                                    this.procesandoFactura = false;

                                    var datafact = {
                                        tipofactura: datosCliente.tipoFactura,
                                        clave: resp.id
                                    }
                                    if (resp && resp.id) {
                                        console.log("resp", resp)
                                        this.idFacturaForComplemento = resp.id;
                                        this.sharedService.setIdFactura(resp.id)
                                        //Soy complemento de pago
                                        if (datosCliente.tipoFactura === 3) {
                                            console.log("complemento de pago")
                                            this.InsertarDatosComplemento();
                                        } else if (datosCliente.tipoFactura === 4) {
                                            console.log("CARTA PORTE")
                                            //AQUI VA FUNCIÒN PARA INSERTAR DATA CARTA PORTE
                                            this.insertarProductos(datafact);
                                            this.sharedService.acciones(1);
                                        }
                                        else {
                                            console.log("Otro")
                                            this.insertarProductos(datafact);
                                        }

                                    }
                                }
                            }, (error: any) => {
                                this.procesandoFactura = false;
                                this._snackBar.open(error?.error?.error?.message,
                                    'OK',
                                    { duration: 10000 })
                                this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }))
                                this.store.dispatch(OcultarSpinner())
                            })
                        }
                    )
                } else {
                    this._snackBar.open('Registro cancelado', 'OK', { duration: 3000 });
                    this.procesandoFactura = false;
                    this.spinner = false;
                    this.timbrar = false;
                };
            });
        };
    };
    //#endregion Crear en base de datos

    cfdiSave(cfdi: any): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            this.srvcoal.postService(`fac-factura-doc-relacionados`, { data: { uuid: cfdi } })
                .subscribe((res: any) => {
                    if (res.err) {
                        this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }));
                        reject('Error');
                    } else {
                        //   var resp = res.data.id;

                        resolve(res.data.id); // Reemplaza esto con la lógica real para obtener el ID
                    }
                }, (error: any) => {
                    this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
                    reject('Error');
                });
        });
    }

    async insertarProductos(datafact: any): Promise<void> {
        console.log("soy otro", datafact, "   ", this.productoSelecionados);
        this.store.dispatch(MostrarSpinner());

        try {
            // Iteramos de forma secuencial sobre los productos
            for (const element of this.productoSelecionados) {
                let bodyProductos = {
                    data: {
                        noIdentificacion: element.codigoUnidad,
                        nombre: element.descripcion,
                        precioUnitario: element.precio,
                        pro_producto: element.idProducto,
                        cantidad: element.cantidad,
                        cat_forma_descuento: Number(element.formaDescuento) === 0 ? 1 : element.formaDescuento,
                        descuento: element.descuento,
                        fact_factura: this.idFacturaForComplemento,
                        cuentaPredial: element.cuentaPredial
                    }
                };

                console.log(element);
                console.log(this.productoSelecionados);

                // Esperamos a que se inserte el producto antes de continuar con el siguiente
                const response: any = await this.srvcoal.postService(`fac-factura-productos`, bodyProductos).toPromise();

                const productId = response?.data?.attributes?.data?.id;
                if (productId) {
                    // Guardamos los impuestos de forma secuencial también
                    await this.saveTaxes(productId);
                    // Opcional: Si tienes otro método para impuestos locales, lo puedes incluir
                    // await this.saveTaxesLocal(productId, element.subTotal);
                } else {
                    throw new Error("Error en la respuesta del servicio");
                }
            }

            // Al finalizar las inserciones, limpiamos la lista de productos seleccionados
            this.productoSelecionados.length = 0;
            this.store.dispatch(OcultarSpinner());

            // Decidimos si se timbra o se muestra la factura
            if (this.timbrar) {
                this.facturar(datafact);
            } else {
                this.mostrarFactura(datafact);
            }
        } catch (error) {
            this.store.dispatch(OcultarSpinner());
            this.procesandoFactura = false;
            this._snackBar.open("Ocurrió un error al agregar los productos: " + error.message, "OK", { duration: 12000 });
            console.error("Error:", error);
        }
    }

    // insertarProductos(datafact: any): void {
    //     console.log("soy otro", datafact, "   ", this.productoSelecionados)
    //     const productoPromesas = this.productoSelecionados.map(element => {
    //         let bodyProductos = {
    //             data: {
    //                 noIdentificacion: element.codigoUnidad,
    //                 nombre: element.descripcion,
    //                 precioUnitario: element.precio,
    //                 pro_producto: element.idProducto,
    //                 cantidad: element.cantidad,
    //                 cat_forma_descuento: Number(element.formaDescuento) === 0 ? 1 : element.formaDescuento,
    //                 descuento: element.descuento,
    //                 fact_factura: this.idFacturaForComplemento,
    //                 cuentaPredial: element.cuentaPredial
    //             }
    //         };
    //         console.log(element)
    //         console.log(this.productoSelecionados)

    //         return new Promise(async (resolve, reject) => {
    //             try {
    //                 var response: any = await this.srvcoal.postService(`fac-factura-productos`, bodyProductos).toPromise();

    //                 const productId = response?.data?.attributes?.data?.id;
    //                 if (productId) {
    //                     await this.saveTaxes(productId);
    //                     // this.saveTaxesLocal(productId, element.subTotal)
    //                     resolve(response);
    //                 } else {
    //                     reject("Error en la respuesta del servicio");
    //                 }
    //             } catch (error) {
    //                 this.procesandoFactura = false;
    //                 console.error(`Error al insertar producto o guardar impuestos: ${error}`);
    //                 reject(error);
    //             }
    //         });

    //     });

    //     Promise.all(productoPromesas).then(responses => {
    //         this.productoSelecionados.length = 0;
    //         this.store.dispatch(OcultarSpinner());
    //         if (this.timbrar) {
    //             this.facturar(datafact);
    //         } else {
    //             this.mostrarFactura(datafact)
    //         }
    //         //this.facturaAdicionalesForm.reset();
    //         //this.facturaForm.reset();
    //     }).catch(error => {
    //         this.store.dispatch(OcultarSpinner());
    //         this.procesandoFactura = false;
    //         this._snackBar.open("Ocurrió un error al agregar los productos " + error?.error?.error?.message, "OK", { duration: 12000 });
    //         console.error(error);
    //     });
    // }

    saveTaxes(idProducto: string): Promise<any> {
        console.log(this.lstProducto)

        const bodyImpuestos = {
            idFacturaProducto: idProducto
        }
        return new Promise((resolve, reject) => {
            this.srvcoal.postService(`fac-factura-prod-imp/saveTaxes`, bodyImpuestos).subscribe(
                res => resolve(res),
                err => {
                    "Ocurrió un error al agregar los productos " + err?.error?.error?.message, "OK", { duration: 12000 }
                    reject(err)
                }
            );
        });
    }

    saveTaxesLocal(idProductoFactura, subTotalProducto) {
        this.srvcoal
            .getService(
                `fac-factura-productos?filters[id]=${idProductoFactura}&populate[pro_producto][populate]=pro_impuesto_locals`
            )
            .subscribe(
                (res: any) => {
                    if (res.err) {
                        console.log('erro *************** 1');
                    } else {
                        console.log(res)
                        const resProducto = res.data[0].attributes.pro_producto.data;
                        const impuestosLocalesProducto = resProducto.attributes.pro_impuesto_locals.data

                        console.log(impuestosLocalesProducto)

                        if (impuestosLocalesProducto.length > 0) {
                            let promises = [];
                            let fac_factura_imp_locales_ids = []

                            impuestosLocalesProducto.forEach(element => {
                                let base = subTotalProducto
                                let tasa = element.attributes.tasa

                                if (element.attributes.monto > 0 && element.attributes.tasa > 0) {
                                    tasa = element.attributes.monto / subTotalProducto
                                } else {
                                    if (element.attributes.monto <= 0) {
                                        if (element.attributes.tasa <= 0) {
                                            tasa = element.attributes.monto / subTotalProducto
                                        } else {
                                            tasa = element.attributes.tasa
                                        }
                                    }
                                }



                                const body = {
                                    data: {
                                        pro_impuesto_local: element.id,
                                        subTotal: subTotalProducto,
                                        base: base,
                                        tasa: tasa,
                                        total: subTotalProducto / (base * tasa)
                                    }

                                }



                                // let promise = this.srvcoal.postService(`fac-factura-imp-locales`, body).toPromise();
                                // promises.push(promise);

                            });

                            // Promise.all(promises).then(results => {
                            //     results.forEach(res2 => {
                            //         if (!res2.err) {
                            //             fac_factura_imp_locales_ids.push(res2.data.id);
                            //         }
                            //     });

                            //     const bodyActualizacion = {
                            //         fac_factura_imp_locales: fac_factura_imp_locales_ids
                            //     }
                            //     this.srvcoal.putService(`fac-factura-productos/${idProductoFactura}`, { data: bodyActualizacion }).subscribe(
                            //         (res3: any) => {
                            //             if (!res3.err) {
                            //                 console.log("Actualización completada", res3);
                            //             }
                            //         },
                            //         (error) => {
                            //             console.log('Error en la actualización', error);
                            //         }
                            //     );
                            // }).catch(error => {
                            //     console.log('Error en las promesas', error);
                            // });
                        }
                    }
                },
                (error: any) => {
                    console.log('error *************** 3', error);
                }
            );

    }

    mostrarFactura(datafact) {
        const dialogRef = this.dialog.open(ConfirmDialogOpcionComponent,
            {
                width: '450px', data: {
                    data: datafact,
                    msj: 'Se ha creado la factura.' // res.recordsets[0][0].mensaje
                }
            });
        dialogRef.afterClosed().subscribe(result => {
            this.router.navigateByUrl('/factura/facturas/0/0/0/0/0/0/0/0');
        });
    }
    /// Refactorizamos facturar()
    facturar(datafact) {
        let data = {
            idFactura: this.idFacturaForComplemento
        };

        // Mostrar spinner mientras se procesa la solicitud
        this.store.dispatch(MostrarSpinner());

        this.srvcoal.postService('fac-factura-xmls/generate40', data).subscribe(
            (res: any) => {
                // Ocultar spinner y notificar éxito
                this.store.dispatch(OcultarSpinner());
                this._snackBar.open('Factura generada correctamente.', 'OK', { duration: 10000 });
                this.mostrarFactura(datafact);
                this.timbrar = false;
                this.procesandoFactura = false;
            },
            (error: any) => {
                // Ocultar spinner
                this.store.dispatch(OcultarSpinner());

                // Manejo de errores mejorado
                this.handleError(error);
                this.procesandoFactura = false;
                this.timbrar = false;

                // console.log('this.respFacturaSave', this.respFacturaSave);  
                // localStorage.setItem("Editar", "1")

                this.idFacturaForComplemento = this.respFacturaSave.idFactura;

                this.baseService.postDetalleFactura(null);
                this.baseService.postDetalleFactura(this.transformarJson(this.respFacturaSave));

                this.router.navigateByUrl(`factura/nueva/0`);
                // this.router.navigateByUrl(`factura/editar/0`);

            }
        );
    }

    transformarJson(input: any): any {
        return {
          serie: input.serie.nombre,
          folio: input.folio,
          rfc: input.rfc,
          rfcEmisor: "CACC620925FN8", // Valor fijo si aplica
          nombre: input.nombre,
          email: input.email,
          fecha: input.fecha,
          descripcion: input.descripcion,
          accion: input.accion,
          tipoFactura: input.tipoFactura,
          tipoFactura_nombre: input.tipoFactura_nombre,
          UUIDCancelado: input.UUIDCancelado,
          UUIDRelacionado: input.UUIDRelacionado,
          clave: input.clave,
          cliente: input.cliente,
          condicionesPago: input.condicionesPago,
          fechaEmision: input.fechaEmision,
          fechaHoraRegistro: input.fechaHoraRegistro,
          fechaRegistro: input.fechaRegistro,
          formaPago: input.formaPago,
          fultext: input.fultext,
          idDatoGeneralFactura: input.idDatoGeneralFactura,
          idEstatusFactura: input.idEstatusFactura,
          idFactura: input.idFactura,
          idFormaPago: input.idFormaPago,
          idSerie: input.idSerie,
          lugarExpedicion: input.lugarExpedicion,
          lugarExpedicionCP: input.lugarExpedicionCP,
          metodoPago: input.metodoPago,
          metodoPago_nombre: null, // No existe en el input original
          moneda: input.moneda,
          motivoCancelacion: input.motivoCancelacion,
          nombreBanco: input.nombreBanco,
          numeroCuenta: input.numeroCuenta,
          numeroPedido: input.numeroPedido,
          observacion: input.observacion,
          periodoAnio: input.periodoAnio,
          periodoMes: input.periodoMes,
          tipoCambio: input.tipoCambio,
          tipo_factura: input.tipo_factura,
          xml_format: input.xml_format,
          idFechaEmision: input.idFechaEmision,
          fac_comp_pago: input.fac_comp_pago.map((comp: any) => ({
            id: comp.id,
            attributes: {
              createdAt: comp.createdAt,
              updatedAt: comp.updatedAt,
              fac_com_pago_documentos: {
                data: comp.fac_com_pago_documentos?.map((doc: any) => ({
                  id: doc.id,
                  attributes: {
                    importePagado: doc.importePagado,
                    createdAt: doc.createdAt,
                  }
                }))
              }
            }
          })),
          confirmacion: input.confirmacion,
          cat_exportacion: {
            id: input.cat_exportacion.id,
            attributes: {
              clave: input.cat_exportacion.clave,
              nombre: input.cat_exportacion.nombre,
            }
          },
          aplicaProductos: input.aplicaProductos,
          importe: input.fac_comp_pago.reduce(
            (total: number, comp: any) =>
              total +
              comp.fac_com_pago_documentos?.reduce(
                (sum: number, doc: any) => sum + doc.importePagado,
                0
              ),
            0
          ), // Suma los importes pagados
          catGlobalAnio: input.catGlobalAnio,
          cuentaBanco: input.cuentaBanco,
          observaciones: input.observaciones,
          ope_empresa_banco: input.ope_empresa_banco,
          fac_factura_doc_relacionados: input.fac_factura_doc_relacionados,
          CFDIRelacionados: input.CFDIRelacionados,
          idEmpresa: input.idEmpresa,
        };
      }
      


    // Método para manejar errores de manera amigable
    handleError(error: any) {
        // Registro del error en consola (podría enviarse a un sistema de monitoreo)
        console.error('Error al generar la factura:', error);

        // Detectar el mensaje de error del objeto recibido
        let message = this.getFriendlyErrorMessage(error);

        // Abrir el diálogo personalizado con el mensaje de excepción
        let msgError = error?.error?.error?.message;
        if( error?.error?.error?.message == 'Emisor no registrado.' ){
            message = 'Tu emisor está en proceso de registro'
            msgError = 'Esto puede tomar un poco de tiempo, ya que el proveedor de facturación necesita validar y registrar los datos del emisor. Por favor, intenta generar tu factura más tarde.'
        }
        this.openDialogExcepciones(message, msgError);

        // Mostrar un mensaje más comprensible al usuario en el snackbar
        this._snackBar.open(message, 'OK', { duration: 10000 });
    }

    // Función para extraer y transformar el mensaje de error
    // getFriendlyErrorMessage(error: any): string {
    //     // Verificar si el objeto contiene el mensaje de error esperado
    //     if (error && error.error && error.error.message) {
    //         return error.error.message;
    //     }

    //     // Mensaje por defecto en caso de que no haya uno específico
    //     return 'Ocurrió un error inesperado al procesar la solicitud.';
    // }

    // Método para obtener mensajes amigables
    getFriendlyErrorMessage(error: any): string {
        // Si es un error de red
        if (error.status === 0) {
            return 'No se pudo conectar con el servidor. Por favor, verifique su conexión a internet.';
        }

        // Si es un error del servidor
        if (error.status >= 500) {
            return 'Ocurrió un error en el servidor. Por favor, intente nuevamente más tarde.';
        }

        // Si es un error de validación del lado del servidor o API
        if (error?.error?.error?.message) {
            // Podrías mapear más errores específicos de tu API aquí
            return 'Revise los datos ingresados y vuelva a intentarlo.';
        }

        // Mensaje genérico para cualquier otro error
        return 'Algo salió mal. Por favor, intente nuevamente más tarde.';
    }


    openDialogExcepciones(titulo: string, mensaje: string): void {
        const dialogRef = this.dialog.open(CustomAlertComponent, {
            width: '60%', // Puedes ajustar el tamaño del diálogo
            data: {
                titulo: titulo,
                message: mensaje
            } // Opcional: envía datos al componente
        });

        // Si quieres realizar alguna acción cuando el diálogo se cierre
        dialogRef.afterClosed().subscribe(result => {
            console.log('El diálogo se cerró', result);
        });
    }
    // facturar(datafact) {
    //     let data = {
    //         idFactura: this.idFacturaForComplemento
    //     }
    //     this.store.dispatch(MostrarSpinner());
    //     this.srvcoal.postService('fac-factura-xmls/generate40', data).subscribe((res: any) => {
    //         this.store.dispatch(OcultarSpinner());
    //         this._snackBar.open('Factura generada correctamente.', 'OK', { duration: 10000 });
    //         this.mostrarFactura(datafact);
    //         this.timbrar = false;
    //         this.procesandoFactura = false;
    //     }, (error: any) => {
    //         this.store.dispatch(OcultarSpinner());
    //         this._snackBar.open(`Ocurrió un error al generar la factura: ${error?.error?.error?.message}`, 'OK', { duration: 10000 });
    //         this.procesandoFactura = false;
    //         this.timbrar = false;
    //         // modificar(e) {
    //         this.baseService.postDetalleFactura(null);
    //         this.baseService.postDetalleFactura([this.respFacturaSave]);
    //         this.router.navigateByUrl(`factura/nueva/0`);
    //         // }
    //     })
    // }

    //Funciones previas
    ArrayConstPrevia() {
        var arrayPrdu = [];
        this.productoSelecionados.forEach(element => {
            console.log('ArrayConstPrevia', element);
            //let index = this.lstProducto.findIndex(x => x.id === element.idProducto);
            //let impuestos = [(this.lstProducto[index].attributes.cat_iep.data) ? this.lstProducto[index].attributes.cat_iep.data.attributes.valor : 0, (this.lstProducto[index].attributes.cat_isr.data) ? this.lstProducto[index].attributes.cat_isr.data.attributes.valor : 0, (this.lstProducto[index].attributes.cat_iva.data) ? this.lstProducto[index].attributes.cat_iva.data.attributes.valor : 0, this.lstProducto[index].attributes.cat_iva_ret.data ? this.lstProducto[index].attributes.cat_iva_ret.data.attributes.valor : 0];
            const R = { id: 1, nombre: 'RETENCIÓN' };
            const T = { id: 2, nombre: 'TRASLADO' };
            const subTotal = element.precio * element.cantidad;
            let lstImpuestos = [
                {
                    tipo: T,
                    impuesto: "IVA",
                    clave: "002",
                    base: subTotal,
                    tasa: element.valIva,
                    importe: subTotal * element.valIva
                },
                {
                    tipo: T,
                    impuesto: "IEPS",
                    clave: "003",
                    base: subTotal,
                    tasa: element.valIEPS,
                    importe: subTotal * element.valIEPS
                },
                {
                    tipo: R,
                    impuesto: "IVA RET",
                    clave: "002",
                    base: subTotal,
                    tasa: element.valIvaRet,
                    importe: subTotal * element.valIvaRet
                },
                {
                    tipo: R,
                    impuesto: "ISR",
                    clave: "001",
                    base: subTotal,
                    tasa: element.valISR,
                    importe: subTotal * element.valISR
                }
            ];

            const impuestos = lstImpuestos.filter(impuesto => impuesto.tasa != null && impuesto.tasa > 0);

            // codigoUnidad
            // Unidad
            let dato = {
                "clave_pys": element.claveSat,
                "cantidad": element.cantidad,
                "unidad": "",
                "clave_unidad": element.codigoUnidad,
                "n_identificacion": element.idProducto,
                "descripcion": element.descripcion,
                "pu": this.facturaService._$(element.precio),
                "importe": this.facturaService._$(element.subTotal),
                "nombreFormaDescuento": element.nombreFormaDescuento,
                "descuento": element.descuentoValue,
                "predial": element.cuentaPredial,
                "impuestos": impuestos,
                "objetoImpuesto": {
                    "valor": element.ObjetoImpuesto,
                    "nombre": element.lblObjetoImpuesto
                }
            }
            arrayPrdu.push(dato);
        });
        return arrayPrdu;
    }

    totalesPrevia() {
        var importeSubtotal;
        var importeDescuento = 0;
        var importeIVA;
        var importeIVARet;
        var importeIEPS;
        var importeISR;
        var importeLocales;
        var importe_total;
        this.productoSelecionados.forEach(element => {
            importeSubtotal = importeSubtotal + (element.precio * element.cantidad);
            importeDescuento += element.descuento ? element.descuento : 0;
            importe_total = importe_total + (element.precio * element.cantidad * 1.16)
        });

        importeSubtotal = +this.sumatoriasTotales[0].sumatoria;
        importeIVA = +this.sumatoriasTotales[1].sumatoria;
        importeIVARet = +this.sumatoriasTotales[2].sumatoria;
        importeIEPS = +this.sumatoriasTotales[3].sumatoria;
        importeISR = +this.sumatoriasTotales[4].sumatoria;
        importe_total = +this.sumatoriasTotales[5].sumatoria;

        let dato = {
            "importeSubtotal": this.facturaService._$(importeSubtotal),
            "importeDescuento": this.facturaService._$(importeDescuento),
            "importeIVA": this.facturaService._$(importeIVA),
            "importeIVARet": this.facturaService._$(importeIVARet),
            "importeIEPS": this.facturaService._$(importeIEPS),
            "importeISR": this.facturaService._$(importeISR),
            //"importeLocales": this.facturaService._$(10004.00),
            "importe_total": this.facturaService._$(importe_total),
            "iva": this.facturaService._$(98765)
        }

        console.log("Precio : ", dato);
        return dato;
    }
    //Crear arreglo complemento pago (pagos y docs rel)
    getItemsWithPrefix(prefix: string) {
        const pagosArray = [];
        const relArray = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && key.startsWith(prefix)) {
                const value = localStorage.getItem(key);
                if (value) {
                    var val = JSON.parse(value);
                    var forma_pago = this.ltsFormaPago.find(element => element.id == val.pago.data.formaPago.id);
                    var moneda = this.ltsMoneda.find(element => element.id == val.pago.data.monedaComplemento);
                    var pagos = {
                        "uuid": i + 1,
                        "fmoneda": moneda?.attributes.clave, //.descripcion,
                        "mpago": val.pago.data.montoPago,
                        "fpago": forma_pago?.attributes.clave, //.descripcion,
                        "fechapago": val.pago.data.fechaPago + " " + val.pago.data.horaPago,
                        "nbanco": val.pago.data.nombreBanco,
                        "rfccuentab": val.pago.data.rfcCuentaBeneficiario,
                        "rfccuentao": val.pago.data.rfcCuentaOrdenante
                    }
                    for (let j = 0; j < val.pago.documentosRelacionados.length; j++) {
                        //var forma_pago = this.ltsFormaPago.find(element => element.id == val.pago.data.formaPago.id);
                        var metodo_pago = this.ltsMetodoPago.find(element => element.id == val.pago.data.formaPago.id);
                        var moneda = this.ltsMoneda.find(element => element.id == val.pago.documentosRelacionados[j][1].data.monedaDocsRel);
                        var docs = {
                            "uuid": i + 1,
                            "ident": val.pago.documentosRelacionados[j][1].data.facturaOriginal,
                            "fpago": metodo_pago?.attributes.clave, //.descripcion,
                            "fmoneda": moneda?.attributes.clave, //.descripcion,
                            "moriginal": val.pago.documentosRelacionados[j][1].data.montoOriginal,
                            "ipagado": val.pago.documentosRelacionados[j][1].data.importePagado,
                            "sinsoluto": val.pago.documentosRelacionados[j][1].data.saldoInsoluto,
                            "serie": val.pago.documentosRelacionados[j][1].serie,
                            "folio": val.pago.documentosRelacionados[j][1].folio
                        }
                        relArray.push(docs);
                    }
                    pagosArray.push(pagos);

                }
            }
        }
        this.pagosListprev = pagosArray;
        this.docsrelListprev = relArray;
    }

    //viste previa general
    async vistaPrevia() {
        const validacion = this.validaDatos();
        if (!validacion.success) {
            return this._snackBar.open(validacion.msg, 'ok', { duration: 10000, });
        }

        //this.spinner = true;
        this.store.dispatch(MostrarSpinner());

        const flugarExpedicion = this.facturaForm.controls.lugarExpedicion.value;
        const fcliente = this.facturaForm.controls.cliente.value;
        
        const condiciones_pago = this.facturaAdicionalesForm.controls.condicionesPago.value;
        
        const fecha_emision = this.facturaAdicionalesForm.controls.fechaEmision.value;
        const fechaActual = new Date();

        let fecha;

        switch (fecha_emision) {
        case 1:
            fecha = fechaActual.toISOString();
            break;
        case 2:
            fechaActual.setDate(fechaActual.getDate() - 1);
            fecha = fechaActual.toISOString();
            break;
        case 3:
            fechaActual.setDate(fechaActual.getDate() - 2);
            fecha = fechaActual.toISOString();
            break;
        default:
            console.warn("Valor de fecha_emision no válido");
            fecha = fechaActual.toISOString();
        }
        // const fecha_emision = this.facturaAdicionalesForm.controls.fechaEmision.value;
        // const fechaActual = new Date();
        // const fecha = fechaActual.toISOString();

        console.log( 'fecha_emision', fecha );

        const date = new Date(fecha); // Tu fecha inicial
        const options = { timeZone: 'America/Mexico_City' };

        // Obtener las partes de la fecha en la zona horaria específica
        const year = date.toLocaleString('es-MX', { ...options, year: 'numeric' });
        const month = date.toLocaleString('es-MX', { ...options, month: '2-digit' });
        const day = date.toLocaleString('es-MX', { ...options, day: '2-digit' });

        const hours = date.toLocaleString('es-MX', { ...options, hour: '2-digit', hour12: false });
        const minutes = date.toLocaleString('es-MX', { ...options, minute: '2-digit' });
        const seconds = date.toLocaleString('es-MX', { ...options, second: '2-digit' });

        // Construir el formato ISO
        const fechaEmision = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        

        let promises = [
            this.facturaService.getDataEmpresa(this.idEmpresa),
            this.facturaService.getDataDireccionEmpresa(flugarExpedicion),
            this.facturaService.getDataCliente(fcliente),
        ];

        let data: any[];
        try {
            data = await Promise.all(promises);
        } catch (error) {
            this._snackBar.open(`Ocurrió un error al cargar los datos: ${error?.error?.error?.message ?? error?.message ?? 'Error desconocido'}`, 'OK', { duration: 5000 });
            this.store.dispatch(OcultarSpinner());
            return;
        }
        const emisor = data[0];
        const dir_emisor = data[1];
        const receptor = data[2];

        //const fserie = this.facturaForm.controls.serie.value;
        //var ser = null;
        //if (fserie) ser = await this.facturaService.getDataDireccionSerie(fserie);

        console.log("data", data);

        console.log("Tipo factura : ", this.tipoFactura[0]);
        //data previa
        if (this.tipoFactura[0].id !== 3) {
            var productos = this.ArrayConstPrevia();
            var totales = this.totalesPrevia();
        }
        //var cliente = this.lstCliente.find(element => element.id == this.facturaForm.value.cliente);
        var serie = this.ltsSerie.find(element => element.id == this.facturaForm.value.serie);
        var metodo_pago = this.ltsMetodoPago.find(element => element.id == this.facturaForm.value.metodoPago);
        var forma_pago = this.ltsFormaPago.find(element => element.id == this.facturaForm.value.formaPago);
        var cfdi_relacionado = this.lstCfdiRelacionados.find(element => element.id == this.facturaAdicionalesForm.value.cFDIRelacionado);
        //Cabecero
        let cabecero = {
            "uuid": null,
            "serie1": serie?.attributes.nombre,
            "metodo_pago": metodo_pago?.attributes.nombre,
            "ingresos": null,
            "condiciones_pago": condiciones_pago,
            "lugar_exp": dir_emisor?.direccion?.codigoPostal,
            "forma_pago": forma_pago?.attributes.descripcion,
            "fecha": fechaEmision,
            "nombre": "Factura",
            "nombretit": "Ingreso"
        };
        let emisorConst = {
            "nombre": emisor?.nombreComercial ?? '',
            "rfc": emisor?.rfc ?? '',
            "lugar_emision": dir_emisor?.direccion?.codigoPostal,
            "direccion": this.facturaService.mapDireccionStr(dir_emisor?.direccion),
            "regimen_fiscal": `${emisor?.regimen_fiscal.clave}-${emisor?.regimen_fiscal.descripcion}`
        };
        let remisorConst = {
            "nombre": receptor?.nombre ?? '',
            "rfc": receptor?.rfc ?? '',
            "direccion": this.facturaService.mapDireccionStr(receptor?.direccion) ?? '',
            "regimen_fiscal": `${receptor?.regimen_fiscal.clave}-${receptor?.regimen_fiscal.descripcion}`
        };
        let timbrado = {
            "ex": 0,
            idEstatusFactura: 1, // 4 Cancelado
            emisor_cert: ''.padEnd(95, ""),
            pac: ''.padEnd(95, ""),
            cadena_original: ''.padEnd(95, ""),
            sat_cret: ''.padEnd(95, ""),
            sello_sat: ''.padEnd(95, ""),
            fecha_emit: ''.padEnd(95, ""),
            sello_emisor: ''.padEnd(95, ""),
        };
        let documentos_relacionados = {
            cfdi_relacionado: {
                id: cfdi_relacionado?.id,
                clave: cfdi_relacionado?.attributes.clave,
                descripcion: cfdi_relacionado?.attributes.descripcion
            },
            documentos: this.contenedorCfdiRelacionados.map(it => { return { id: 0, uuid: it.cfdiRelacionados }; })
        };

        let pdf = null;
        console.log('sumatoriasTotales subtotal', this.sumatoriasTotales[0].sumatoria);

        switch (this.idTipoFactura) {//(this.tipoFactura[0].idTipoFactura) {
            case 1:
                //cabecero
                cabecero.nombretit = 'INGRESO'
                let facturaData = [
                    [cabecero],
                    [emisorConst],
                    [remisorConst],
                    productos,
                    [{ "subtotal_total": 300 }],
                    [{ "porcentaje_iva": "IVA 16%" }],
                    [{ "iva": 100 }],
                    [totales],
                    [],
                    [{ "qr": "QR CODE" }],
                    [timbrado],
                    [],
                    [documentos_relacionados],
                    [],
                    [{ "idLogo": this.logoEmpresa }],
                    [{ global: 0 }]
                ]
                try {
                    pdf = await this.sparroService.getReportBase64("reportes/SelPdf", facturaData, "VistaPrevia");
                    this.store.dispatch(OcultarSpinner());
                    this.dialogVistaPrevia(pdf);
                } catch (error) {
                    this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
                    this.store.dispatch(OcultarSpinner());
                }
                break;
            case 2:
                cabecero.nombretit = 'EGRESO'
                let PorteData = [
                    [cabecero],
                    [emisorConst],
                    [remisorConst],
                    productos,
                    [{ "subtotal_total": "$" + totales.importeSubtotal }],
                    [{ "porcentaje_iva": "IVA 16%" }],
                    [{ "iva": "$" + totales.iva }],
                    [totales],
                    [],
                    [{ "qr": "QR CODE" }],
                    [timbrado],
                    [],
                    [documentos_relacionados],
                    [],
                    [{ "idLogo": this.logoEmpresa }],
                    [{ global: 0 }]
                ]
                //"https://forum-kobotoolbox-org.s3.dualstack.us-east-1.amazonaws.com/original/2X/5/5a7b168b37a53310c7be8c1bfc25f024cebedef5.png"
                // this.sparroService.getReport("reportes/SelPdf", PorteData, "ReportePrueba");
                try {
                    pdf = await this.sparroService.getReportBase64("reportes/SelPdf", PorteData, "VistaPrevia");
                    this.store.dispatch(OcultarSpinner());
                    this.dialogVistaPrevia(pdf);
                } catch (error) {
                    this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
                    this.store.dispatch(OcultarSpinner());
                }
                break;
            case 3:
                this.getItemsWithPrefix("Pago");
                let ComplementoData = {
                    "logo": { "idLogo": this.logoEmpresa },
                    "emisor": emisorConst,
                    "receptor": remisorConst,
                    "productos": {
                        "ClaveProdServ": "84111506",
                        "Cantidad": "1",
                        "ClaveUnidad": "ACT",
                        "Descripcion": "Pago",
                        "ValorUnitario": "0",
                        "Importe": "0",
                        "ObjetoImp": "01"
                    },
                    "tproductos": null,
                    "pagos": this.pagosListprev,
                    "DocsRel": this.docsrelListprev,
                    "footer": { idEstatusFactura: 1 }
                }
                //"https://img.freepik.com/vector-premium/icono-empresa-ilustracion-elemento-simple-diseno-simbolo-concepto-empresa-puede-utilizar-web-movil_159242-7784.jpg?w=2000"
                // this.sparroService.getReport("reportes/CallFeatureNew", ComplementoData, "ReportePrueba");
                try {
                    pdf = await this.sparroService.getReportBase64("reportes/CallFeatureNew", ComplementoData, "VistaPrevia");
                    this.store.dispatch(OcultarSpinner());
                    this.dialogVistaPrevia(pdf);
                } catch (error) {
                    this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
                    this.store.dispatch(OcultarSpinner());
                }
                break;
            case 5:
                //cabecero
                console.log('this.facturaGlobalForm', this.facturaGlobalForm)
                const periodicidad = this.periodicidadFactGlobal.filter(item => item.id === this.facturaGlobalForm.value.periodicidad);
                const mes = this.mesFactGlobal.filter(item => item.id === this.facturaGlobalForm.value.mesFactGlobal);

                console.log(periodicidad, mes)

                cabecero.nombretit = 'INGRESO'
                let facturaGlobalData = [
                    [cabecero],
                    [emisorConst],
                    [remisorConst],
                    productos,
                    [{ "subtotal_total": 300 }],
                    [{ "porcentaje_iva": "IVA 16%" }],
                    [{ "iva": 100 }],
                    [totales],
                    [],
                    [{ "qr": "QR CODE" }],
                    [timbrado],
                    [],
                    [documentos_relacionados],
                    [],
                    [{ "idLogo": this.logoEmpresa }],
                    [
                        {
                            "global": 1,
                            "lblPeriodo": `${periodicidad[0].attributes.clave} - ${periodicidad[0].attributes.periodicidad}`,
                            "lblMes": `${mes[0].attributes.clave} - ${mes[0].attributes.mes}`,
                            "lblAnio": this.facturaGlobalForm.value.anioFactGlobal
                        }
                    ]
                ]
                try {
                    pdf = await this.sparroService.getReportBase64("reportes/SelPdf", facturaGlobalData, "VistaPrevia");
                    this.store.dispatch(OcultarSpinner());
                    this.dialogVistaPrevia(pdf);
                } catch (error) {
                    this._snackBar.open(`Ocurrió un error al generar el comprobante: ${error?.error?.error?.message}`, 'OK', { duration: 5000 });
                    this.store.dispatch(OcultarSpinner());
                }
                break;
            case 10:
                this.sharedService.acciones(2);
                this.store.dispatch(OcultarSpinner());
                break;
            default: this.store.dispatch(OcultarSpinner()); break;
        }
    }

    dialogVistaPrevia(pdf: any) {
        const dialogRef = this.dialog.open(VistaPreviaFacturaComponent, {
            width: '95vw', //'1000px',
            height: '90vh',
            disableClose: false,
            data: { src: pdf },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.success == 1) {
                this.NuevoProducto = result.idProducto;
                this.GetProducto(2);
            }
        });
    }

    validaDatos = () => {


        if (this.clienteRule.obligatory && (this.facturaForm.controls.cliente.value === null || this.facturaForm.controls.cliente.value === '' || this.facturaForm.controls.cliente.value === undefined)) {
            return { success: false, msg: 'Favor de seleccionar un cliente' };
        };
        if (this.lugarExpedicionRule.obligatory && (this.facturaForm.controls.lugarExpedicion.value == null || this.facturaForm.controls.lugarExpedicion.value === '' || this.facturaForm.controls.lugarExpedicion.value == undefined)) {
            return { success: false, msg: 'Favor de seleccionar lugar de expedicion' };
        };

        if (this.formaPagoRule.obligatory && !this.facturaForm.controls.formaPago.value) {
            return { success: false, msg: 'Favor de seleccionar una forma de pago' };
        };

        if (this.metodoPagoRule.obligatory && !this.facturaForm.controls.metodoPago.value) {
            return { success: false, msg: 'Favor de seleccionar un metodo de pago' };
        };

        if (this.numeroPedidoRule.obligatory && (this.facturaAdicionalesForm.controls.numeroPedido.value === null || this.facturaAdicionalesForm.controls.numeroPedido.value === undefined || this.facturaAdicionalesForm.controls.numeroPedido.value === '')) {
            return { success: false, msg: 'Favor de seleccionar numero de pedido' }
        };
        if (this.monedaRule.obligatory && (this.facturaAdicionalesForm.controls.moneda.value === null || this.facturaAdicionalesForm.controls.moneda.value === undefined || this.facturaAdicionalesForm.controls.moneda.value === '')) {
            return { success: false, msg: 'Favor de seleccionar moneda' }
        };
        if (this.tipoCambioRule.obligatory && (this.facturaAdicionalesForm.controls.tipoCambio.value === null || this.facturaAdicionalesForm.controls.tipoCambio.value === undefined || this.facturaAdicionalesForm.controls.tipoCambio.value === '')) {
            return { success: false, msg: 'Favor de seleccionar tipo de cambio' }
        };
        if (this.fechaEmisionRule.obligatory && (this.facturaAdicionalesForm.controls.fechaEmision.value === null || this.facturaAdicionalesForm.controls.fechaEmision.value === undefined || this.facturaAdicionalesForm.controls.fechaEmision.value === '')) {
            return { success: false, msg: 'Favor de seleccionar fecha emision' }
        };
        if (this.numeroCuentaRule.obligatory && (this.facturaAdicionalesForm.controls.numerodeCuenta.value === null || this.facturaAdicionalesForm.controls.numerodeCuenta.value === undefined || this.facturaAdicionalesForm.controls.numerodeCuenta.value === '')) {
            return { success: false, msg: 'Favor de seleccionar numero de cuenta' }
        };
        if (this.nombreBancoRule.obligatory && (this.facturaAdicionalesForm.controls.nombreBanco.value === null || this.facturaAdicionalesForm.controls.nombreBanco.value === undefined || this.facturaAdicionalesForm.controls.nombreBanco.value === '')) {
            return { success: false, msg: 'Favor de seleccionar nombre banco' }
        };
        if (this.seleccionaObservacionRule.obligatory && (this.facturaAdicionalesForm.controls.seleccionaObservacion.value === null || this.facturaAdicionalesForm.controls.seleccionaObservacion.value === undefined || this.facturaAdicionalesForm.controls.seleccionaObservacion.value === '')) {
            return { success: false, msg: 'Favor de seleccionar una observacion' }
        };
        if (this.seleccioneCuentaBancoRule.obligatory && (this.facturaAdicionalesForm.controls.seleccioneCuentaBanco.value === null || this.facturaAdicionalesForm.controls.seleccioneCuentaBanco.value === undefined || this.facturaAdicionalesForm.controls.seleccioneCuentaBanco.value === '')) {
            return { success: false, msg: 'Favor de seleccionar cuenta del banco' }
        };
        //se comenta por reglas por definir
        // if (this.facturaAdicionalesForm.controls.moneda.value !== this.tipoCambioRule?.diferentValid && (this.facturaAdicionalesForm.controls.tipoCambio.value === null || this.facturaAdicionalesForm.controls.tipoCambio.value === undefined || this.facturaAdicionalesForm.controls.tipoCambio.value === '')) {
        //     if (this.facturaAdicionalesForm.controls.moneda.value !== 0) {
        //         return { success: false, msg: 'Favor de especificar el tipo de cambio' };
        //     };
        // };
        if (this.facturaAdicionalesForm.controls.cFDIRelacionado.value !== null) {
            //&& this.facturaAdicionalesForm.controls.cFDIRelacionado.value !== 0) {
            if (this.facturaAdicionalesForm.controls.cFDIRelacionado.value !== undefined) {
                if (this.facturaAdicionalesForm.controls.cFDIRelacionado.value !== '') {
                    if (this.contenedorCfdiRelacionados.length <= 0) {
                        return { success: false, msg: 'Favor de agregar un CDFI relacionado.' }
                    };
                };
            };
        };
        if (this.facturaAdicionalesForm.controls.cFDIRelacionado.value === null && this.facturaForm.value.tipoFactura == TipoDeComprobante.NotaDeCredito) {
            // if (this.facturaAdicionalesForm.controls.cFDIRelacionado.value === undefined) {
            // if (this.facturaAdicionalesForm.controls.cFDIRelacionado.value === '') {
            if (this.contenedorCfdiRelacionados.length <= 0) {
                return { success: false, msg: 'Para emitir una Nota de Crédito, es esencial vincular al menos un CFDI, en "Opciones Adicionales" podras especificarla.' }
            };
            // };
            // };
        };

        if (this.seleccionaObservacionRule.obligatory && this.desObservacion) {
            if (this.facturaAdicionalesForm.controls.observaciones.value === null || this.facturaAdicionalesForm.controls.observaciones.value === undefined || this.facturaAdicionalesForm.controls.observaciones.value === '') {
                return { success: false, msg: 'Las observaciones no pueden ir vacias' };
            };
            if (this.facturaAdicionalesForm.controls.observaciones.value.length < this.seleccionaObservacionRule.maxLength) {
                return { success: false, msg: 'Las observaciones deben llevar mas de 12 caracteres' };
            };
            if (this.facturaAdicionalesForm.controls.observaciones.value.length > this.seleccionaObservacionRule.maxLength) {
                return { success: false, msg: 'Las observaciones deben llevar menos de 1500 caracteres' };
            };
        };
        if (this.productoSelecionados.length === 0 && this.facturaForm.controls.tipoFactura.value !== 3)
            return { success: false, msg: 'Favor de agregar un producto o servicio a facturar' };
        if (this.facturaForm.value.tipoFactura === 5) {
            if (this.facturaGlobalForm.value.mesFactGlobal === 0 || this.facturaGlobalForm.value.periodicidad === 0 || this.facturaGlobalForm.value.anioFactGlobal === 0)
                return { success: false, msg: 'Favor de completar información de factura global' };
        }
        if (this.facturaForm.value.tipoFactura === 3) {
            const valido = this.complementoPago.validaComplementoPago();
            if (!valido) return { success: false, msg: 'Favor de completar información de pago' };
        }

        return { success: true, msg: '' };
    };

    GetCliente() {
        console.log('entra cliente')
        this.lstCliente.length = 0;
        // this.srvcoal.getService(`cli-clientes?populate=*`,).subscribe((res: any) => {
        this.srvcoal.getService(`ope-empresas?fields=id&fields=razonSocial&filters[id][$eq]=${this.idEmpresa}
            &populate[cli_clientes]=*
           `)
            .subscribe((res: any) => {
                if (res.err) {
                    console.log("erro *************** 1")
                } else if (res.excepcion) {
                    console.log("erro *************** 2")
                } else {
                    this.emisorRSocial = res.data
                    this.lstCliente = this.emisorRSocial[0].attributes.cli_clientes.data

                    
                    if(this.EditFac_Factura){
                        if(this.EditFac_Factura.attributes.cli_cliente.data.id ?? false){
                            this.curCliente(this.EditFac_Factura.attributes.cli_cliente.data.id);
                        }
                    }
                    
                        // this.EditFac_Factura = res.data;
                        // this.facturaForm.controls.cliente.setValue(res.data.attributes.cli_cliente.data.id);

                // this.facturaForm.controls.cliente.patchValue(res.data.attributes.cli_cliente.data.id);



                    console.log("this.emisorRSocial", this.emisorRSocial)
                }
            })

        // this.coalService.getService(`catalogo/GetSelCliente?idOperacion=${this.idOperacion}`,).subscribe((res: any) => {
        //     if (res.err) {
        //     } else if (res.excepcion) {
        //     } else {
        //         this.lstCliente = res.recordsets[0];
        //         this.store.dispatch(OcultarSpinner());
        //     }
        // }, (error: any) => {
        //     this.store.dispatch(OcultarSpinner());
        // });
    }

    PostSelLugarExpedicion() {
        // this.ltsLugarExpedicion.length = 0;
        // const body = {
        //     idOperacion: this.idOperacion
        // }

        // console.log("e,isosr social",this.emisorRSocial)
        // this.srvcoal.getService(`ope-direccion-empresas?populate[dir_direccion][fields]=codigoPostal&fields=nombre&filters[ope_empresa][id][$eq]=${this.emisorRSocial[0].id}`,).subscribe((res: any) => {

        //     if (res.err) {
        //         console.log("erro *************** 1")
        //     } else if (res.excepcion) {
        //         console.log("erro *************** 2")
        //     } else {
        //         this.ltsLugarExpedicion = res.data
        //         console.log('ltsLugarExpedicion dsata', res.data)
        //     }
        // }, (error: any) => {
        //     console.log("erro *************** 3", error)
        // });
    }

    PostSelSerie(e, origen = 0) {
        try {
            this.store.dispatch(MostrarSpinner())
            this.serieFlag = false;
            this.spinnerSerie = true;
            // this.store.dispatch(MostrarSpinner());
            setTimeout(() => {
                if (origen === 1) {
                    this.facturaForm.controls.serie.reset();
                };
                const lugarExp = this.ltsLugarExpedicion.find(x => x.id === e);
                console.log("lugarExp", lugarExp);
                this.ltsSerie.length = 0;
                if (lugarExp) {
                    this.facturaForm.controls.emisorCP.setValue(lugarExp.attributes.dir_direccion.data.attributes.codigoPostal);
                    this.ltsSerie = lugarExp?.attributes?.ope_direccion_series?.data
                }
                this.ltsLugarExpedicion.forEach(element => {
                    if (element.idLugarExpedicion == e) {
                        this.lugarExp = element
                    }
                });

                //// console.log("lugarExp", this.lugarExp);

                const body = {
                    idLugarExpedicion: Number(e)
                }

                if (this.ltsSerie.length == 0) {
                    this.serieFlag = false;
                }
                else {
                    this.serieFlag = true;
                }
                this.spinnerSerie = false;
                this.store.dispatch(OcultarSpinner());
            }, 1000);
        } catch (error) {
            // console.log('Error controlado');
            this.store.dispatch(OcultarSpinner());
        }
    }

    getAllCfdiForRelacion = value => {
        if (value) {
            const dataRelacionado = this.lstCfdiRelacionados.find(x => x.idCFDIRelacionado === value);
            // const body = {
            //     queryComplement: dataRelacionado.complementQuery,
            //     idCliente: this.facturaForm.controls.cliente.value,
            //     idOperacion: this.idOperacion
            // };
            // this.coalService.postService(`catalogo/getAllFacturasRelacionadas`, body).subscribe((res: any) => {
            //     if (res.err) {
            //         this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
            //         return this._snackBar.open('Error al traer los CFDI relacionados', 'OK', { duration: 3000 });
            //     } else if (res.excepcion) {
            //         this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
            //         return this._snackBar.open('Error al traer los CFDI relacionados', 'OK', { duration: 3000 });
            //     } else {
            //         this.store.dispatch(OcultarSpinner());
            //         if (res.recordsets[0].length > 0) {
            // this.allCfdiEncontrados = res.recordsets[0];
            //         } else {
            //             this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
            //             return this._snackBar.open('No se encontraron CDFI para relacionar', 'OK', { duration: 3000 });
            //         };
            //     };
            // }, (error: any) => {
            //     this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
            //     return this._snackBar.open('Error al traer los CFDI relacionados', 'OK', { duration: 3000 });
            // });
        }

        this.store.dispatch(OcultarSpinner());
    };

    agregarFolioManual = () => {
        const folio = this.facturaAdicionalesForm.value.folioManual;
        if (folio && this.isUUID(folio)) {
            const existeEnArreglo = this.contenedorCfdiRelacionados.some(item => item.cfdiRelacionados === folio);
            if (!existeEnArreglo) {
                const body = {
                    cfdiRelacionados: folio
                };
                this.contenedorCfdiRelacionados.push(body);
                this.facturaAdicionalesForm.controls.folioManual.reset();
                console.log(body);
            } else {
                console.error('El folio ya existe en el arreglo.');
                this._snackBar.open('El CDFI ya esta relacionado', 'OK', { duration: 3000 });
            }
        }
    };

    seleccionarRelacionados = (value, reload) => {
        // this.store.dispatch(MostrarSpinner());
        this.showCfdiManual = true
        this.allCfdiEncontrados = [];
        if (reload !== 1) {
            this.contenedorCfdiRelacionados = [];
        };
        const dataRelacionado = this.lstCfdiRelacionados.find(x => x.id === value);
        const body = {
            queryComplement: dataRelacionado.complementQuery,
            idCliente: this.facturaForm.controls.cliente.value,
            idOperacion: this.idOperacion
        };
        // this.coalService.postService(`catalogo/getAllFacturasRelacionadas`, body).subscribe((res: any) => {
        //     if (res.err) {
        //         this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
        //         return this._snackBar.open('Error al traer los CFDI relacionados', 'OK', { duration: 3000 });
        //     } else if (res.excepcion) {
        //         this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
        //         return this._snackBar.open('Error al traer los CFDI relacionados', 'OK', { duration: 3000 });
        //     } else {
        //         this.store.dispatch(OcultarSpinner());
        //         if (res.recordsets[0].length > 0) {
        //             this.allCfdiEncontrados = res.recordsets[0];
        //             this.showModalRelacionados(this.allCfdiEncontrados);
        //         } else {
        //             this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null)
        //             // // this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue([]);
        //             return this._snackBar.open('No se encontraron CDFI para relacionar', 'OK', { duration: 3000 });
        //         };
        //     };
        // }, (error: any) => {
        //     this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
        //     return this._snackBar.open('Error al traer los CFDI relacionados', 'OK', { duration: 3000 });
        // });
    };



    showModalRelacionados = data => {
        let newData = []
        if (this.contenedorCfdiRelacionados.length > 0) {
            newData = data.map(d => {
                const search = this.contenedorCfdiRelacionados.find(x => {
                    if (x.cfdiRelacionados === d.UUID) {
                        return true;
                    } else {
                        return false;
                    };
                });

                if (!search) {
                    return d
                };
            });
        } else {
            newData = data.map(d => {
                return d;
            });
        };

        const dataSend = {
            facturas: newData,
            title: 'Selecciona el CFDI que quieres relacionar'
        };
        const dialogRef = this.dialog.open(RelacionadosDialogComponent, {
            width: '90%',
            data: dataSend
        });
        dialogRef.afterClosed().subscribe(result => {
            let error;
            let onlyTotal = [{ id: 0, total: 0, formaPago: '' }]
            if (result[0].confirm === 1) {
                for (const relacion of result[0].allRelacionados) {
                    if (this.isUUID(relacion.UUID)) {
                        this.agregarRelacionadoData(relacion.UUID);
                    } else {
                        error = true;
                    };
                };
                setTimeout(() => {
                    for (const relacion of this.contenedorCfdiRelacionados) {
                        const data = this.allCfdiEncontrados.find(x => x.UUID == relacion.cfdiRelacionados);
                        if (data) {
                            if (data?.total > onlyTotal[0].total) {
                                onlyTotal[0].total = data?.total;
                                onlyTotal[0].id = data?.idFactura;
                                onlyTotal[0].formaPago = data?.formaPago;
                            };
                        };
                    };

                    if (this.facturaForm.controls.tipoFactura.value === 2) {//Solo Faturas
                        // this.facturaForm.controls.formaPago.setValue(onlyTotal[0].formaPago);
                    };
                    if (error) {
                        return this._snackBar.open('No todos los UUID se agregaron ya que no es valido', 'OK', { duration: 3000 });
                    };
                }, 500)
            } else {
                return this._snackBar.open('No se relaciono ningun CFDI', 'OK', { duration: 3000 });
            };
        });
    };

    agregarRelacionado() {
        const body = {
            cfdiRelacionados: ''
        };
        this.contenedorCfdiRelacionados.push(body);
    };

    eliminarRelacionado = index => {
        this.contenedorCfdiRelacionados.splice(index, 1);
        setTimeout(() => {
            if (this.facturaForm.controls.tipoFactura.value === 2) {
                let onlyTotal = [{ id: 0, total: 0, formaPago: '' }];
                for (const relacion of this.contenedorCfdiRelacionados) {
                    const data = this.allCfdiEncontrados.find(x => x.UUID == relacion.cfdiRelacionados);
                    if (data.total > onlyTotal[0].total) {
                        onlyTotal[0].total = data.total;
                        onlyTotal[0].id = data.idFactura;
                        onlyTotal[0].formaPago = data.formaPago;
                    };
                };
                // this.facturaForm.controls.formaPago.setValue(onlyTotal[0].formaPago);
            };
        }, 500);
    };

    changeDescripcion(event) {
        let descripcion = Number(event);
        if (descripcion > 0) {
            if (descripcion !== 1) {
                const index = this.lstObservaciones.filter(x => x.id === descripcion);
                this.facturaAdicionalesForm.controls.observaciones.setValue(index[0].attributes.observacion);
            } else {
                this.facturaAdicionalesForm.controls.observaciones.reset();
            };
            this.desObservacion = true;
        } else {
            this.desObservacion = false;
            this.facturaAdicionalesForm.controls.observaciones.setValue(null);
        }
    }

    changeRelacionados(event) {
        let relacionado = event.target.value;
        let validador = this.isUUID(relacionado);
        if (!validador) {
            this._snackBar.open('Favor de introducir un UUID válido', 'OK', { duration: 3000 });
            // setTimeout(() => this.contenedorCfdiRelacionados[index].cfdiRelacionados = '', 800);
        } else {
            // this.contenedorCfdiRelacionados[index].cfdiRelacionados = relacionado;
            console.log("this.contenedorCfdiRelacionados", this.contenedorCfdiRelacionados)
        }
        //// console.log(this.contenedorCfdiRelacionados);
    }

    isUUID(uuid) {
        let s = uuid;
        s = s.match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
        if (s === null) {
            return false;
        }
        return true;
    }

    GetCatalogoFacturacion() {
        this.store.dispatch(MostrarSpinner());
        const endpoints = [
            'cat-tipo-comprobantes',
            'cat-forma-pagos',
            'cat-metodo-pagos',
            'cat-monedas',
            'cat-fecha-emisiones',
            'cat-cfdi-relaciondos',
            'cat-forma-descuentos',
            'cat-objeto-impuestos',
            'cat-exportaciones'
        ];

        const promises = endpoints.map(endpoint => this.fetchData(endpoint));
        Promise.all(promises)
            .then(results => {

                this.lstTipoFactura = results[0];
                this.ltsFormaPago = results[1];
                this.ltsMetodoPago = results[2];
                this.ltsMetodoPagoAux = [];
                for (const item of this.ltsMetodoPago) {
                    this.ltsMetodoPagoAux.push({ id: item.id, clave: item.attributes.clave, nombre: item.attributes.nombre, active: false });
                }
                this.ltsMoneda = results[3];
                this.fechaEmisionValor = results[4];
                this.lstCfdiRelacionados = results[5];  
                this.ltsFormaDescuento = results[6];
                this.ltsObjetoImpuesto = results[7]
                this.lstExportacion = results[8]
                this.banderaActualizarFactura ? this.llenarFormularioForm() : this.store.dispatch(OcultarSpinner());

                if (this.tipo !== '0') {
                    // setTimeout(() => {
                    this.facturaForm.controls.tipoFactura.setValue(Number(this.tipo));
                    this.changeTipoFactura(Number(this.tipo))
                    // }, 2000);

                }
            })
            .catch(error => {
                console.log('Al menos una llamada falló', error);
                this.store.dispatch(OcultarSpinner());
            });

    }

    // Función para realizar la llamada a la API y devolver una promesa
    private fetchData(apiEndpoint: string): Promise<any> {
        // const fullEndpoint = apiEndpoint !== 'cat-tipo-comprobantes' ? `${apiEndpoint}?populate='*'` : `${apiEndpoint}?populate='*'&filters[portal][$eq]=true`;
        const fullEndpoint = apiEndpoint !== 'cat-tipo-comprobantes'
        ? `${apiEndpoint}?populate='*'&pagination[page]=1&pagination[pageSize]=5000`
        : `${apiEndpoint}?populate='*'&filters[portal][$eq]=true&pagination[page]=1&pagination[pageSize]=5000`;

        return new Promise((resolve, reject) => {
            this.srvcoal.getService(fullEndpoint).subscribe(
                (res: any) => {
                    if (res.err) {
                        console.log(`Error en ${apiEndpoint} *************** 1`);
                        reject(res.err);
                    } else {
                        resolve(res.data);
                    }
                },
                (error: any) => {
                    console.log(`Error en ${apiEndpoint} *************** 3`, error);
                    reject(error);
                }
            );
        });
    }



    curMetodoPago(e) {
        setTimeout(() => {
            this.ltsMetodoPago.forEach(element => {
                if (element.idMetodoPago == e) {
                    this.metodoPago = element
                };
            });
        }, 5000);

        // console.log("Esta es una entrada de edición", e);
    };

    curFormaPago(id: number = 0) {
        let fPago = this.ltsFormaPago.find(x => x.id == id);
        this.metodoPago = [];
        let PPD = this.ltsMetodoPagoAux.find(x => x.clave == 'PPD');
        let PPD_index = this.ltsMetodoPagoAux.findIndex(x => x.clave == 'PPD');
        let PUE = this.ltsMetodoPagoAux.find(x => x.clave == 'PUE');
        let PUE_index = this.ltsMetodoPagoAux.findIndex(x => x.clave == 'PUE');
        if (fPago?.attributes.clave == '99') {
            let valor = PPD?.id || 2;
            this.facturaForm.controls.metodoPago.setValue(valor);
            this.curMetodoPago(valor);
            this.ltsMetodoPagoAux[PPD_index].active = false;
            this.ltsMetodoPagoAux[PUE_index].active = true;
            //this.disabledMetodoPago = true;
            // console.log('99', 1);

        } else {
            let valor = PUE?.id || 1;
            this.facturaForm.controls.metodoPago.setValue(valor);
            this.ltsMetodoPagoAux[PPD_index].active = true;
            this.ltsMetodoPagoAux[PUE_index].active = false;
            //this.facturaForm.controls.metodoPago.reset(1);
            //this.disabledMetodoPago = false;
            // console.log("!=99", 2);
        };

        this.ltsFormaPago.forEach(element => {
            if (element.idFormaPago === id) {
                this.formaPago = element
            }
        });
    }

    curFormaPagoPV(e) {
        setTimeout(() => {
            this.ltsFormaPago.forEach(element => {
                if (element.idFormaPago === e) {
                    this.formaPago = element
                }
            });
        }, 5000);
    }

    curCliente(e) {
        if (this.facturaForm.controls.tipoFactura.value === 2) {
            this.facturaForm.controls.formaPago.setValue(1)
        };
        this.lstCliente.forEach(element => {
            if (element.id == e) {
                this.cliente = element
                // console.log('this.cliente', this.cliente);
                // this.facturaForm.controls.cliente.setValue(this.cliente.id)
                console.log('this.cliente', this.cliente.id);
                this.facturaForm.controls.cliente.patchValue(this.cliente.id);
                console.log(this.facturaForm.value);
                
            };
        });
    };

    clearCliente(){
        this.filteredClientes = this.lstCliente;
        this.cliente = null;
        this.clienteControl.reset();
    }

    // Lógica de filtrado de clientes basada en la entrada del usuario
    filterClientes(value: string) {
        const filterValue = value.toLowerCase();
        this.filteredClientes = this.lstCliente.filter(cliente =>
            cliente.attributes.nombre.toLowerCase().includes(filterValue) ||
            cliente.attributes.rfc.toLowerCase().includes(filterValue)
        );
    }

    GetProducto(opcion: number = 1) {
        this.store.dispatch(MostrarSpinner());
        this.lstProducto.length = 0;

        this.srvcoal.getService(`ope-empresas?fields=id&fields=razonSocial&filters[id][$eq]=${this.idEmpresa}
            &populate[pro_productos][populate]=*`)
            .subscribe((res: any) => {
                if (res.err) {
                    console.log("erro *************** 1")
                } else if (res.excepcion) {
                    console.log("erro *************** 2")
                } else {

                    this.lstProducto = res.data[0].attributes.pro_productos.data

                    this.store.dispatch(OcultarSpinner());




                    if (opcion == 2) {
                        setTimeout(() => {
                            this.selectProducto(this.NuevoProducto);
                            this.store.dispatch(OcultarSpinner());
                        }, 600);
                    }
                    else if (opcion == 3) {
                        this.cacelarProducto();

                        setTimeout(() => {
                            this.selectProducto(this.NuevoProducto);
                            this.store.dispatch(OcultarSpinner());
                        }, 600);
                    }
                    else {
                        this.store.dispatch(OcultarSpinner());
                    }
                    //     };
                    // }, (error: any) => {
                    //     this.store.dispatch(OcultarSpinner());
                    // });

                }
            }, (error: any) => {
                console.log("erro *************** 3", error)
            });
    };

    modificarCliente() {
        if (this.facturaForm.controls.cliente.value === undefined || this.facturaForm.controls.cliente.value === null || this.facturaForm.controls.cliente.value === '' || this.facturaForm.controls.cliente.value === 0)
            return this._snackBar.open('Favor de seleccionar un cliente', 'ok', {
                duration: 3000,
            });
        this.mostrarComponenteCliente = true;
        let index = this.lstCliente.findIndex(x => x.id === this.facturaForm.controls.cliente.value);
        let array = [];
        array.push(this.lstCliente[index]);
        this.arregloClienteSeleccionado = array;
        //// console.log(this.arregloClienteSeleccionado);
        console.log("modificar", {
            ...this.datosevent,
            idEmpresa: this.idEmpresa
        })
        this.openDialogNewCliente(
            {
                ...this.datosevent,
                mode: 2,
                idEmpresa: this.idEmpresa
            }
        );
    }

    invocarEventoCliente(e): void {
        this.mostrarComponenteCliente = false;
        //// console.log('e', e);
    }

    actualizarProductosForGrid() {
        const validacion = this.validaDatosProductos();
        if (!validacion.success) {
            this._snackBar.open(validacion.msg, 'ok', { duration: 10000, });
        } else {
            let indexBuscoObjetoProducto = this.productoSelecionados.findIndex(x => x.idProductoFac === Number(this.dataActualizacion.idProductoFac));

            const precio = this.agregarProductoForm.controls.precioUnitario.value;
            const cantidad = Number(this.agregarProductoForm.controls.cantidad.value) === 0 ? 1 : Number(this.agregarProductoForm.controls.cantidad.value);
            const descuento = Number(this.agregarProductoForm.controls.formaDescuento.value) === 1 ? 0 : Number(this.agregarProductoForm.controls.descuento.value);

            this.productoSelecionados[indexBuscoObjetoProducto].cantidad = cantidad;
            this.productoSelecionados[indexBuscoObjetoProducto].descuento = descuento;
            this.productoSelecionados[indexBuscoObjetoProducto].formaDescuento = Number(this.agregarProductoForm.controls.formaDescuento.value);
            //const indexFormaDescuento = this.ltsFormaDescuento.findIndex(x => x.idFormaDescuento === Number(this.agregarProductoForm.controls.formaDescuento.value));
            const indexFormaDescuento = this.ltsFormaDescuento.findIndex(x => x.id === Number(this.agregarProductoForm.controls.formaDescuento.value));
            const formaDescuento = this.ltsFormaDescuento[indexFormaDescuento];
            this.productoSelecionados[indexBuscoObjetoProducto].nombreFormaDescuento = formaDescuento?.attributes?.formaDescuento;
            this.productoSelecionados[indexBuscoObjetoProducto].cuentaPredial = this.cuentaPredialForm.get('cuentaPredial').value?.attributes?.cuentaPredial;
            // this.changeCantidad(Number(this.agregarProductoForm.controls.cantidad.value), indexBuscoObjetoProducto, 1);
            this.productoSelecionados[indexBuscoObjetoProducto].descripcion = this.agregarProductoForm.controls.descripcionProducto.value;
            this.productoSelecionados[indexBuscoObjetoProducto].precio = precio; //this.agregarProductoForm.controls.precioUnitario.value;
            this.productoSelecionados[indexBuscoObjetoProducto].total = this.total;
            this.productoSelecionados[indexBuscoObjetoProducto].subTotal = this.subtotal;
            this.productoSelecionados[indexBuscoObjetoProducto].ImpuestosLocales = this.impuestosLocales;
            this.sumarTotales();
            this.agregarProductoForm.reset();
            this.actulizarProducto = false;
            this.stateCtrl.setValue('');
            this.verForm = false;

            this.cuentaPredialForm.get('cuentaPredial').setValue(0);
        };
    };

    eliminar(e) {
        if (this.actulizarProducto)
            return this._snackBar.open('Favor de terminar edición de producto', 'OK', { duration: 3000 });

        let index = this.productoSelecionados.findIndex(x => x.idProductoFac === e.idProductoFac);
        let prod = this.productoSelecionados[index];

        if (prod.id != null) {
            this.productoSelecionadosEliminados.push(prod);
        }

        this.productoSelecionados.splice(index, 1);
        this.objetoGridConfiguration.Data = [...this.productoSelecionados];
        this.sumarTotales();
        if (this.banderaActualizarFactura)
            this.listadoProductosEliminados += String(e.idProductoFac) + ',';
    }

    modificar(e) {
        // console.log("modificar(e)", e);
        this.curProducto = e;
        this.dataActualizacion = e;
        setTimeout(() => this.llenarFormulario(e), 500);
    }

    llenarFormulario(e) {
        this.verForm = true;
        this.valorProducto = Number(e.idProducto);
        const dataProducto = this.lstProducto.find(x => x.id === this.valorProducto);
        this.curProductoCatalogo = dataProducto;
        this.curProducto = dataProducto;


        

        /*
                this.ivaProdSelect = dataProducto.attributes.cat_iva.data ? dataProducto.attributes.cat_iva.data.attributes.nombre:0 //dataProducto.valorIva;
                this.ivaRetProdSelect = dataProducto.attributes.cat_iva_ret.data ? dataProducto.attributes.cat_iva_ret.data.nombre:0;
                this.isrProdSelect = dataProducto.attributes.cat_isr.data ? dataProducto.attributes.cat_isr.data.nombre:0;
                this.IEPSProdSelect = dataProducto.valorIEPS;

                this.valueIvaProdSelect = Number(e.valIva.valor)
               //(e.subTotal-e.descuento)*e.valIva.valor;
                this.valueIvaRetProdSelect = Number(e.valIvaRet);
                this.valueIEPSProdSelect = Number(e.valIEPS);
                this.valueIsrProdSelect = Number(dataProducto.IEPSTasa ? e.valIEPS : 0) //Number(dataProducto.valISR);

                // this.valueIEPSProdSelectCuota = Number(dataProducto.IEPSTasa ? 0 : dataProducto.IEPSCuotaCuot);
                // this.IEPSProdSelectCuota = dataProducto.IEPSTasa ? '' : `IEPS ${this.valueIEPSProdSelectCuota * 100}%`;

        */

        this.ivaProdSelect = dataProducto.attributes.cat_iva.data.attributes.nombre;
        this.ivaRetProdSelect = dataProducto.attributes.cat_iva_ret.data ? dataProducto.attributes.cat_iva_ret.data.attributes.nombre : 0;
        this.isrProdSelect = (dataProducto.attributes.cat_isr.data) ? dataProducto.attributes.cat_isr.data.attributes.nombre : 0;
        this.valueIvaProdSelect = Number((dataProducto.attributes.cat_iva.data) ? dataProducto.attributes.cat_iva.data.attributes.valor : 0);
        this.valueIvaRetProdSelect = Number(dataProducto.attributes.cat_iva_ret.data ? dataProducto.attributes.cat_iva_ret.data.attributes.valor : 0);
        this.valueIsrProdSelect = Number(dataProducto.attributes.cat_isr.data ? dataProducto.attributes.cat_isr.data.attributes.valor : 0)

        this.IEPSProdSelect = (dataProducto.attributes.cat_iep.data) ? dataProducto.attributes.cat_iep.data.attributes.nombre : 0;
        this.valueIEPSProdSelect = Number(dataProducto.attributes.cat_iep.data === null ? 0 : dataProducto.attributes.cat_iep.data.attributes.valor);

        this.valueIEPSProdSelectCuota = Number(dataProducto.attributes.esTasa ? 0 : dataProducto.attributes.cuotaIeps);
        this.IEPSProdSelectCuota = dataProducto.IEPSTasa ? '' : `IEPS ${this.valueIEPSProdSelectCuota * 100}%`;

        this.impuestos = e.montoImpuestosTotal;
        this.subtotal = e.subTotal;
        this.subtotalProducto = this.subtotal;
        this.total = e.subTotal;
        this.descuento = e.descuento

        this.actulizarProducto = true;

        this.agregarProductoForm.controls.productoServicio.setValue(e.idProducto);
        this.agregarProductoForm.controls.cantidad.setValue(e.cantidad);
        this.agregarProductoForm.controls.formaDescuento.setValue(e.formaDescuento);
        this.agregarProductoForm.controls.descuento.setValue(e.descuento);
        this.agregarProductoForm.controls.precioUnitario.setValue(e.precio.toFixed(2));
        this.agregarProductoForm.controls.subTotal.setValue(e.subTotal.toFixed(2));
        this.agregarProductoForm.controls.total.setValue(e.total.toFixed(2));
        this.agregarProductoForm.controls.descripcionProducto.setValue(e.descripcion);
        this.agregarProductoForm.controls.precioUnitario.setValue(e.precio);
        this.codigoUnidadUpdate = e.claves[0];



        this.calcOnlyMontoImpuetos();

        // Configurar cuentas prediales
        this.setupCuentaPredialEdit(dataProducto, e.cuentaPredial);

        // this.lstCuentaPredial = null;
        // if (dataProducto.CuentaPredial) {
        //     const datos = JSON.parse(dataProducto.CuentaPredial);
        //     this.lstCuentaPredial = datos.map(item => item.cuentaPredial);
        //     if (this.lstCuentaPredial.length) {
        //         this.adicionalesProducto = true;
        //     }
        //     else {
        //         this.adicionalesProducto = false;
        //     }
        // }
        // else {
        //     this.adicionalesProducto = false;
        // }

        // this.cuentaPredialForm.get('cuentaPredial').setValue(e.cuentaPredial)
    }


    agregarProductosForGrid() { // this.descuento
        const validacion = this.validaDatosProductos();
        if (!validacion.success) {
            this._snackBar.open(validacion.msg, 'ok', { duration: 10000, });
        } else {
            const productoServicioValue = this.NuevoProducto;
            const cantidadValue = Number(this.agregarProductoForm.controls.cantidad.value);
            const formaDescuentaValue = Number(this.agregarProductoForm.controls.formaDescuento.value);
            let descuentoValue: any = Number(this.agregarProductoForm.controls.descuento.value)
            const precioUnitarioValue = (this.agregarProductoForm.controls.precioUnitario.value);
            const descripcionPorductoValue = this.agregarProductoForm.controls.descripcionProducto.value;

            // if (formaDescuentaValue === 2) {
            //     descuentoValue = `%${descuentoValue}`
            // };

            let indexBuscoObjetoProducto = this.productoSelecionados.findIndex(x => x.id === productoServicioValue);

            let body: any = {}
            let index = this.lstProducto.findIndex(x => x.id === productoServicioValue);
            // console.log("index", index, productoServicioValue);

            //let claves = [this.lstProducto[index].attributes.cat_unidad.data.attributes.clave + ' - ' + this.lstProducto[index].attributes.cat_unidad.data.attributes.descripcion];
            let claves = [this.lstProducto[index].attributes.cat_unidad.data.attributes.clave];
            let impuestos = [(this.lstProducto[index].attributes.cat_iep.data) ? this.lstProducto[index].attributes.cat_iep.data.attributes.valor : 0, (this.lstProducto[index].attributes.cat_isr.data) ? this.lstProducto[index].attributes.cat_isr.data.attributes.valor : 0, (this.lstProducto[index].attributes.cat_iva.data) ? this.lstProducto[index].attributes.cat_iva.data.attributes.valor : 0, this.lstProducto[index].attributes.cat_iva_ret.data ? this.lstProducto[index].attributes.cat_iva_ret.data.attributes.valor : 0];
            impuestos = impuestos.filter(impuesto => impuesto != null);
            // const total = (precioUnitarioValue * 1) + this.lstProducto[index].montoImpuestosTotal;
            const indexFormaDescuento = this.ltsFormaDescuento.findIndex(x => x.id === formaDescuentaValue);
            const formaDescuento = this.ltsFormaDescuento[indexFormaDescuento];
            const nombreFormaDescuento = formaDescuento?.attributes?.formaDescuento;

            body = {
                idProductoFac: this.productoSelecionados.length + 1,
                idProducto: productoServicioValue,
                cantidad: cantidadValue === 0 ? 1 : cantidadValue,
                descripcion: descripcionPorductoValue,//this.lstProducto[index].descripcion,
                precio: precioUnitarioValue,
                subTotal: this.subtotal * 1,//precioUnitarioValue * 1,
                total: this.total,
                descuento: formaDescuentaValue === 1 ? 0 : descuentoValue,
                descuentoValue: descuentoValue,

                claves: claves,
                impuestos: impuestos,
                nombreFormaDescuento: nombreFormaDescuento,
                formaDescuento: formaDescuentaValue,
                // =============== COMO SE LLENA?? ==============
                montoImpuestosTotal: 0, //this.lstProducto[index].montoImpuestosTotal,

                valIva: (this.lstProducto[index].attributes.cat_iva.data) ? this.lstProducto[index].attributes.cat_iva.data.attributes.valor : 0,
                valIvaRet: this.lstProducto[index].attributes.cat_iva_ret.data ? this.lstProducto[index].attributes.cat_iva_ret.data.attributes.valor : 0,

                valIEPS: (this.lstProducto[index].attributes.cat_iep.data) ? this.lstProducto[index].attributes.cat_iep.data.attributes.valor : 0,
                valISR: (this.lstProducto[index].attributes.cat_isr.data) ? this.lstProducto[index].attributes.cat_isr.data.attributes.valor : 0,

                iva: (this.lstProducto[index].attributes.cat_iva.data) ? this.lstProducto[index].attributes.cat_iva.data.attributes.descripcion : '',
                ivaRet: this.lstProducto[index].attributes.cat_iva_ret.data ? this.lstProducto[index].attributes.cat_iva_ret.data.attributes.descripcion : '',

                ISR: (this.lstProducto[index].attributes.cat_isr.data) ? this.lstProducto[index].attributes.cat_isr.data.attributes.descripcion : '',

                IEPSTasaCat: (this.lstProducto[index].attributes.cat_iep.data) ? this.lstProducto[index].attributes.cat_iep.data.attributes.valor : 0,
                IEPSTasa: this.lstProducto[index].attributes.esTasa,
                IEPSCuota: this.lstProducto[index].attributes.esTasa ? false : true,
                IEPSCuotaCuot: this.lstProducto[index].attributes.cuotaIeps,

                existeRegistrado: 0,
                ImpuestosLocalesProducto: this.lstProducto[index].attributes.pro_impuesto_locals.data,
                ObjetoImpuesto: this.lstProducto[index].attributes.cat_objeto_impuesto.data.attributes.valor,
                lblObjetoImpuesto: this.lstProducto[index].attributes.cat_objeto_impuesto.data.attributes.nombre,
                claveSat: this.lstProducto[index].attributes.cat_clave_sat.data.attributes.clave,
                codigoUnidad: this.lstProducto[index].attributes.cat_unidad.data.attributes.clave,
                Unidad: this.lstProducto[index].attributes.cat_unidad.data.attributes.descripcion,
                cuentaPredial: this.cuentaPredialForm.get('cuentaPredial').value?.attributes?.cuentaPredial,

                ImpuestosLocales: this.impuestosLocales
            };

            console.log('Producto', body);
            this.cuentaPredialForm.get('cuentaPredial').setValue(0);
            this.cuentaPredialForm.controls.cuentaPredial.markAsUntouched();

            this.productoSelecionados.push(body);
            this.objetoGridConfiguration.Data = [...this.productoSelecionados];

            this.sharedService.productos(this.productoSelecionados);
            // ======= AM DEJO COMENTADO PORQUE NO TRAIGO EL SUMTOTALES DE TABLA==
            this.sumarTotales();
            this.agregarProductoForm.reset();
            this.stateCtrl.setValue('');
            this.descuento = 0;
            this.verForm = false;

            console.log('this.objetoGridConfiguration', this.objetoGridConfiguration.Columns, this.objetoGridConfiguration.Data);
        };
    };

    validaDatosProductos = () => {
        if (this.descripcionRule?.obligatory && (this.agregarProductoForm.controls.descripcionProducto.value === '' || this.agregarProductoForm.controls.descripcionProducto.value === null || this.agregarProductoForm.controls.descripcionProducto.value === undefined)) {
            return { success: false, msg: 'Favor de agregar la descripcion del producto' };
        };
        if (this.cantidadRule?.obligatory && (this.agregarProductoForm.controls.cantidad.value === '' || this.agregarProductoForm.controls.cantidad.value === 0 || this.agregarProductoForm.controls.cantidad.value === null || this.agregarProductoForm.controls.cantidad.value === undefined) || this.agregarProductoForm.controls.cantidad.errors !== null) {
            return { success: false, msg: 'Favor de seleccionar una cantidad de productos' };
        };
        if (this.valorUnitarioRule?.obligatory && (this.agregarProductoForm.controls.precioUnitario.value === '' || this.agregarProductoForm.controls.precioUnitario.value === 0 || this.agregarProductoForm.controls.precioUnitario.value === null || this.agregarProductoForm.controls.precioUnitario.value === undefined)) {
            return { success: false, msg: 'Favor de colocar un precio al producto' };
        };
        if (this.agregarProductoForm.controls.formaDescuento.value === '' || this.agregarProductoForm.controls.formaDescuento.value === null || this.agregarProductoForm.controls.formaDescuento.value === undefined) {
            return { success: false, msg: 'Favor de seleccionar la forma de descuento' };
        };
        if (this.descuentoRule?.obligatory && (this.agregarProductoForm.controls.descuento.value === '' || this.agregarProductoForm.controls.descuento.value === null || this.agregarProductoForm.controls.descuento.value === undefined) || this.agregarProductoForm.controls.descuento.errors !== null) {
            return { success: false, msg: 'Favor de colocar la cantidad a descontar' };
        };
        if (this.adicionalesProducto && !this.cuentaPredialForm.controls.cuentaPredial.valid) {
            return { success: false, msg: 'Favor de seleccionar una cuenta predial' };
        }

        return { success: true, msg: '' };
    };

    cacelarProducto() {
        this.curProducto = [];
        this.actulizarProducto = false;
        this.agregarProductoForm.reset();
        this.stateCtrl.setValue('');
        this.verForm = false;
    }

    selectProductoEnter() {

    }

    // selectProducto(valor) {
    //     this.verForm = true;
    //     this.valorProducto = 0;
    //     this.valorProducto = Number(valor);
    //     const dataProducto = this.lstProducto.find(x => x.id === this.valorProducto);
    //     this.curProducto = dataProducto;
    //     this.NuevoProducto = this.curProducto.id;

    //     this.ivaProdSelect = dataProducto.attributes.cat_iva.data.attributes.nombre;
    //     this.ivaRetProdSelect = dataProducto.attributes.cat_iva_ret.data ? dataProducto.attributes.cat_iva_ret.data.attributes.nombre : 0;
    //     this.isrProdSelect = (dataProducto.attributes.cat_isr.data) ? dataProducto.attributes.cat_isr.data.attributes.nombre : 0;
    //     this.valueIvaProdSelect = Number((dataProducto.attributes.cat_iva.data) ? dataProducto.attributes.cat_iva.data.attributes.valor : 0);
    //     this.valueIvaRetProdSelect = Number(dataProducto.attributes.cat_iva_ret.data ? dataProducto.attributes.cat_iva_ret.data.attributes.valor : 0);
    //     this.valueIsrProdSelect = Number(dataProducto.attributes.cat_isr.data ? dataProducto.attributes.cat_isr.data.attributes.valor : 0)

    //     this.IEPSProdSelect = (dataProducto.attributes.cat_iep.data) ? dataProducto.attributes.cat_iep.data.attributes.nombre : 0;
    //     this.valueIEPSProdSelect = Number(dataProducto.attributes.cat_iep.data === null ? 0 : dataProducto.attributes.cat_iep.data.attributes.valor);

    //     this.actulizarProducto = false;

    //     this.subtotal = dataProducto.attributes.precioUnitario;
    //     this.subtotalProducto = this.subtotal;
    //     this.total = dataProducto.attributes.precioUnitario;
    //     this.valueIEPSProdSelectCuota = Number(dataProducto.attributes.esTasa ? 0 : dataProducto.attributes.cuotaIeps);
    //     this.IEPSProdSelectCuota = dataProducto.IEPSTasa ? '' : `IEPS ${this.valueIEPSProdSelectCuota * 100}%`;


    //     this.agregarProductoForm.controls.subTotal.setValue(this.subtotal.toFixed(2));
    //     this.agregarProductoForm.controls.precioUnitario.setValue(dataProducto.attributes.precioUnitario);
    //     this.agregarProductoForm.controls.total.setValue(this.total.toFixed(2));
    //     this.agregarProductoForm.controls.formaDescuento.setValue(0);
    //     this.agregarProductoForm.controls.descuento.setValue(0);
    //     this.agregarProductoForm.controls.cantidad.setValue(1);
    //     this.agregarProductoForm.controls.descripcionProducto.setValue(dataProducto.attributes.descripcion);

    //     this.lstCuentaPredial = dataProducto?.attributes?.pro_cuenta_predials?.data;
    //     this.adicionalesProducto = this.lstCuentaPredial.length > 0;
    //     setTimeout(() => {
    //         if(this.lstCuentaPredial.length == 1){
    //             this.cuentaPredialForm.get('cuentaPredial').setValue(this.lstCuentaPredial[0].id);
    //             this.cdr.detectChanges();  // Forzar la detección de cambios
    //         }
    //         console.log('this.cuentaPredialForm',this.cuentaPredialForm,this.cuentaPredialForm.value);
    //     }, 500);

    //     //IEPSTasa
    //     this.calcOnlyMontoImpuetos();
    // };

    //#region selectProducto
    selectProducto(valor) {
        console.log('--------');
        console.log('PRODUCTO');
        console.log(valor);
        console.log('--------');
    
        this.verForm = true;
        this.valorProducto = 0;
        this.valorProducto = Number(valor.id);
        const dataProducto_ = valor;
    
        this.curProducto = dataProducto_;
        this.NuevoProducto = this.curProducto.id;
    
        const attributes = dataProducto_.attributes || {};
    
        this.ivaProdSelect = attributes.cat_iva?.data?.attributes?.nombre ?? null;
        this.valueIvaProdSelect = Number(attributes.cat_iva?.data?.attributes?.valor ?? 0);
    
        this.ivaRetProdSelect = attributes.cat_iva_ret?.data?.attributes?.nombre ?? null;
        this.valueIvaRetProdSelect = Number(attributes.cat_iva_ret?.data?.attributes?.valor ?? 0);
    
        this.isrProdSelect = attributes.cat_isr?.data?.attributes?.nombre ?? null;
        this.valueIsrProdSelect = Number(attributes.cat_isr?.data?.attributes?.valor ?? 0);
    
        this.IEPSProdSelect = attributes.cat_iep?.data?.attributes?.nombre ?? null;
        this.valueIEPSProdSelect = Number(attributes.cat_iep?.data?.attributes?.valor ?? 0);
    
        this.valueIEPSProdSelectCuota = Number(attributes.esTasa ? 0 : attributes.cuotaIeps ?? 0);
        this.IEPSProdSelectCuota = attributes.esTasa ? '' : `IEPS ${this.valueIEPSProdSelectCuota * 100}%`;
    
        this.actulizarProducto = false;
    
        this.subtotal = attributes.precioUnitario ?? 0;
        this.subtotalProducto = this.subtotal;
        this.total = attributes.precioUnitario ?? 0;
    
        this.agregarProductoForm.controls.subTotal.setValue(this.subtotal.toFixed(2));
        this.agregarProductoForm.controls.precioUnitario.setValue(attributes.precioUnitario ?? 0);
        // Mostrar formulario y establecer el producto seleccionado
        this.verForm = true;
        this.valorProducto = Number(valor);
    
        // Buscar el producto seleccionado
        const dataProducto = this.lstProducto.find(x => x.id === this.valorProducto);
        if (!dataProducto) {
            console.error('Producto no encontrado');
            return;
        }
    
        // Asignar producto actual
        this.curProducto = dataProducto;
        this.NuevoProducto = this.curProducto.id;
    
        // Configurar atributos del producto
        this.setupAttributes(dataProducto);
    
        // Configurar formulario
        this.setupForm(dataProducto);
    
        // Configurar cuentas prediales
        this.setupCuentaPredial(dataProducto);
    
        // Calcular impuestos y montos
        // this.calcOnlyMontoImpuetos();
    }
    
    
    setupAttributes(dataProducto) {
        const attributes = dataProducto.attributes;
    
        // Configurar IVA, ISR y IEPS
        this.ivaProdSelect = attributes.cat_iva?.data?.attributes?.nombre ?? 0;
        this.ivaRetProdSelect = attributes.cat_iva_ret?.data?.attributes?.nombre ?? 0;
        this.isrProdSelect = attributes.cat_isr?.data?.attributes?.nombre ?? 0;
        this.valueIvaProdSelect = Number(attributes.cat_iva?.data?.attributes?.valor ?? 0);
        this.valueIvaRetProdSelect = Number(attributes.cat_iva_ret?.data?.attributes?.valor ?? 0);
        this.valueIsrProdSelect = Number(attributes.cat_isr?.data?.attributes?.valor ?? 0);
    
        // Configurar IEPS
        this.IEPSProdSelect = attributes.cat_iep?.data?.attributes?.nombre ?? 0;
        this.valueIEPSProdSelect = Number(attributes.cat_iep?.data?.attributes?.valor ?? 0);
    
        // Configurar IEPS por cuota
        this.valueIEPSProdSelectCuota = Number(attributes.esTasa ? 0 : attributes.cuotaIeps);
        this.IEPSProdSelectCuota = attributes.esTasa ? '' : `IEPS ${this.valueIEPSProdSelectCuota * 100}%`;
    
        // Configurar subtotal y total
        this.subtotal = attributes.precioUnitario;
        this.subtotalProducto = this.subtotal;
        this.total = attributes.precioUnitario;
    
        // Desactivar actualización del producto por defecto
        this.actulizarProducto = false;
    }

    setupForm(dataProducto) {
        const attributes = dataProducto.attributes;
    
        // Actualizar controles del formulario
        this.agregarProductoForm.controls.subTotal.setValue(this.subtotal.toFixed(2));
        this.agregarProductoForm.controls.precioUnitario.setValue(attributes.precioUnitario);
        this.agregarProductoForm.controls.total.setValue(this.total.toFixed(2));
        this.agregarProductoForm.controls.formaDescuento.setValue(0);
        this.agregarProductoForm.controls.descuento.setValue(0);
        this.agregarProductoForm.controls.cantidad.setValue(1);
        this.agregarProductoForm.controls.descripcionProducto.setValue(attributes.descripcion ?? '');
    
        this.lstCuentaPredial = attributes.pro_cuenta_predials?.data ?? [];
        this.adicionalesProducto = this.lstCuentaPredial.length > 0;
    
        this.calcOnlyMontoImpuetos();
    // }
        this.agregarProductoForm.controls.descripcionProducto.setValue(attributes.descripcion);
    }
    
    setupCuentaPredial(dataProducto) {
        this.lstCuentaPredial = dataProducto?.attributes?.pro_cuenta_predials?.data ?? [];
        this.adicionalesProducto = this.lstCuentaPredial.length > 0;
    
        if (this.lstCuentaPredial.length === 1) {
            // Preseleccionar automáticamente la única cuenta predial
            this.cuentaPredialForm.get('cuentaPredial').setValue(this.lstCuentaPredial[0]);
        } else {
            // Si hay más de una opción, dejar el valor como null
            this.cuentaPredialForm.get('cuentaPredial').setValue(null);
        }
    
        this.cdr.detectChanges();
    }

    setupCuentaPredialEdit(dataProducto, cuentaPredial) {
        this.lstCuentaPredial = dataProducto?.attributes?.pro_cuenta_predials?.data ?? [];
        this.adicionalesProducto = this.lstCuentaPredial.length > 0;
    
        if (this.lstCuentaPredial.length === 1) {
            // Preseleccionar automáticamente la única cuenta predial
            this.cuentaPredialForm.get('cuentaPredial').setValue(this.lstCuentaPredial[0]);
        } else {
            // Si hay más de una opción, dejar el valor como null
            const result = this.lstCuentaPredial.find(node => node.attributes.cuentaPredial === cuentaPredial);
            this.cuentaPredialForm.get('cuentaPredial').setValue(result);
        }
    
        this.cdr.detectChanges();
    }
    
    
    //#endregion


    calcOnlyMontoImpuetos = () => {
        this.ImpuestosTotalesProducto = 0;
        this.lastValueIvaProdSelect = this.total * (this.valueIvaProdSelect ?? 0);
        this.lastValueIvaRetProdSelect = this.total * (this.valueIvaRetProdSelect ?? 0);
        this.lastValueIsrProdSelect = this.total * (this.valueIsrProdSelect ?? 0);
        this.lastValueIEPSProdSelect = this.total * (this.valueIEPSProdSelect ?? 0);
        this.lastValueIEPSProdSelectCuota = this.total * (this.valueIEPSProdSelectCuota ?? 0);
        /*this.total = this.total*/
    
        this.impuestosLocales = [];
    
        // Cálculo de impuestos locales
        if ((this.curProducto?.attributes?.pro_impuesto_locals?.data?.length ?? 0) > 0) {
            //     console.log("this.curProducto.ImpuestosLocales", this.curProducto.ImpuestosLocales, JSON.parse(this.curProducto.ImpuestosLocales));
    
            const impuestosLocales = [];
    
            let impLoc = this.curProducto.attributes.pro_impuesto_locals.data;
            impLoc.forEach(imp => {
                let element = imp.attributes;
                let tipo_impuesto = element.cat_tipo_impuesto?.data;
                let importeImpuesto = 0; // this.total;
    
                if (element.monto == 0 || element.monto === undefined || element.monto === null || element.monto == "") {
                    if (element.tasa > 0) {
                        importeImpuesto = this.total * element.tasa;
                    }
                    else {
                        importeImpuesto = 0;
                    }
                }
                else {
                    importeImpuesto = element.monto;
                }
    
                if (parseInt(tipo_impuesto?.id ?? '0') == 1) {
                    this.ImpuestosTotalesProducto = this.ImpuestosTotalesProducto - importeImpuesto;
                }
                else if (parseInt(tipo_impuesto?.id ?? '0') == 2) {
                    this.ImpuestosTotalesProducto = this.ImpuestosTotalesProducto + importeImpuesto;
                }
    
                impuestosLocales.push({
                    id: imp.id,
                    nombre: element.nombre ?? '',
                    tasa: element.tasa ?? 0,
                    monto: element.monto ?? 0,
                    tipo: tipo_impuesto?.id ?? 0, //.idTipoImpuestoRetencion,
                    importeImpuesto: importeImpuesto
                });
            });
    
            this.impuestosLocales = impuestosLocales;
        } else {
            this.ImpuestosTotalesProducto = 0;
            this._snackBar.open('No se encontraron impuestos locales', 'ok', { duration: 3000, });
        }
    
        if (this.curProducto?.attributes?.cat_objeto_impuesto?.data?.attributes?.valor != '02') {
            this.lastValueIvaProdSelect = 0;
            this.lastValueIvaRetProdSelect = 0;
            this.lastValueIsrProdSelect = 0;
            this.lastValueIEPSProdSelect = 0;
            this.lastValueIEPSProdSelectCuota = 0;
            this.ImpuestosTotalesProducto = 0;
            this.impuestosLocales = [];
        }
    
        // console.log("antes", this.total, this.ImpuestosTotalesProducto);
    
        this.totalImpuestos = (this.lastValueIvaProdSelect - this.lastValueIvaRetProdSelect - this.lastValueIsrProdSelect + this.lastValueIEPSProdSelect + this.ImpuestosTotalesProducto + this.lastValueIEPSProdSelectCuota);
        this.total += this.totalImpuestos;
        this.agregarProductoForm.controls.total.setValue(this.total.toFixed(2));
        // console.log("despues", this.total);
    };

    agregarProductos(e) {
        //// console.log(e);
        let indexBuscoObjetoProducto = this.productoSelecionados.findIndex(x => x.idProducto === Number(e));
        //// console.log(indexBuscoObjetoProducto);
        if (indexBuscoObjetoProducto >= 0)
            return this._snackBar.open('Ya has seleccionado este producto', 'ok', { duration: 3000, });
        let body: any = {}
        let index = this.lstProducto.findIndex(x => x.idClienteProducto === Number(e));
        let claves = ['Clave producto: ' + this.lstProducto[index].claveSat, 'Clave unidad:         ' + this.lstProducto[index].codigoUnidad];
        let impuestos = [this.lstProducto[index].valorIEPS, this.lstProducto[index].valorISR, this.lstProducto[index].valorIva, this.lstProducto[index].valorIvaRet];
        impuestos = impuestos.filter(impuesto => impuesto != null);
        const total = (this.lstProducto[index].precioUnitario * 1) + this.lstProducto[index].montoImpuestosTotal;
        body = {
            idProducto: e,
            cantidad: 1,
            descripcion: this.lstProducto[index].descripcion,
            precio: this.lstProducto[index].precioUnitario,
            subTotal: this.lstProducto[index].precioUnitario * 1,
            total: total,
            descuento: 0,
            claves: claves,
            impuestos: impuestos,
            formaDescuento: 1,
            montoImpuestosTotal: this.lstProducto[index].montoImpuestosTotal,
            valIva: this.lstProducto[index].valIva,
            valIvaRet: this.lstProducto[index].valIvaRet,
            valIEPS: this.lstProducto[index].valIEPS,
            valISR: this.lstProducto[index].valISR,
            iva: this.lstProducto[index].iva,
            ivaRet: this.lstProducto[index].ivaRet,
            IEPSTasaCat: this.lstProducto[index].IEPSTasaCat,
            ISR: this.lstProducto[index].ISR,
            IEPSTasa: this.lstProducto[index].IEPSTasa,
            IEPSCuota: this.lstProducto[index].IEPSCuota,
            IEPSCuotaCuot: this.lstProducto[index].IEPSCuotaCuot
        }
        this.productoSelecionados.push(body);
        this.datosTabla1.renderRows();
        this.sumarTotales();
        //// console.log(body);
        //// console.log(this.productoSelecionados);

    }

    formProducto() {
        this.facturaForm = this.fb.group({
            cliente: new FormControl(0, Validators.required),
            tipoFactura: new FormControl(0, Validators.required),
            serie: new FormControl('', Validators.required),
            lugarExpedicion: new FormControl('', Validators.required),
            formaPago: new FormControl(1, Validators.required),
            metodoPago: new FormControl(0, Validators.required),
            emisorRSocial: new FormControl('', Validators.required),
            emisorCP: new FormControl('', Validators.required),
        })
    }

    DatosAdicionales() {
        this.datosAdicionalesContador++;
        if (this.datosAdicionalesContador % 2) {
            this.datosAdicionales = true;
        } else {
            this.datosAdicionales = false;
        }
    }

    changeCantidadForm(event) {
        let cantidad = Number(event.target.value);
        this.subtotal = parseFloat(this.agregarProductoForm.controls.precioUnitario.value) * cantidad;
        this.subtotalProducto = this.subtotal;
        this.total = parseFloat(this.agregarProductoForm.controls.precioUnitario.value) * cantidad;
        this.agregarProductoForm.controls.subTotal.setValue(this.subtotal.toFixed(2));
        if (this.agregarProductoForm.controls.formaDescuento.value > 1) {
            this.changeDescuentoForm(this.agregarProductoForm.controls.descuento.value);
        } else {
            this.calcularSinDescuentoForm();
        };
    };

    changePrecioUnitarioForm(event) {
        let precioUnitario = parseFloat(event.target.value);
        this.subtotal = precioUnitario * Number(this.agregarProductoForm.controls.cantidad.value);
        this.subtotalProducto = this.subtotal;
        this.total = precioUnitario * Number(this.agregarProductoForm.controls.cantidad.value);
        this.agregarProductoForm.controls.subTotal.setValue(this.subtotal.toFixed(2));
        if (this.agregarProductoForm.controls.formaDescuento.value > 1) {
            this.changeDescuentoForm(this.agregarProductoForm.controls.descuento.value);
        } else {
            this.calcularSinDescuentoForm();
        };
    };

    calcularSinDescuento(index) {
        const precioCantidad = this.productoSelecionados[index].cantidad * this.productoSelecionados[index].precio;
        const valorImpuesto = (precioCantidad * this.productoSelecionados[index].valIva) + (precioCantidad * this.productoSelecionados[index].valIvaRet) + (this.productoSelecionados[index].IEPSTasa === true && this.productoSelecionados[index].IEPSTasaCat !== null && this.productoSelecionados[index].IEPSCuotaCuot === null ? precioCantidad * this.productoSelecionados[index].valIEPS : precioCantidad * this.productoSelecionados[index].IEPSCuotaCuot) + (precioCantidad * this.productoSelecionados[index].valISR);
        this.productoSelecionados[index].montoImpuestosTotal = valorImpuesto;
        this.productoSelecionados[index].total = ((parseFloat(this.productoSelecionados[index].precio) * this.productoSelecionados[index].cantidad) - parseFloat(this.productoSelecionados[index].descuento)) + this.productoSelecionados[index].montoImpuestosTotal;
        this.sumarTotales();
        // this.productoSelecionados[index].total = this.productoSelecionados[index].total.toFixed(2);
    }

    calcularSinDescuentoForm() {
        this.calcOnlyMontoImpuetos();
    };

    formaDescuento(event, index) {
        let formaDescuento = event;
        this.productoSelecionados[index].formaDescuento = Number(formaDescuento);
        if (Number(formaDescuento) === 1) {
            this.productoSelecionados[index].descuento = 0;
            this.calcularSinDescuento(index);

        } else {
            // this.changeDescuento(String(this.productoSelecionados[index].descuento), index, 1);
        }
    }

    formaDescuentoForm(event) {
        let formaDescuento = event;
        this.subtotal = Number(this.agregarProductoForm.controls.precioUnitario.value) * Number(this.agregarProductoForm.controls.cantidad.value);
        this.subtotalProducto = this.subtotal;
        this.total = Number(this.agregarProductoForm.controls.precioUnitario.value) * Number(this.agregarProductoForm.controls.cantidad.value);
        if (Number(formaDescuento) === 1) {
            this.descuento = 0;
            this.agregarProductoForm.controls.descuento.setValue(0);
            this.calcularSinDescuentoForm();
        } else {
            this.agregarProductoForm.controls.descuento.setValue(0);
            this.descuento = 0;
            this.changeDescuentoForm(this.agregarProductoForm.controls.descuento.value);
        };
    };

    changeDescuentoForm(dato) {
        let descuento = dato;
        this.subtotal = Number(this.agregarProductoForm.controls.precioUnitario.value) * Number(this.agregarProductoForm.controls.cantidad.value);
        this.total = Number(this.agregarProductoForm.controls.precioUnitario.value) * Number(this.agregarProductoForm.controls.cantidad.value);
        this.subtotalProducto = this.subtotal;

        let index = this.lstProducto.findIndex(x => x.idClienteProducto === this.valorProducto);
        const dataProducto = this.lstProducto.find(x => x.idClienteProducto === this.valorProducto);
        switch (this.agregarProductoForm.controls.formaDescuento.value) {
            case 0:
                this.agregarProductoForm.controls.descuento.setValue(0);
                this._snackBar.open('Favor de seleccionar una forma de descuento', 'ok', { duration: 3000, });
                break;
            case 1:
                // descuento por porcentaje
                if (descuento < 0 || parseFloat(descuento) >= 101) {
                    this.agregarProductoForm.controls.descuento.setValue(0);
                    return this._snackBar.open('Ingrese un valor inferior a 100%', 'ok', { duration: 3000, });
                }

                // this.subtotal = parseFloat(this.agregarProductoForm.controls.precioUnitario.value) * Number(this.agregarProductoForm.controls.cantidad.value);
                // this.agregarProductoForm.controls.subTotal.setValue(this.subtotal.toFixed(2));
                let descuentoDecimal = parseFloat(descuento) / 100;
                // let valorDescuento = (parseFloat(this.agregarProductoForm.controls.precioUnitario.value) * parseFloat(this.agregarProductoForm.controls.cantidad.value)) * descuentoDecimal;
                let valorDescuento = this.total * descuentoDecimal;
                // const precioCantidad = (this.agregarProductoForm.controls.cantidad.value * this.agregarProductoForm.controls.precioUnitario.value) - valorDescuento;
                this.total = this.total - valorDescuento;

                // Este codigo funcinaba
                // this.subtotal = this.subtotal - valorDescuento;
                // Se corrige con este otro
                this.subtotal = this.subtotal;

                // const valorImpuesto = (precioCantidad * this.lstProducto[index].valIva) + (precioCantidad * this.lstProducto[index].valIvaRet) + (this.lstProducto[index].IEPSTasa === true && this.lstProducto[index].IEPSTasaCat !== null && this.lstProducto[index].IEPSCuotaCuot === null ? precioCantidad * this.lstProducto[index].valIEPS : precioCantidad * this.lstProducto[index].IEPSCuotaCuot) + (precioCantidad * this.lstProducto[index].valISR);
                // this.impuestos = valorImpuesto;
                // this.total = ((parseFloat(this.agregarProductoForm.controls.precioUnitario.value) * parseFloat(this.agregarProductoForm.controls.cantidad.value)) - valorDescuento) + this.impuestos;
                this.agregarProductoForm.controls.subTotal.setValue(this.subtotal.toFixed(2));
                this.descuento = valorDescuento;
                this.calcOnlyMontoImpuetos();
                break;
            case 2:
                // descuento por monto
                // const precioCantidad1 = (this.agregarProductoForm.controls.cantidad.value * this.agregarProductoForm.controls.precioUnitario.value) - parseFloat(descuento);
                // const valorImpuesto1 = (precioCantidad1 * this.lstProducto[index].valIva) + (precioCantidad1 * this.lstProducto[index].valIvaRet) + (this.lstProducto[index].IEPSTasa === true && this.lstProducto[index].IEPSTasaCat !== null && this.lstProducto[index].IEPSCuotaCuot === null ? precioCantidad1 * this.lstProducto[index].valIEPS : precioCantidad1 * this.lstProducto[index].IEPSCuotaCuot) + (precioCantidad1 * this.lstProducto[index].valISR);
                // this.impuestos = valorImpuesto1;
                // let res = ((parseFloat(this.agregarProductoForm.controls.precioUnitario.value) * parseFloat(this.agregarProductoForm.controls.cantidad.value)) - parseFloat(descuento)) + this.impuestos;
                // if (res <= 0)
                //     return this._snackBar.open('Ingrese un valor menor', 'ok', { duration: 3000, });
                // this.subtotal = parseFloat(this.agregarProductoForm.controls.precioUnitario.value) * Number(this.agregarProductoForm.controls.cantidad.value);
                // this.agregarProductoForm.controls.subTotal.setValue(this.subtotal.toFixed(2));
                // this.total = res;
                // this.agregarProductoForm.controls.total.setValue(this.total.toFixed(2));
                if (descuento < 0 || (this.total - descuento) <= 0) {
                    return this._snackBar.open('Asegurate de ingresar un descuento valido', 'ok', { duration: 3000, });
                } else {
                    this.total = this.total - descuento;

                    // Este codigo funcionaba antes
                    // this.subtotal = this.subtotal - descuento;
                    // Se corrige con este
                    this.subtotal = this.subtotal;

                    this.descuento = descuento;
                    this.agregarProductoForm.controls.subTotal.setValue(this.subtotal.toFixed(2));
                    this.calcOnlyMontoImpuetos();
                };
                break;
            default:
                break;
        };
    };


    ////// Refactorizacion
    sumarTotales() {
        // Reiniciar las sumatorias
        this.resetSumatorias();

        this.productoSelecionados.forEach(producto => {
            this.actualizarSumatoriasPorProducto(producto);
        });

        this.sumatoriasTotales.forEach(x => {
            x.sumatoria = parseFloat(x.sumatoria.toFixed(2));
        });

        // Controlar los totales de los impuestos locales
        this.calcularImpuestosLocalesTotales();

        // Calcular sumatoria de descuentos
        this.sumatoriaDescuento = this.productoSelecionados.reduce((total, producto) => {
            return total + (producto.descuento || 0);
        }, 0);

        // Actualizar la sumatoria sin descuentos
        this.sumatoriaSinDescuento = parseFloat(this.sumatoriasTotales.find(x => x.columna === "Subtotal").sumatoria);
    }

    // Función para reiniciar las sumatorias
    resetSumatorias() {
        this.sumatoriasTotales.forEach(x => {
            x.sumatoria = 0;
        });
    }

    // Función para actualizar las sumatorias de un producto
    actualizarSumatoriasPorProducto(producto) {
        console.log('actualizarSumatoriasPorProducto', this.sumatoriasTotales);

        this.sumatoriasTotales.forEach(sumatoria => {
            const columna = sumatoria.columna;
            switch (columna) {
                case "Subtotal":
                    sumatoria.sumatoria += producto.subTotal;
                    break;
                case "IVA":
                    sumatoria.sumatoria += this.calcularImpuesto(producto, 'valIva');
                    break;
                case "IVARET":
                    sumatoria.sumatoria += this.calcularImpuesto(producto, 'valIvaRet');
                    break;
                case "IEPS":
                    sumatoria.sumatoria += this.calcularIEPS(producto);
                    break;
                case "ISR":
                    sumatoria.sumatoria += this.calcularImpuesto(producto, 'valISR');
                    break;
                case "Total":
                    sumatoria.sumatoria += Number(producto.total);
                    break;
            }
        });
    }

    // Función para calcular el impuesto
    calcularImpuesto(producto, impuestoKey) {
        // Verificar si el ObjetoImpuesto es '02', si no, devolvemos 0
        if (producto.ObjetoImpuesto !== '02') {
            return 0;
        }

        // Continuar con el cálculo del impuesto si el ObjetoImpuesto es '02'
        let precioCantidad = this.obtenerPrecioConDescuento(producto);
        return precioCantidad * producto[impuestoKey];
    }

    // Función para calcular el IEPS
    calcularIEPS(producto) {
        // Verificar si el ObjetoImpuesto es '02', si no, devolvemos 0
        if (producto.ObjetoImpuesto !== '02') {
            return 0;
        }

        let precioCantidad = this.obtenerPrecioConDescuento(producto);
        if (producto.IEPSTasa && producto.IEPSTasaCat !== null && producto.IEPSCuotaCuot === null) {
            return precioCantidad * producto.valIEPS;
        } else {
            return precioCantidad * producto.IEPSCuotaCuot;
        }
    }

    // Función para obtener el precio con descuento aplicado
    obtenerPrecioConDescuento(producto) {
        let precioCantidad = producto.cantidad * producto.precio;
        switch (producto.formaDescuento) {
            case 0: // Sin descuento
                return precioCantidad;
            case 1: // Descuento en porcentaje
                let descuentoDecimal = parseFloat(producto.descuento) / 100;
                let valorDescuento = precioCantidad * descuentoDecimal;
                return precioCantidad - valorDescuento;
            case 2: // Descuento en cantidad fija
                return precioCantidad - producto.descuento;
        }
    }

    // Función para calcular los impuestos locales totales
    calcularImpuestosLocalesTotales() {
        const impuestosLocalesTotal = [];

        this.productoSelecionados.forEach(producto => {
            producto.ImpuestosLocales.forEach(impuestoLocal => {
                let impuestoExistente = impuestosLocalesTotal.find(x => x.id === impuestoLocal.id);
                if (!impuestoExistente) {
                    impuestosLocalesTotal.push({ ...impuestoLocal });
                } else {
                    impuestoExistente.importeImpuesto += impuestoLocal.importeImpuesto;
                }
            });
        });

        this.impuestosLocalesTotal = impuestosLocalesTotal;
    }
    // Refactorizacion

    // sumarTotales() {

    //     this.sumatoriasTotales.forEach(x => {
    //         x.sumatoria = 0;
    //     });
    //     let precioCantidad;
    //     let valorImpuesto;
    //     let descuentoDecimal;
    //     let valorDescuento;
    //     for (let i = 0; i < this.productoSelecionados.length; i++) {
    //         console.log('productoSelecionados', this.productoSelecionados[i].ObjetoImpuesto);

    //         for (let j = 0; j < this.sumatoriasTotales.length; j++) {
    //             switch (this.sumatoriasTotales[j].columna) {
    //                 case "Subtotal":
    //                     this.sumatoriasTotales[j].sumatoria += this.productoSelecionados[i].subTotal //- this.productoSelecionados[i].descuento
    //                     break;
    //                 case "IVA":
    //                     switch (this.productoSelecionados[i].formaDescuento) {
    //                         case 0:
    //                             precioCantidad = this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valIva);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                         case 1:
    //                             descuentoDecimal = parseFloat(this.productoSelecionados[i].descuento) / 100;
    //                             valorDescuento = (parseFloat(this.productoSelecionados[i].precio) * parseFloat(this.productoSelecionados[i].cantidad)) * descuentoDecimal;
    //                             precioCantidad = (this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio) - valorDescuento;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valIva);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                         case 2:
    //                             precioCantidad = (this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio) - this.productoSelecionados[i].descuento;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valIva);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                     }
    //                     break;
    //                 case "IVARET":
    //                     switch (this.productoSelecionados[i].formaDescuento) {
    //                         case 0:
    //                             precioCantidad = this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valIvaRet);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                         case 1:
    //                             descuentoDecimal = parseFloat(this.productoSelecionados[i].descuento) / 100;
    //                             valorDescuento = (parseFloat(this.productoSelecionados[i].precio) * parseFloat(this.productoSelecionados[i].cantidad)) * descuentoDecimal;
    //                             precioCantidad = (this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio) - valorDescuento;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valIvaRet);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                         case 2:
    //                             precioCantidad = (this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio) - this.productoSelecionados[i].descuento;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valIvaRet)
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                     }
    //                     break;
    //                 case "IEPS":
    //                     switch (this.productoSelecionados[i].formaDescuento) {
    //                         case 0:
    //                             precioCantidad = this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valIEPS);

    //                             let varIEPSCuota = Number(this.productoSelecionados[i].IEPSTasa ? 0 : this.productoSelecionados[i].IEPSCuotaCuot);
    //                             valorImpuesto += precioCantidad * varIEPSCuota;

    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                         case 1:
    //                             descuentoDecimal = parseFloat(this.productoSelecionados[i].descuento) / 100;
    //                             valorDescuento = (parseFloat(this.productoSelecionados[i].precio) * parseFloat(this.productoSelecionados[i].cantidad)) * descuentoDecimal;
    //                             precioCantidad = (this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio) - valorDescuento;
    //                             valorImpuesto = (this.productoSelecionados[i].IEPSTasa === true && this.productoSelecionados[i].IEPSTasaCat !== null && this.productoSelecionados[i].IEPSCuotaCuot === null ? precioCantidad * this.productoSelecionados[i].valIEPS : precioCantidad * this.productoSelecionados[i].IEPSCuotaCuot);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                         case 2:
    //                             precioCantidad = (this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio) - this.productoSelecionados[i].descuento;
    //                             valorImpuesto = (this.productoSelecionados[i].IEPSTasa === true && this.productoSelecionados[i].IEPSTasaCat !== null && this.productoSelecionados[i].IEPSCuotaCuot === null ? precioCantidad * this.productoSelecionados[i].valIEPS : precioCantidad * this.productoSelecionados[i].IEPSCuotaCuot);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                     }
    //                     break;
    //                 case "ISR":
    //                     switch (this.productoSelecionados[i].formaDescuento) {
    //                         case 0:
    //                             precioCantidad = this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valISR);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                         case 1:
    //                             descuentoDecimal = parseFloat(this.productoSelecionados[i].descuento) / 100;
    //                             valorDescuento = (parseFloat(this.productoSelecionados[i].precio) * parseFloat(this.productoSelecionados[i].cantidad)) * descuentoDecimal;
    //                             precioCantidad = (this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio) - valorDescuento;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valISR);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                         case 2:
    //                             precioCantidad = (this.productoSelecionados[i].cantidad * this.productoSelecionados[i].precio) - this.productoSelecionados[i].descuento;
    //                             valorImpuesto = (precioCantidad * this.productoSelecionados[i].valISR);
    //                             this.sumatoriasTotales[j].sumatoria += valorImpuesto;
    //                             break;
    //                     }
    //                     break;
    //                 case "Total":
    //                     this.sumatoriasTotales[j].sumatoria += Number(this.productoSelecionados[i].total);
    //                     break;
    //                 default:
    //                     break;

    //             }
    //         }
    //     }
    //     this.sumatoriasTotales.forEach(x => {
    //         x.sumatoria = x.sumatoria.toFixed(2);
    //     });

    //     // Controlamos los totales de los impuestos locales
    //     /*if (this.impuestosLocalesTotal.length == 0) {
    //         this.impuestosLocalesTotal = this.impuestosLocales;
    //     }
    //     else {
    //         if(!this.actulizarProducto)
    //             this.impuestosLocales.forEach(item => {
    //                 let index: any = [];
    //                 index = this.impuestosLocalesTotal.find(x => x.nombre === item.nombre);
    //                 // console.log("item", index, item);

    //                 if (index === undefined || index === null) {
    //                     this.impuestosLocalesTotal.push(item);
    //                 }
    //                 else {
    //                     index.importeImpuesto = index.importeImpuesto + item.importeImpuesto;
    //                 }
    //             });
    //     }
    //     */

    //     const impuestosLocalesTotal = [];

    //     this.productoSelecionados.forEach(pro => {
    //         pro.ImpuestosLocales.forEach(item => {
    //             let index = impuestosLocalesTotal.find(x => x.id === item.id);
    //             if (index === undefined || index === null) {
    //                 impuestosLocalesTotal.push({ ...item });
    //             }
    //             else {
    //                 index.importeImpuesto = index.importeImpuesto + item.importeImpuesto;
    //             }
    //         });
    //     });

    //     this.impuestosLocalesTotal = impuestosLocalesTotal;

    //     this.impuestosLocales = [];

    //     this.sumatoriaDescuento = 0;
    //     this.productoSelecionados.forEach(element => {
    //         this.sumatoriaDescuento += element.descuento ? element.descuento : 0;
    //     });

    //     this.sumatoriaSinDescuento = parseFloat(this.sumatoriasTotales[0].sumatoria) //+ this.sumatoriaDescuento;
    //     console.log("sum5", this.sumatoriasTotales[5].sumatoria)
    // }

    removeData(index) {
        this.productoSelecionados.splice(index, 1);
        this.datosTabla1.renderRows();
        this.sumarTotales();
    }

    setOperacion() {
        let parametros = {}

        // this.store.dispatch(MostrarSpinner());
        // this.coalService.postService(`operacion/PostGetOperacion`, parametros)
        //     .subscribe(
        //         (res: any) => {
        //             if (res.error) {

        //             } else if (res.excepcion) {

        //             } else {
        //                 let respuesta = res.recordsets[0][0];
        //                 this.emisor = respuesta;
        //                 this.baseService.postOperacionData(respuesta);
        //                 // this.store.dispatch(AsignarOperacion( respuesta ))
        //             }
        //             this.store.dispatch(OcultarSpinner());
        //         }, (error: any) => {
        //             this.store.dispatch(OcultarSpinner());
        //         }
        //     )
    }

    getData() {
        this.data = {
            columns: ['Nombre', 'Valor', 'Opciones'],
            rows: []
        };

        let parametros = {
            idPadre: 0
        }

        // this.store.dispatch(MostrarSpinner());
        // this.coalService.postService(`catalogo/PostGetCatalogos`, parametros).subscribe((res: any) => {
        //     if (res.error) {

        //     } else if (res.excepcion) {

        //     } else {
        //         let respuesta = res.recordsets[0];
        //         //// console.log("respuesta", respuesta);

        //         this.data = {
        //             columns: ['Nombre', 'Valor', 'Opciones'],
        //             rows: respuesta
        //         };
        //         this.store.dispatch(OcultarSpinner());
        //         // this.snackBar.open(respuesta.msg, 'Ok', { duration: 10000 });
        //     }
        // }, (error: any) => {
        //     this.store.dispatch(OcultarSpinner());
        // })
    }

    changeTipoFactura = value => {
        this.formComplementoporte = false;
        this.procesoPorte = false;
        this.showCfdiManual = false;

        localStorage.removeItem('allDocs');

        // this.store.dispatch(MostrarSpinner());

        this.idTipoFactura = parseInt(value);
        // setTimeout(() => {
        console.log("changeTipoFactura", value, this.lstTipoFactura);
        this.tipoFactura = this.lstTipoFactura.filter(x => x.id === value)
        this.lblTipoFactura = this.tipoFactura[0].attributes.nombre
        if (this.idTipoFactura === 5) {
            this.getPeriodicidad();
        }
        // }, 3000);
        // // console.log("changeTipoFactura 1", value, this.tipoFactura);

        for (let i = 0; i <= 100; i++) {
            localStorage.removeItem('Pago' + i)
        };
        this.resetDataFormFactura();
        this.resetDataAdicionales();
        // this.lstCfdiRelacionados = [];
        this.seleccionTipoFactura = false;
        this.complementoPagoTemplate = false;
        if (parseInt(value) === 3) {
            this.complementoPagoTemplate = true;
        };
        if (value !== 0) {
            this.store.dispatch(MostrarSpinner());
            // this.srvcoal.getService(`ope-empresas?populate=*`,).subscribe((res: any) => {
            this.srvcoal.getService(`ope-empresas?fields=id&fields=razonSocial
            &populate[pro_productos][populate][cat_clave_sat][populate]=*
            &populate[pro_productos][populate][cat_iep][populate]=*
            &populate[pro_productos][populate][cat_isr][populate]=*
            &populate[pro_productos][populate][cat_iva][populate]=*
            &populate[pro_productos][populate][cat_iva_ret][populate]=*
            &populate[pro_productos][populate][cat_objeto_impuesto][populate]=*
            &populate[pro_productos][populate][cat_unidad][populate]=*
            &populate[pro_productos][populate][pro_cuenta_predials][populate]=*
            &populate[pro_productos][populate][pro_pedimentos][populate]=*
            &populate[pro_productos][populate][pro_impuesto_locals][populate]=*
            &filters[id][$eq]=${this.idEmpresa}
            &populate[ope_direccion_empresas][populate][dir_direccion]=*
            &populate[ope_direccion_empresas][populate][ope_direccion_series]=*
            &populate[ope_empresa_observacions][populate]=*&default=1
            &populate[ope_empresa_bancos][populate]=*&default=1
            &populate[cli_clientes][populate]=dir_direccion.dir_asentamiento.dir_codigo_postal,cat_uso_factura,cat_regimen_fiscal,dir_direccion.dir_pai,dir_direccion.dir_estado,dir_direccion.dir_asentaiento,dir_direccion.dir_municipio`)
                .subscribe((res: any) => {
                    console.log("🚀 ~ .subscribe ~ res:", res)
                    if (res.err) {
                        console.log("erro *************** 1")
                    } else if (res.excepcion) {
                        console.log("erro *************** 2")
                    } else {
                        this.emisorRSocial = res.data
                        this.ltsLugarExpedicion = this.emisorRSocial[0].attributes.ope_direccion_empresas.data
                        this.lstCliente = this.emisorRSocial[0].attributes.cli_clientes.data
                        this.lstObservaciones = this.emisorRSocial[0].attributes.ope_empresa_observacions.data
                        this.lstCuentaBancaria = this.emisorRSocial[0].attributes.ope_empresa_bancos.data
                        this.lstProducto = this.emisorRSocial[0].attributes.pro_productos.data
                        
                        if( this.dataLlenarFormulario ){
                            if(this.dataLlenarFormulario.cliente ?? this.EditFac_Factura.attributes.cli_cliente.data.id ?? false){
                                let cliente = this.dataLlenarFormulario.cliente ?? this.EditFac_Factura.attributes.cli_cliente.data.id ?? 0;
                                this.curCliente(cliente);
                            }
                        }

                        this.filteredStates = this.stateCtrl.valueChanges.pipe(
                            startWith(''),
                            map(state => (state ? this._filterStates(state) : this.lstProducto.slice())),
                        );
                        
                        this.banderaActualizarFactura ? 
                        this.PostSelSerie(this.dataLlenarFormulario.lugarExpedicion ? this.dataLlenarFormulario.lugarExpedicion : 0) : 
                        this.store.dispatch(OcultarSpinner());
                        
                        this.facturaForm.controls.emisorRSocial.setValue(this.idEmpresa)
                        this.facturaForm.get('emisorRSocial').disable();
                        if (this.banderaActualizarFactura) {
                            // this.facturaForm.controls['tipoFactura'].disable(); , SI DESACTIVAMOS EL TIPO DE FACTURA NO SE PUEDE ACTUALIZAR Y GENERA ERROR
                        }
                        
                        this.store.dispatch(OcultarSpinner());
                    }
                }, (error: any) => {
                    console.log("erro *************** 3", error)
                });


            this.srvcoal.getService(`cat-tipo-comprobantes?filters[id][$eq]=${this.idTipoFactura}&populate[cat_val_tipo_comprobantes]=*`)
                .subscribe((res: any) => {
                    console.log("🚀 ~ .subscribe ~ res:=============>>>>>> linea 3575", res)

                    if (res.err) {
                        console.log("erro *************** 1")
                        this.store.dispatch(OcultarSpinner());

                    } else if (res.excepcion) {
                        console.log("erro *************** 2")
                        this.store.dispatch(OcultarSpinner());

                    } else {
                        console.log('rep', res.data[0].attributes.cat_val_tipo_comprobantes.data)
                        if (res.data[0].attributes.cat_val_tipo_comprobantes.data.length > 0) {
                            for (let data of res.data[0].attributes.cat_val_tipo_comprobantes.data) {
                                if (data?.attributes.parametro === 'emisorCP') {
                                    this.emisorCPRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'emisorRSocial') {
                                    this.emisorRSocialRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'cantidad') {
                                    this.cantidadRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'claveProdServ') {
                                    this.claveProdServRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'claveUnidad') {
                                    this.claveUnidadRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'cliente') {
                                    this.clienteRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };

                                if (data?.attributes.parametro === 'confirmacion') {
                                    this.confirmacionRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };

                                if (data?.attributes.parametro === 'cuentaBanco') {
                                    this.cuentaBancoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'descripcion') {
                                    this.descripcionRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'descuento') {
                                    this.descuentoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'fechaEmision') {
                                    this.fechaEmisionRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'formaPago') {
                                    this.formaPagoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'importe') {
                                    this.importeRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'lugarExpedicion') {
                                    this.lugarExpedicionRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'metodoPago') {
                                    this.metodoPagoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'moneda') {
                                    console.log("data?.attributes.parametro", data?.attributes.parametro)
                                    this.monedaRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'noIdentificacion') {
                                    this.noIdentificacionRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'nombreBanco') {
                                    this.nombreBancoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'numeroCuenta') {
                                    this.numeroCuentaRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'numeroPedido') {
                                    this.numeroPedidoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'seleccionaObservacion') {
                                    this.seleccionaObservacionRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'seleccioneCuentaBanco') {
                                    this.seleccioneCuentaBancoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'subTotal') {
                                    this.subTotalRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'tipoCambio') {
                                    this.tipoCambioRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'tipoRelacion') {
                                    this.tipoRelacionRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'total') {
                                    this.totalRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'unidad') {
                                    this.unidadRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'uuid') {
                                    this.uuidRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'valorUnitario') {
                                    this.valorUnitarioRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                /**COMPLEMNTO */
                                if (data?.attributes.parametro === 'fechaPago') {
                                    this.fechaPagoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'horaPago') {
                                    this.horaPagoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'montoPago') {
                                    this.montoPagoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'numeroOperacion') {
                                    this.numeroOperacionRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'rfcCuentaOrdenante') {
                                    this.rfcCuentaOrdenanteRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'cuentaOrdenante') {
                                    this.cuentaOrdenanteRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'nombreBancoComplemento') {
                                    this.nombreBancoComplementoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'rfcCuentaBeneficiario') {
                                    this.rfcCuentaBeneficiarioRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'cuentabeneficiario') {
                                    this.cuentabeneficiarioRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                /**DOCS RELACIONADOS */
                                if (data?.attributes.parametro === 'facturaOriginal') {
                                    this.facturaOriginalRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'montoOriginal') {
                                    this.montoOriginalRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'noParcialidad') {
                                    this.noParcialidadRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'serie') {
                                    this.serieRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'folio') {
                                    this.folioRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'objetoImpuesto') {
                                    this.objetoImpuestoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'metodoPagoDocsRel') {
                                    this.metodoPagoDocsRelRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'importeSaldoAnteriror') {
                                    this.importeSaldoAnterirorRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'importePagado') {
                                    this.importePagadoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'saldoInsoluto') {
                                    this.saldoInsolutoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                /**IMPUESTOS */
                                if (data?.attributes.parametro === 'impuestoComplemento') {
                                    this.impuestoComplementoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'baseComplemento') {
                                    this.baseComplementoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'tasaComplemento') {
                                    this.tasaComplementoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                                if (data?.attributes.parametro === 'totalComplemento') {
                                    this.totalComplementoRule[data.attributes.atributo] = data.attributes.valor == 'TRUE' ? true : data.attributes.valor == 'FALSE' ? false : data.attributes.valor == 'NULL' ? null : data.attributes.valor;
                                };
                            }

                            const facturaSeleccionada = this.lstTipoFactura.find(element => element.id == value);
                            this.condicionesPagoRule = {};
                            if (facturaSeleccionada?.attributes.dataCfdiType === 'I' || facturaSeleccionada?.attributes.dataCfdiType === 'E') {

                                this.condicionesPagoRule.hidden = false;
                            } else {
                                this.condicionesPagoRule.hidden = true;
                            }

                            this.seleccionTipoFactura = true;
                            if (!this.banderaActualizarFactura) {
                                let moneda = this.ltsMoneda.find(option => option?.attributes?.clave === 'MXN');
                                this.facturaAdicionalesForm.controls.moneda.setValue(moneda);
                                this.facturaAdicionalesForm.controls.tipoCambio.disable()
                                this.facturaAdicionalesForm.controls.tipoCambio.setValue(1)
                                this.facturaAdicionalesForm.controls.fechaEmision.setValue(1);
                            };
                            if (this.banderaActualizarFactura) {
                                // setTimeout(() => {
                                //     this.getAllCfdiForRelacion(this.dataLlenarFormulario.CFDIRelacionados);
                                // }, 500);
                            };

                            if (value == TipoDeComprobante.CartaPorte) {
                                this.FacturaEdit = this.dataLlenarFormulario?.idFactura;
                                this.formComplementoporte = true;
                                this.seleccionTipoFactura = true;
                                this.procesoPorte = true;
                            }

                            this.store.dispatch(OcultarSpinner());

                        } else {
                            if (value == TipoDeComprobante.CartaPorte) {
                                this.FacturaEdit = this.dataLlenarFormulario?.idFactura;
                                this.formComplementoporte = true;
                                this.seleccionTipoFactura = true;
                                this.procesoPorte = true;
                            } else {
                                this._snackBar.open('No se encontro información para la creacion del formulario, favor de contactar al administrador', 'Ok', { duration: 10000 });
                                this.seleccionTipoFactura = false;
                                this.complementoPagoTemplate = false;
                            }
                            this.store.dispatch(OcultarSpinner());

                        };

                    }
                }, (error: any) => {
                    this.store.dispatch(OcultarSpinner())
                    this.spinner = false;
                });

        };
    };

    changeEmisor = value => {
        this.PostSelLugarExpedicion();
    }

    resetDataFormFactura = () => {
        this.facturaForm.controls.cliente.reset();
        this.facturaForm.controls.lugarExpedicion.reset();
        this.facturaForm.controls.serie.reset();
        this.facturaForm.controls.formaPago.reset();
        this.facturaForm.controls.metodoPago.reset();
    };

    resetDataAdicionales = () => {
        // this.productoSelecionados = [];
        this.facturaAdicionalesForm.reset();
        this.facturaAdicionalesForm.controls.seleccionaObservacion.setValue(0);
        this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
        this.facturaAdicionalesForm.controls.seleccioneExportacion.setValue(1)
        this.contenedorCfdiRelacionados = [];
        this.desObservacion = false;
    };

    //#region FUNCIONES LUIS GARCIA
    //VALIDA EL CAMPO DE LAS OBSERVACIONES
    onFocusOutObservaciones = () => {
        if (this.desObservacion) {
            if (this.facturaAdicionalesForm.controls.observaciones.value.length < this.seleccionaObservacionRule.minLength) {
                return this._snackBar.open('Las observaciones deben llevar mas de 12 caracteres', 'ok', { duration: 3000, });
            };
            if (this.facturaAdicionalesForm.controls.observaciones.value.length > this.seleccionaObservacionRule.maxLength) {
                return this._snackBar.open('Las observaciones deben llevar menos de 1500 caracteres', 'ok', { duration: 3000, });
            };
        };
    };

    changeMoneda = value => {
        console.log(this.tipoCambioRule)
        const monedaClave = this.ltsMoneda.filter(x => x.id === value)[0].attributes.clave
        console.log(monedaClave)
        if (monedaClave === 'MXN') {
            this.tipoCambioRule.disabled = false
            this.facturaAdicionalesForm.controls.tipoCambio.disable()
            this.facturaAdicionalesForm.controls.tipoCambio.setValue(1);
        } else {
            this.facturaAdicionalesForm.controls.tipoCambio.reset()
            this.facturaAdicionalesForm.controls.tipoCambio.enable()
        };
    };
    //#endregion

    redirect(url: string) {
        this.router.navigateByUrl(url);
        // this.router.navigate(['cuenta']);
    };

    validaDatosComplemento = () => {
        this.complementoPago.validaDatosComplemento();
    };

    countPagosValidaDatosEventEmiter = async e => {
        console.log("countPagosValidaDatosEventEmiter", e);

        let error = false;
        let mensaje = '';

        for (let dataEventV of e) {
            console.log("dataEventV", dataEventV);

            const validacion = this.validaComplementoPago(JSON.parse(localStorage.getItem(dataEventV.id))['pago']);
            console.log("dataEventV", dataEventV);
            if (!validacion.success) {
                error = true;
                mensaje = validacion.msg
            } else {
                for (let docsValida of JSON.parse(localStorage.getItem(dataEventV.id))['pago'].documentosRelacionados) {
                    // if (docsValida[1].data.facturaOriginal === undefined) {
                    // error = true;
                    // mensaje = `Favor de llenar los datos en ${dataEventV.id} de los documentos relacionados`
                    // } else {
                    const validacionDocsRel = this.validaDocRelacionados(docsValida[1].data);
                    if (!validacionDocsRel.success) {
                        error = true;
                        mensaje = `${validacionDocsRel.msg} en ${dataEventV.id}`
                    } else {
                        if (docsValida[2].impuestos.length > 0) {
                            for (let impuesto of docsValida[2].impuestos) {
                                if (impuesto[1].data.impuestoComplemento === undefined) {
                                    error = true;
                                    mensaje = `Favor de llenar los datos en ${dataEventV.id} de los impuestos`
                                } else {
                                    const validacionImpuestos = this.validaImpuestos(impuesto[1].data);
                                    if (!validacionImpuestos.success) {
                                        error = true;
                                        mensaje = `${validacionImpuestos.msg} en ${dataEventV.id}`
                                    };
                                };
                            };
                        };
                    };
                    // };
                };
            };
        };

        if (!error) {
            this.InsertarDatos();
        } else {
            this._snackBar.open(mensaje, 'ok', { duration: 3000, });
        };
    };

    async deleteFacComPagoDocumento(items: any[]): Promise<any> {
        return new Promise((resolve, reject) => {
            if (!items || items.length === 0) {
                this._snackBar.open('No se proporcionaron elementos para eliminar', 'Ok', { duration: 5000 });
                reject({ success: 0, message: 'Lista de elementos vacía' });
                return;
            }

            // Extraer los IDs del arreglo
            const ids = items.map(item => item.id);

            // Ejecutar eliminación en paralelo para cada ID
            Promise.all(ids.map(id => this.processDelete(id)))
                .then(results => {
                    resolve({ success: 1, deletedRecords: results });
                })
                .catch(error => {
                    this._snackBar.open('Error en la eliminación masiva', 'Ok', { duration: 10000 });
                    reject(error);
                });
        });
    }
    
    /**
     * Proceso de eliminación individual para cada ID
     */
    private async processDelete(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.coalService.getService(`fac-complemento-pagos/${id}`).subscribe(async (response: any) => {
                if (response.data) {
                    const documentos = response.data.attributes.fac_com_pago_documentos?.data || [];
    
                    try {
                        for (const doc of documentos) {
                            const docId = doc.id;
                            const docImps = doc.attributes.fac_com_pago_doc_imps?.data || [];
    
                            // Eliminar `fac_com_pago_doc_imps` asociados
                            for (const imp of docImps) {
                                await this.coalService.deleteService(`fac-com-pago-doc-imps/${imp.id}`).toPromise();
                            }
    
                            // Eliminar `fac_com_pago_documentos`
                            await this.coalService.deleteService(`fac-com-pago-documentos/${docId}`).toPromise();
                        }
    
                        // Una vez eliminados los subnodos, eliminar el nodo principal
                        this.coalService.deleteService(`fac-complemento-pagos/${id}`).subscribe(
                            (res: any) => {
                                if (res.error) {
                                    this._snackBar.open(`Error al eliminar el ID ${id}, contacte al administrador`, 'Ok', { duration: 10000 });
                                    reject({ success: 0, id });
                                } else {
                                    resolve({ success: 1, id });
                                }
                            },
                            (error: any) => {
                                this._snackBar.open(`${error?.error?.error?.message}`);
                                reject(error);
                            }
                        );
    
                    } catch (error) {
                        this._snackBar.open(`Error al desvincular documentos asociados al ID ${id}`, 'Ok', { duration: 10000 });
                        reject(error);
                    }
    
                } else {
                    this._snackBar.open(`No se encontró el nodo con ID ${id}`, 'Ok', { duration: 5000 });
                    reject({ success: 0, id });
                }
            }, (error: any) => {
                this._snackBar.open(`Error al obtener el nodo con ID ${id}`, 'Ok', { duration: 5000 });
                reject(error);
            });
        });
    }

    InsertarDatosComplemento = () => {
        this.complementoPago.insertDataComplementoPago();
    };

    countPagosEventEmiter = async (e) => {

        console.log("countPagosEventEmiter" , e);
        console.log("idFacturaForComplemento", this.idFacturaForComplemento);
        this.store.dispatch(MostrarSpinner());

        let error = false;
        let mensaje = '';

        for (let dataEventV of e) {
            console.log("llegue al for", dataEventV)
            const validacion = this.validaComplementoPago(JSON.parse(localStorage.getItem(dataEventV.id))['pago']);
            if (!validacion.success) {
                error = true;
                mensaje = validacion.msg
                console.log("no valido pago")
            } else {
                console.log("Valido pago ELSE")
                for (let docsValida of JSON.parse(localStorage.getItem(dataEventV.id))['pago'].documentosRelacionados) {
                    if (docsValida[1].data.facturaOriginal === undefined) {
                        error = false//true;
                        mensaje = `Favor de llenar los datos en ${dataEventV.id} de los documentos relacionados`
                    } else {
                        const validacionDocsRel = this.validaDocRelacionados(docsValida[1].data);
                        if (!validacionDocsRel.success) {
                            error = false//true;
                            mensaje = `${validacionDocsRel.msg} en ${dataEventV.id}`
                        } else {
                            if (docsValida[2].impuestos.length > 0) {
                                for (let impuesto of docsValida[2].impuestos) {
                                    if (impuesto[1].data.impuestoComplemento === undefined) {
                                        error = false//true;
                                        mensaje = `Favor de llenar los datos en ${dataEventV.id} de los impuestos`
                                    } else {
                                        const validacionImpuestos = this.validaImpuestos(impuesto[1].data);
                                        if (!validacionImpuestos.success) {
                                            error = false//true;
                                            mensaje = `${validacionImpuestos.msg} en ${dataEventV.id}`
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };

        if (this.idFacturaForComplemento === 0) {
            error = false//true;
            mensaje = 'Error al obtener el idFactura'
        };

        // console.log("!error");

        if (!error) {
            this.numPagos = e.length
            for (let dataEvent of e) {
                console.log("fattds0", JSON.parse(localStorage.getItem(dataEvent.id))['pago'])

                // if(this.banderaActualizarFactura){
                //     console.log(dataEvent.child ?? 'no hay child') 
                //     console.log(dataEvent?.child?.dataUpdateComplemento ?? 'no hay dataUpdateComplemento')
                //     console.log(dataEvent?.child?.dataUpdateComplemento?.id ??  'no hay id')

                //     await this.complementoPagoDataUpd(JSON.parse(localStorage.getItem(dataEvent.id))['pago'], dataEvent.id,dataEvent?.child?.dataUpdateComplemento?.id);
                // }
                // else{
                    await this.complementoPagoData(JSON.parse(localStorage.getItem(dataEvent.id))['pago'], dataEvent.id);
                // }
            }

            var datafact = {
                tipofactura: 3,
                clave: this.idFacturaForComplemento
            }
            if (this.timbrar) {
                this.facturar(datafact);
            }

        } else {
            this.store.dispatch(OcultarSpinner());
            this._snackBar.open(mensaje, 'ok', { duration: 3000, });
        };
    };

    validaComplementoPago = (data: any) => {
        console.log("validaComplementoPago", data);
        if (!data.data) {
            return { succes: false, msg: 'Favor de insertar la fecha de pago' };
        }
        if (this.fechaPagoRule.obligatory && (data.data.fechaPago === null || data.data.fechaPago === undefined || data.data.fechaPago === '')) {
            return { succes: false, msg: 'Favor de insertar la fecha de pago' };
        };
        if (this.horaPagoRule.obligatory && (data.data.horaPago === null || data.data.horaPago === undefined || data.data.horaPago === '')) {
            return { succes: false, msg: 'Favor de insertar la hora de pago' };
        };
        if (this.montoPagoRule.obligatory && (data.data.montoPago === null || data.data.montoPago === undefined || data.data.montoPago === '')) {
            return { succes: false, msg: 'Favor de insertar la monto de pago' };
        };
        // if (this.numeroOperacionRule.obligatory && (data.data.numeroOperacion === null || data.data.numeroOperacion === undefined || data.data.numeroOperacion === '')) {
        //     return { succes: false, msg: 'Favor de insertar la numero operacion' };
        // };
        // if (this.rfcCuentaOrdenanteRule.obligatory && (data.data.rfcCuentaOrdenante === null || data.data.rfcCuentaOrdenante === undefined || data.data.rfcCuentaOrdenante === '')) {
        //     return { succes: false, msg: 'Favor de insertar la rfc ordenante' };
        // };
        // if (this.cuentaOrdenanteRule.obligatory && (data.data.cuentaOrdenante === null || data.data.cuentaOrdenante === undefined || data.data.cuentaOrdenante === '')) {
        //     return { succes: false, msg: 'Favor de insertar la cuenta ordenante' };
        // };
        // if (this.nombreBancoComplementoRule.obligatory && (data.data.nombreBanco === null || data.data.nombreBanco === undefined || data.data.nombreBanco === '')) {
        //     return { succes: false, msg: 'Favor de insertar la nombre banco' };
        // };
        // if (this.rfcCuentaBeneficiarioRule.obligatory && (data.data.rfcCuentaBeneficiario === null || data.data.rfcCuentaBeneficiario === undefined || data.data.rfcCuentaBeneficiario === '')) {
        //     return { succes: false, msg: 'Favor de insertar la rfc cuenta beneficiario' };
        // };
        // if (this.cuentabeneficiarioRule.obligatory && (data.data.cuentabeneficiario === null || data.data.cuentabeneficiario === undefined || data.data.cuentabeneficiario === '')) {
        //     return { succes: false, msg: 'Favor de insertar la fcuenta beneficiario' };
        // };
        if (this.monedaRule.obligatory && (data.data.monedaComplemento.value === null || data.data.monedaComplemento.value === undefined || data.data.monedaComplemento.value === '')) {
            return { success: false, msg: 'Favor de seleccionar moneda' }
        };
        if (this.tipoCambioRule.obligatory && (data.data.tipoCambioComplemento === null || data.data.tipoCambioComplemento === undefined || data.data.tipoCambioComplemento === '')) {
            return { success: false, msg: 'Favor de seleccionar tipo de cambio' }
        };
        if (this.formaPagoRule.obligatory && (data.data.formaPago == null || data.data.formaPago === '' || data.data.formaPago == undefined)) {
            return { success: false, msg: 'Favor de seleccionar un metodo de pago' };
        };

        return { success: true, msg: '' };
    };

    validaDocRelacionados = (data: any) => {
        if (this.facturaOriginalRule.obligatory && (data.facturaOriginal === null || data.facturaOriginal === undefined || data.facturaOriginal === '')) {
            return { success: false, msg: 'Favor de colocar la factura original de los documentos relacionados' };
        };
        if (this.montoOriginalRule.obligatory && (data.montoOriginal === null || data.montoOriginal === undefined || data.montoOriginal === '')) {
            return { success: false, msg: 'Favor de colocar el monto original de los documentos relacionados' };
        };
        if (this.noParcialidadRule.obligatory && (data.noParcialidad === null || data.noParcialidad === undefined || data.noParcialidad === '')) {
            return { success: false, msg: 'Favor de colocar no Parcialidad original de los documentos relacionados' };
        };
        if (this.serieRule.obligatory && (data.serie === null || data.serie === undefined || data.serie === '')) {
            return { success: false, msg: 'Favor de colocar la serie de los documentos relacionados' };
        };
        if (this.folioRule.obligatory && (data.folio === null || data.folio === undefined || data.folio === '')) {
            return { success: false, msg: 'Favor de colocar el folio de los documentos relacionados' };
        };
        // if (this.objetoImpuestoRule.obligatory && (data.objetoImpuesto === null || data.objetoImpuesto === undefined || data.objetoImpuesto === '')) {
        //     return { success: false, msg: 'Favor de colocar el objeto impuesto de los documentos relacionados' };
        // };
        if (this.metodoPagoDocsRelRule.obligatory && (data.metodoPagoDocsRel === null || data.metodoPagoDocsRel === undefined || data.metodoPagoDocsRel === '')) {
            return { success: false, msg: 'Favor de colocar metoodo de pago de los documentos relacionados' };
        };
        if (this.importeSaldoAnterirorRule.obligatory && (data.importeSaldoAnteriror === null || data.importeSaldoAnteriror === undefined || data.importeSaldoAnteriror === '')) {
            return { success: false, msg: 'Favor de colocar el importe anteriror de los documentos relacionados' };
        };
        if (this.importePagadoRule.obligatory && (data.importePagado === null || data.importePagado === undefined || data.importePagado === '')) {
            return { success: false, msg: 'Favor de colocar el importe pagado de los documentos relacionados' };
        };
        if (this.saldoInsolutoRule.obligatory && (data.saldoInsoluto === null || data.saldoInsoluto === undefined || data.saldoInsoluto === '')) {
            return { success: false, msg: 'Favor de colocar el salfo insoluto de los documentos relacionados' };
        };

        return { success: true, msg: '' };
    };

    validaImpuestos = (data: any) => {
        if (this.impuestoComplementoRule.obligatory && (data.impuestoComplemento === null || data.impuestoComplemento === undefined || data.impuestoComplemento === '')) {
            return { success: false, msg: 'Favor de colocar el impuesto en los impuestos' }
        };
        if (this.baseComplementoRule.obligatory && (data.baseComplemento === null || data.baseComplemento === undefined || data.baseComplemento === '')) {
            return { success: false, msg: 'Favor de colocar la base en los impuestos' };
        };
        if (this.tasaComplementoRule.obligatory && (data.tasaComplemento === null || data.tasaComplemento === undefined || data.tasaComplemento === '')) {
            return { success: false, msg: 'Favor de colocar la tasa en los impuestos' };
        };
        if (this.totalComplementoRule.obligatory && (data.totalComplemento === null || data.totalComplemento === undefined || data.totalComplemento === '')) {
            return { success: false, msg: 'Favor de colocar el total en los impuestos' };
        };

        return { success: true, msg: '' };
    };

    complementoPagoDataUpd = (data: any, idPago, idComplemento) => {
        console.log("complementoPagoData", data);
        const valPago = Number(idPago.match(/\d+/)[0])
        console.log("idPago", valPago);
        return new Promise(async (resolve) => {
            try {
                const { documentosRelacionados } = data;

                console.log("data.data.fechaPago", data.data)
                const json = {
                    fechaPago: data.data.fechaPago.split('T')[0],
                    horaPago: '12:00:00',//data.data.horaPago + ":00",
                    // cat_forma_pago: data.data.formaPago,
                    cat_forma_pago: data.data.formaPago === null ? null : {
                        id: data.data.formaPago.id
                    },
                    montoPago: parseFloat(data.data.montoPago),
                    cat_moneda: data.data.monedaComplemento === null ? {
                        id: 1
                    } : {
                        id: data.data.monedaComplemento
                    },
                    tipoCambio: data.data.tipoCambioComplemento,
                    numeroOperacion: data.data.numeroOperacion,
                    rfcCuentaOrdenante: data.data.rfcCuentaOrdenante,
                    cuentaOrdenante: data.data.cuentaOrdenante,
                    nombreBanco: data.data.nombreBanco,
                    rfcCuentaBeneficiario: data.data.rfcCuentaBeneficiario,
                    cuentaBeneficiario: data.data.cuentabeneficiario,
                    fact_factura: this.idFacturaForComplemento,
                    modifyPago: this.actualizarFact == 1 && valPago < 2 ? true : false

                };
                console.log("json", json)
                console.log("documentosRelacionados", documentosRelacionados)
                // const resComplementoPago = await this.insertDataComplementoPago('catalogo/insComplemento', json);
                const resComplementoPago = await this.UpdDataComplementoPago(`fac-complemento-pagos/${idComplemento}`, { data: json });

                console.log("documentosRelacionados", documentosRelacionados)
                if (resComplementoPago[0].success == 1) {
                    if (documentosRelacionados && documentosRelacionados.length > 0 && Object.keys(documentosRelacionados[0][1].data).length !== 0) {
                        console.log("SI TIENE documentos", resComplementoPago[0]?.idReturn ?? 'no hay id')
                        for (let docRel of documentosRelacionados) {
                            console.log('Doc ', docRel)
                            await this.documentosRelacionadosFnUpd(idComplemento, docRel)
                        };
                        resolve([{ success: 1 }]);
                    } else {
                        console.log("sin documentos")
                        resolve([{ success: 1 }]);
                        this.store.dispatch(OcultarSpinner());
                    };
                    // var datafact = {
                    //     tipofactura: 3,
                    //     clave: this.idFacturaForComplemento
                    // }
                    // if (this.timbrar) {
                    //     this.facturar(datafact);
                    // }
                    // this.store.dispatch(OcultarSpinner());
                    // const dialogRef = this.dialog.open(ConfirmDialogOpcionComponent,
                    //     {
                    //         width: '450px', data: {
                    //             data: datafact,
                    //             msj: "Complemento de Pago"
                    //         }
                    //     });
                    // dialogRef.afterClosed().subscribe(result => {
                    //     if (result == 0) {
                    //         this.router.navigateByUrl('/factura/facturas');
                    //     }
                    // });
                } else {
                    resolve([{ success: 0 }]);
                };
            } catch (e) {
                "Ocurrió un error al crear el complemento " + e?.error?.error?.message, "OK", { duration: 12000 }
                console.log("error", e)
                resolve([{ success: 0 }]);
                // console.log('Error al insertar complemeto', e)
            };
        });
    };
    complementoPagoData = (data: any, idPago) => {
        console.log("complementoPagoData", data);
        const valPago = Number(idPago.match(/\d+/)[0])
        console.log("idPago", valPago);
        return new Promise(async (resolve) => {
            try {
                const { documentosRelacionados } = data;

                console.log("data.data.fechaPago", data.data)
                const json = {
                    fechaPago: data.data.fechaPago.split('T')[0],
                    horaPago: '12:00:00',//data.data.horaPago + ":00",
                    // cat_forma_pago: data.data.formaPago,
                    cat_forma_pago: data.data.formaPago === null ? null : {
                        id: data.data.formaPago.id
                    },
                    montoPago: parseFloat(data.data.montoPago),
                    cat_moneda: data.data.monedaComplemento === null ? {
                        id: 1
                    } : {
                        id: data.data.monedaComplemento
                    },
                    tipoCambio: data.data.tipoCambioComplemento,
                    numeroOperacion: data.data.numeroOperacion,
                    rfcCuentaOrdenante: data.data.rfcCuentaOrdenante,
                    cuentaOrdenante: data.data.cuentaOrdenante,
                    nombreBanco: data.data.nombreBanco,
                    rfcCuentaBeneficiario: data.data.rfcCuentaBeneficiario,
                    cuentaBeneficiario: data.data.cuentabeneficiario,
                    fact_factura: this.idFacturaForComplemento,
                    modifyPago: this.actualizarFact == 1 && valPago < 2 ? true : false

                };
                console.log("json", json)
                console.log("documentosRelacionados", documentosRelacionados)
                // const resComplementoPago = await this.insertDataComplementoPago('catalogo/insComplemento', json);
                const resComplementoPago = await this.insertDataComplementoPago('fac-complemento-pagos', { data: json });

                console.log("documentosRelacionados", documentosRelacionados)
                if (resComplementoPago[0].success == 1) {
                    if (documentosRelacionados && documentosRelacionados.length > 0 && Object.keys(documentosRelacionados[0][1].data).length !== 0) {
                        console.log("SI TIENE documentos", resComplementoPago[0].idReturn)
                        for (let docRel of documentosRelacionados) {
                            await this.documentosRelacionadosFn(resComplementoPago[0].idReturn.attributes.data.id, docRel)
                        };
                        resolve([{ success: 1 }]);
                    } else {
                        console.log("sin documentos")
                        resolve([{ success: 1 }]);
                        this.store.dispatch(OcultarSpinner());
                    };
                    // var datafact = {
                    //     tipofactura: 3,
                    //     clave: json.fact_factura
                    // }
                    // if (this.timbrar) {
                    //     this.facturar(datafact);
                    // }
                    // this.store.dispatch(OcultarSpinner());
                    // const dialogRef = this.dialog.open(ConfirmDialogOpcionComponent,
                    //     {
                    //         width: '450px', data: {
                    //             data: datafact,
                    //             msj: "Complemento de Pago"
                    //         }
                    //     });
                    // dialogRef.afterClosed().subscribe(result => {
                    //     if (result == 0) {
                    //         this.router.navigateByUrl('/factura/facturas');
                    //     }
                    // });
                } else {
                    resolve([{ success: 0 }]);
                };
            } catch (e) {
                "Ocurrió un error al crear el complemento " + e?.error?.error?.message, "OK", { duration: 12000 }
                console.log("error", e)
                resolve([{ success: 0 }]);
                // console.log('Error al insertar complemeto', e)
            };
        });
    };

    documentosRelacionadosFnUpd(idComplemento: number, dataDocRel: any) {
        return new Promise(async (resolve) => {
            const valDocu = Number(dataDocRel[0].id.match(/\d+/)[0])
            const json = {
                //idComplemento: idComplemento,
                facturaOriginal: dataDocRel[1].data.facturaOriginal.attributes?.fac_factura_timbre?.data?.attributes?.uuid || dataDocRel[1].data.facturaOriginal,
                montoOriginal: parseFloat(dataDocRel[1].data.montoOriginal),
                noParcialidad: dataDocRel[1].data.noParcialidad,
                serie: dataDocRel[1].data.serie,
                folio: dataDocRel[1].data.folio,
                cat_moneda: dataDocRel[1].data.monedaDocsRel === null ? null : { id: dataDocRel[1].data.monedaDocsRel },
                tipoCambio: parseFloat(dataDocRel[1].data.tipoCambioDocsRel),
                cat_objeto_impuesto: dataDocRel[1].data.objetoImpuesto === null ? null : { id: dataDocRel[1].data.objetoImpuesto },
                cat_metodo_pago: dataDocRel[1].data.metodoPagoDocsRel === null ? null : { id: dataDocRel[1].data.metodoPagoDocsRel },
                importeSaldoAnteriror: parseFloat(dataDocRel[1].data.importeSaldoAnteriror),
                importePagado: parseFloat(dataDocRel[1].data.importePagado),
                saldoInsoluto: parseFloat(dataDocRel[1].data.saldoInsoluto),
                comp_pago: idComplemento,
                modifyPago: this.actualizarFact == 1 && valDocu < 2 ? true : false
            };
            const resDocsRelacionados = await this.insertDataComplementoPago('fac-com-pago-documentos', { data: json });
            if (resDocsRelacionados[0].success === 1) {
                if (dataDocRel[2].impuestos.length > 0) {
                    for (let dataImpuesto of dataDocRel[2].impuestos) {
                        console.log("dataImpuesto", dataImpuesto)
                        await this.impuestosDocsRelacionados(resDocsRelacionados[0].idReturn.attributes.data.id, dataImpuesto);
                    };
                    resolve([{ success: 1 }]);
                    this.store.dispatch(OcultarSpinner());
                } else {
                    this.store.dispatch(OcultarSpinner());
                    resolve([{ success: 1 }]);
                };
            } else {
                resolve([{ success: 0 }]);
            };
        });
    };
    documentosRelacionadosFn(idComplemento: number, dataDocRel: any) {
        return new Promise(async (resolve) => {
            const valDocu = Number(dataDocRel[0].id.match(/\d+/)[0])
            const json = {
                //idComplemento: idComplemento,
                facturaOriginal: dataDocRel[1].data.facturaOriginal.attributes?.fac_factura_timbre?.data?.attributes?.uuid || dataDocRel[1].data.facturaOriginal,
                montoOriginal: parseFloat(dataDocRel[1].data.montoOriginal),
                noParcialidad: dataDocRel[1].data.noParcialidad,
                serie: dataDocRel[1].data.serie,
                folio: dataDocRel[1].data.folio,
                cat_moneda: dataDocRel[1].data.monedaDocsRel === null ? null : { id: dataDocRel[1].data.monedaDocsRel },
                tipoCambio: parseFloat(dataDocRel[1].data.tipoCambioDocsRel),
                cat_objeto_impuesto: dataDocRel[1].data.objetoImpuesto === null ? null : { id: dataDocRel[1].data.objetoImpuesto },
                cat_metodo_pago: dataDocRel[1].data.metodoPagoDocsRel === null ? null : { id: dataDocRel[1].data.metodoPagoDocsRel },
                importeSaldoAnteriror: parseFloat(dataDocRel[1].data.importeSaldoAnteriror),
                importePagado: parseFloat(dataDocRel[1].data.importePagado),
                saldoInsoluto: parseFloat(dataDocRel[1].data.saldoInsoluto),
                comp_pago: idComplemento,
                modifyPago: this.actualizarFact == 1 && valDocu < 2 ? true : false
            };
            const resDocsRelacionados = await this.insertDataComplementoPago('fac-com-pago-documentos', { data: json });
            if (resDocsRelacionados[0].success === 1) {
                if (dataDocRel[2].impuestos.length > 0) {
                    for (let dataImpuesto of dataDocRel[2].impuestos) {
                        console.log("dataImpuesto", dataImpuesto)
                        await this.impuestosDocsRelacionados(resDocsRelacionados[0].idReturn.attributes.data.id, dataImpuesto);
                    };
                    resolve([{ success: 1 }]);
                    this.store.dispatch(OcultarSpinner());
                } else {
                    this.store.dispatch(OcultarSpinner());
                    resolve([{ success: 1 }]);
                };
            } else {
                resolve([{ success: 0 }]);
            };
        });
    };

    impuestosDocsRelacionados(idDocRelacionado: number, dataImpuestos: any) {
        return new Promise(async (resolve) => {
            console.log("dataImpuestos[1].data.tasaComplemento", dataImpuestos[1].data.tasaComplemento)
            const valImp = Number(dataImpuestos[0].id.match(/\d+/)[0])
            const json = {
                cat_impuesto: dataImpuestos[1].data.impuestoComplemento,
                base: parseFloat(dataImpuestos[1].data.baseComplemento),
                tasa: parseFloat(dataImpuestos[1].data.tasaComplemento.attributes.valor),
                total: dataImpuestos[1].data.totalComplemento,
                comp_documento: idDocRelacionado,
                modifyPago: this.actualizarFact == 1 && valImp < 2 ? true : false
            };
            // console.log("idDocRelacionado",idDocRelacionado)
            console.log("{data:json}", { data: json })
            console.log("data", dataImpuestos[1].data.impuestoComplemento)
            await this.insertDataComplementoPago('fac-com-pago-doc-imps', { data: json });
            resolve([{ success: 1 }]);
            // // this.store.dispatch(OcultarSpinner());
        });
    };

    UpdDataComplementoPago(url: string, data: any) {
        return new Promise(resolve => {
            this.coalService.putService(url, data).subscribe((res: any) => {
                if (res.error) {
                    //this.store.dispatch(OcultarSpinner());
                    this._snackBar.open('Error al insertar la informacion, favor de contactar al administrador', 'Ok', { duration: 10000 });
                    resolve([{ success: 0 }]);
                } else {
                    console.log("res", res)
                    resolve([{ success: 1, idReturn: res.data }]);
                };
            }, (error: any) => {
                this._snackBar.open(`${error?.error?.error?.message}`);
            });
        });
    };

    insertDataComplementoPago(url: string, data: any) {
        return new Promise(resolve => {
            this.coalService.postService(url, data).subscribe((res: any) => {
                if (res.error) {
                    //this.store.dispatch(OcultarSpinner());
                    this._snackBar.open('Error al insertar la informacion, favor de contactar al administrador', 'Ok', { duration: 10000 });
                    resolve([{ success: 0 }]);
                } else {
                    console.log("res", res)
                    resolve([{ success: 1, idReturn: res.data }]);
                };
            }, (error: any) => {
                this._snackBar.open(`${error?.error?.error?.message}`);
            });
        });
    };

    descargarxml() {
        var xmlvariable = this.dataLlenarFormulario;
        // console.log(xmlvariable);
        var fileToExport = new Blob([xmlvariable.xml_format], { type: "text/xml" });
        var a = document.createElement("a");
        a.href = URL.createObjectURL(fileToExport);
        a.target = "_blank";
        a.download = xmlvariable.rfc + '-' + xmlvariable.nombre + ".xml"
        a.click();
    }

    descargarpdf() {
        // console.log("Entra we");
        this.descargarFactura(this.dataLlenarFormulario);
    }

    descargarFactura(factura) {
        // console.log(factura);
        switch (factura.tipo_factura) {
            case "Factura":
                this.facturaF(factura);
                break;
            case "Nota de Crédito":
                this.facturaF(factura);
                break;
            case "Complemento de Pago":
                this.facturaC(factura);
                break;
        }

    }

    facturaC(factura) {
        this.store.dispatch(MostrarSpinner());
        var body = { idfactura: factura.clave }
        this.coalService.postService(`catalogo/selReporteComplementos`, body).subscribe((res: any) => {
            if (res.err) {
                this.store.dispatch(MostrarExcepcion({ pila: res.error, tipoExcepcion: 4 }))
            } else if (res.excepcion) {
                this.store.dispatch(MostrarExcepcion({ pila: res.excepcion, tipoExcepcion: 3 }))
            } else {
                let body = {
                    emisor: {
                        nombre: res.recordsets[0][0].fullname,
                        rfc: res.recordsets[0][0].rfc,
                        direccion: res.recordsets[0][0].direccion,
                        lugar_emision: res.recordsets[0][0].LugarEmosion,
                    },
                    receptor: {
                        nombre: res.recordsets[1][0].nombreRazonSocial,
                        rfc: res.recordsets[1][0].rfc,
                        direccion: res.recordsets[1][0].direccion
                    },
                    productos: res.recordsets[3][0],
                    tproductos: res.recordsets[4][0].total,
                    pagos: res.recordsets[5],
                    DocsRel: res.recordsets[6],
                    logo: res.recordsets[8][0],
                    footer: {
                        NoCertificado: res.recordsets[7][0].NoCertificado,
                        cadena_original: this.customCadenaOriginal(res),//res.recordsets[7][0].SelloDgitalSAT,
                        sello_emisor: res.recordsets[7][0].Sello,
                        sello_sat: res.recordsets[7][0].SelloSAT,
                        version: res.recordsets[7][0].Version,
                        emisor_cert: res.recordsets[7][0].Certificado,
                        fecha_emit: res.recordsets[7][0].FechaTimbrado,
                        sat_cret: res.recordsets[7][0].NoCertificado,
                        pac: "Lorem",
                        qr: res.recordsets[7][0].SelloDgitalSAT,
                        idEstatusFactura: res.recordsets[7][0].idEstatusFactura
                    }
                };
                this.sparroService.getReport("reportes/CallFeatureNew", body, "ReportePrueba");
            };

        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
            this.store.dispatch(MostrarExcepcion({ pila: error, tipoExcepcion: 2 }));
        });
    }

    customCadenaOriginal(res) {
        console.log('customCadenaOriginal');

        return `||${res[7].SelloDgitalSAT}||`
    }

    facturaF(factura) {
        this.store.dispatch(MostrarSpinner());
        var factura_response;
        let data = {
            clave: factura.clave
        }
        this.coalService.postService("operacion/GetReporteFactura", data).subscribe(
            (response: any) => {
                factura_response = response.recordsets;
                this.sparroService.getReport("reportes/SelPdf", factura_response, "ReportePrueba");
            });
    }

    openDialog(): void {
        const dialogRef = this.dialog.open(ProductoAddComponent, {
            width: '800px',
            disableClose: true,
            data: { mode: 1, producto: null, idEmpresa: this.idEmpresa },
        });

        dialogRef.afterClosed().subscribe(result => {
            // console.log('The dialog was closed', result);
            if (result.success == 1) {
                this.NuevoProducto = result.producto.id;
                this.GetProducto(2);
            }
        });
    }

    modificarProducto(e) {
        // console.log("modificar(e)", e);

        const dialogRef = this.dialog.open(ProductoAddComponent, {
            width: '800px',
            disableClose: true,
            data: { mode: 2, producto: e, idEmpresa: this.idEmpresa },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result.success == 1) {
                this.NuevoProducto = result.producto.id;
                this.GetProducto(3);
            }
        });
    }

    openDialogNewCliente(data): void {

        var clientesend;
        if (data.mode == 2) {
            clientesend = { ...this.cliente, mode: 2 };
        } else {
            // clientesend = null;

            clientesend = {
                mode: data.mode,
                idEmpresa: this.idEmpresa
            }
        }
        const dialogRef = this.dialog.open(DialogNuevoClienteComponent, {
            width: '800px',
            data: { ...clientesend },
            disableClose: true
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
            if (result.success == 1) {
                this.GetCliente();
                this.cliente = result.nuevoCliente
                this.facturaForm.controls.cliente.setValue(result.nuevoCliente.id)
                console.log(this.facturaForm)
                //// console.log('The dialog was closed');
                //this.animal = result;
            }
        });
    }
    agregarClienteSimplificado() {
        console.log("csf")
        this.openDialogNewCliente({ mode: 3, idEmpresa: this.idEmpresa });
    }
    transformcurrency(transform) {
        return this.cp.transform(transform, 'USD', 'symbol', '1.0-0');
    }

    transformcurrencydecimales(transform) {
        return this.cp.transform(transform, 'USD', 'symbol', '1.2-2');
    }

    //#region Cuenta predial
    cuentaPredialForm: FormGroup;

    initCuentaPredial() {
        this.cuentaPredialForm = this.fb.group({
            cuentaPredial: ['', Validators.required]
        });
    }

    _filterMoneda(value: string): any {
        const filterValue = value.toLowerCase();
        return this.ltsMoneda.filter(option => option.attributes.clave.toLowerCase().includes(filterValue) || option.attributes.descripcion.toLowerCase().includes(filterValue));
    }

    displayFnMoneda(moneda: any): string {
        return '' + moneda?.attributes.clave + '-' + moneda?.attributes?.descripcion;
    };

    //facturaForm

    //new CFDI Realacionados Boton
    btnCfdiRelacionados(idRelacion, reload) {

        console.log("🚀 ~ GetCliente ~ reload:", reload)
        console.log("🚀 ~ GetCliente ~ value:", idRelacion)
        //Validando Cliente
        console.log("🚀 ~ GetCliente ~ this.facturaForm.controls.cliente.value :", this.facturaForm.controls.cliente.value)
        console.log("🚀 ~ GetCliente ~ this.idOperacion:", this.idOperacion)
        let idCliente = this.facturaForm.controls.cliente.value ?? null;
        if (idCliente == null || idCliente == undefined) {
            this._snackBar.open('Para abrir el listado de facturas a relacionar especifique un cliente a esta factura, de lo contrario proporcione manualmente el folio fiscal.', 'OK', { duration: 9000 });
            return;
        }

        this.showCfdiManual = true
        this.allCfdiEncontrados = [];
        if (reload !== 1) {
            this.contenedorCfdiRelacionados = [];
        };
        const dataRelacionado = this.lstCfdiRelacionados.find(x => x.id === idRelacion);
        const body = {
            queryComplement: dataRelacionado?.complementQuery,
            idCliente: idCliente,
            idOperacion: this.idOperacion
        };

        const dataCliente = this.lstCliente.find(x => x.id === idCliente);
        let dataModal = {
            cliente: dataCliente,
            relacion: dataRelacionado,
            data: []
        }

        //cat-cfdi-relaciondos
        let baseUrl = `fac-facturas?populate=*`;
        let filters = [];
        //Cliente
        if (idCliente) {
            filters.push(`filters[cli_cliente][id][$eq]=${idCliente}`);
        }
        //Empresa
        if (this.idEmpresa) {
            filters.push(`filters[ope_empresa][id][$eq]=${this.idEmpresa}`);
        }
        //Tipo Comprobante
        let idTipo = this.facturaForm.controls.tipoFactura.value || null;
        if (idTipo) {
            filters.push(`filters[cat_tipo_comprobante][id][$eq]=${idTipo}`);
        }

        //Tipo de relacion en CFDI / cat_cfdi_relaciondo
        if (idRelacion) {
            filters.push(`filters[cat_cfdi_relaciondo][id][$eq]=${idRelacion}`);
        }

        let filterUrl = filters.length ? '&' + filters.join('&') : '';

        // Concatena el filtro si existe
        let uri = `${baseUrl}${filterUrl}`;

        this.store.dispatch(MostrarSpinner());
        //Call Service
        this.coalService.getService(uri).subscribe((res: any) => {
            console.log("🚀 ~ this.coalService.getService ~ res:", res)
            this.store.dispatch(OcultarSpinner());

            if (res.err) {
                this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
                return this._snackBar.open('Error al traer los CFDI relacionados', 'OK', { duration: 3000 });
            } else if (res.excepcion) {
                this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
                return this._snackBar.open('Error al traer los CFDI relacionados', 'OK', { duration: 3000 });
            } else {

                //fac_factura_doc_relacionados
                let data: any[] = res?.data || [];
                if (data.length > 0) {
                    //Array solo resultados con CFDIS
                    let ArrayCfdis: any[] = [];
                    //Recorriendo lista para determinar que existan documentos relacionados
                    for (const item of data) {
                        let comprobante = item?.attributes?.cat_tipo_comprobante?.data?.attributes?.nombre || '***';
                        let serie = item?.attributes?.ope_direccion_serie?.data?.attributes?.nombre || '***';
                        let folio = item?.attributes?.folio || '***';
                        let total = item?.attributes?.total || '***';
                        let fecha = item?.attributes?.fechaEmision || '***';

                        let Cfdis: any[] = item?.attributes?.fac_factura_doc_relacionados?.data || [];
                        //Existen documentos
                        if (Cfdis.length > 0) {
                            for (const { id, attributes } of Cfdis) {
                                let uuid = attributes?.uuid || null;
                                //Existe UUID Y Tiene formato correcto
                                if (this.notNullOrEmpty(uuid) && this.isUUID(uuid)) {
                                    //existe en lista
                                    const index = this.contenedorCfdiRelacionados.findIndex(x => x && x.cfdiRelacionados === uuid);
                                    if (index === -1) {
                                        ArrayCfdis.push({ comprobante, serie, folio, total, fecha, uuid });
                                    }

                                }

                            }//fin for second

                        }
                    }//fin for primary

                    if (ArrayCfdis.length > 0) {
                        dataModal.data = ArrayCfdis;
                        this.showModalCfdiRelacionados(dataModal);
                    } else {
                        return this._snackBar.open('No se encontraron CDFI para relacionar', 'OK', { duration: 3000 });
                    }
                }
                else {
                    this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null)
                    // // this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue([]);
                    return this._snackBar.open('No se encontraron CDFI para relacionar', 'OK', { duration: 3000 });
                };
            };
        }, (error: any) => {
            this.store.dispatch(OcultarSpinner());
            this.facturaAdicionalesForm.controls.cFDIRelacionado.setValue(null);
            return this._snackBar.open('Error al traer los CFDI relacionados', 'OK', { duration: 3000 });
        });
    }

    //new CFDI Realcionados Modal
    showModalCfdiRelacionados(data) {

        const dialogCfdiRel = this.dialog.open(DialogCfdiRelacionadosComponent, {
            width: '90%',
            data: data
        });
        dialogCfdiRel.afterClosed().subscribe(result => {
            //console.log("🚀 ~ dialogCfdiRel.afterClosed ~ result:", result)
            let data: any[] = result?.data || [];
            if (result.success == 1 && data.length > 0) {
                //Set array
                for (const { uuid } of data) {
                    if (uuid) {
                        const index = this.contenedorCfdiRelacionados.findIndex(x => x && x.cfdiRelacionados === uuid);
                        if (index === -1) {
                            this.contenedorCfdiRelacionados.push({ cfdiRelacionados: uuid })
                        } else {
                            this.contenedorCfdiRelacionados[index] = { cfdiRelacionados: uuid };
                        }
                    }
                }


            }
        });
    }
    // Validation object
    notNullOrEmpty(obj: any): boolean {
        return obj !== undefined && obj !== null && obj !== '';
    }

}
